/* tslint:disable */
/* eslint-disable */
/**
 * Forecast-planning user API
 * components はアルファベット順で記述<br /> components.schemas は各機能限定的でなく汎用的なオブジェクトは上に記述、各機能限定的なオブジェクトはpathsの定義順で記述（尚、被参照オブジェクトは参照される前に定義）
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { ApiUtility } from '@codequality/vue-cli-base';
import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AllOf
 */
export interface AllOf {
    /**
     * 
     * @type {string}
     * @memberof AllOf
     */
    'c事業所住所'?: string;
    /**
     * 
     * @type {string}
     * @memberof AllOf
     */
    'c事業所電話番号'?: string;
    /**
     * 
     * @type {string}
     * @memberof AllOf
     */
    'c事業所代表者名'?: string;
    /**
     * 
     * @type {string}
     * @memberof AllOf
     */
    'c担当者名'?: string;
    /**
     * 
     * @type {string}
     * @memberof AllOf
     */
    'c担当者メールアドレス'?: string;
    /**
     * 
     * @type {string}
     * @memberof AllOf
     */
    'c担当者パスワード'?: string;
    /**
     * 
     * @type {number}
     * @memberof AllOf
     */
    'c計画作成期間': number;
    /**
     * 
     * @type {number}
     * @memberof AllOf
     */
    'c計画0期の決算期': number;
    /**
     * 
     * @type {E消費税区分}
     * @memberof AllOf
     */
    'c消費税区分': E消費税区分;
    /**
     * 
     * @type {number}
     * @memberof AllOf
     */
    'c消費税率': number;
    /**
     * 
     * @type {E課税方式}
     * @memberof AllOf
     */
    'c課税方式': E課税方式;
    /**
     * 
     * @type {E経理方式}
     * @memberof AllOf
     */
    'c経理方式': E経理方式;
    /**
     * 
     * @type {number}
     * @memberof AllOf
     */
    'c簡易課税事業区分': number;
    /**
     * 
     * @type {E端数処理}
     * @memberof AllOf
     */
    'c消費税端数処理': E端数処理;
    /**
     * 
     * @type {E端数処理}
     * @memberof AllOf
     */
    'c減価償却費端数処理': E端数処理;
    /**
     * 
     * @type {E端数処理}
     * @memberof AllOf
     */
    'c実績値及び計画値端数処理': E端数処理;
    /**
     * 
     * @type {E製造原価科目未使用フラグ}
     * @memberof AllOf
     */
    'c製造原価科目未使用フラグ': E製造原価科目未使用フラグ;
}
/**
 * 
 * @export
 * @interface CAllOf
 */
export interface CAllOf {
    /**
     * 
     * @type {string}
     * @memberof CAllOf
     */
    '資産コード'?: string;
    /**
     * 
     * @type {string}
     * @memberof CAllOf
     */
    '名称': string;
    /**
     * 
     * @type {E償却方法}
     * @memberof CAllOf
     */
    '償却方法': E償却方法;
    /**
     * 
     * @type {number}
     * @memberof CAllOf
     */
    '数量'?: number;
    /**
     * 
     * @type {string}
     * @memberof CAllOf
     */
    '事業供用日': string;
    /**
     * 
     * @type {number}
     * @memberof CAllOf
     */
    '取得価額': number;
    /**
     * 
     * @type {number}
     * @memberof CAllOf
     */
    '耐用年数'?: number;
    /**
     * 
     * @type {number}
     * @memberof CAllOf
     */
    '前期末簿価'?: number;
    /**
     * 
     * @type {リース償却}
     * @memberof CAllOf
     */
    'リース償却'?: リース償却;
    /**
     * 
     * @type {Array<YearValue>}
     * @memberof CAllOf
     */
    '減価償却s'?: Array<YearValue>;
    /**
     * 
     * @type {number}
     * @memberof CAllOf
     */
    '部門Pk'?: number;
    /**
     * 
     * @type {number}
     * @memberof CAllOf
     */
    '販管費割合'?: number;
    /**
     * 
     * @type {string}
     * @memberof CAllOf
     */
    '備考'?: string;
}
/**
 * 
 * @export
 * @interface CBSItemAllOf
 */
export interface CBSItemAllOf {
    /**
     * 
     * @type {Cデータ実態BSValue}
     * @memberof CBSItemAllOf
     */
    '修正事項': Cデータ実態BSValue;
    /**
     * 
     * @type {Cデータ実態BSValue}
     * @memberof CBSItemAllOf
     */
    '中小企業特性の反映': Cデータ実態BSValue;
}
/**
 * 
 * @export
 * @interface CConfigItemAllOf
 */
export interface CConfigItemAllOf {
    /**
     * 
     * @type {Array<科目別計画明細Config>}
     * @memberof CConfigItemAllOf
     */
    'configs': Array<科目別計画明細Config>;
}
/**
 * 
 * @export
 * @interface CPlbscfItemAllOf
 */
export interface CPlbscfItemAllOf {
    /**
     * 計算コード(Nxx)
     * @type {string}
     * @memberof CPlbscfItemAllOf
     */
    '計算Code'?: string;
}
/**
 * 
 * @export
 * @interface CPlbscfItemCommonAllOf
 */
export interface CPlbscfItemCommonAllOf {
    /**
     * 指定年の入力値 or 計算値
     * @type {number}
     * @memberof CPlbscfItemCommonAllOf
     */
    'value': number;
    /**
     * 指定年(損益計算書)の入力値 or 計算値
     * @type {number}
     * @memberof CPlbscfItemCommonAllOf
     */
    'yValue'?: number;
}
/**
 * 
 * @export
 * @interface CommonAllOf
 */
export interface CommonAllOf {
    /**
     * 
     * @type {number}
     * @memberof CommonAllOf
     */
    'cライセンス番号': number;
}
/**
 * 
 * @export
 * @interface ConfigAllOf
 */
export interface ConfigAllOf {
    /**
     * 
     * @type {E科目別計画明細ConfigType}
     * @memberof ConfigAllOf
     */
    'type': E科目別計画明細ConfigType;
    /**
     * 
     * @type {string}
     * @memberof ConfigAllOf
     */
    'label': string;
    /**
     * type = 1 の場合は必須
     * @type {number}
     * @memberof ConfigAllOf
     */
    'fixedValue'?: number;
    /**
     * 
     * @type {科目別計画明細Formula}
     * @memberof ConfigAllOf
     */
    'formula'?: 科目別計画明細Formula;
    /**
     * 表示要否<br /> 但し、科目別計画明細No.1, 2, 10 は本値に関わらず必ず表示<br /> また、紐付くCデータPlbscfItemは、本値に関わらず各種計算に利用
     * @type {boolean}
     * @memberof ConfigAllOf
     */
    'isVisible'?: boolean;
}
/**
 * 
 * @export
 * @interface CデータPlbscfItem
 */
export interface CデータPlbscfItem {
    /**
     * 
     * @type {number}
     * @memberof CデータPlbscfItem
     */
    '勘定科目Pk'?: number;
    /**
     * 指定年の入力値 or 計算値
     * @type {number}
     * @memberof CデータPlbscfItem
     */
    'value': number;
    /**
     * 指定年(損益計算書)の入力値 or 計算値
     * @type {number}
     * @memberof CデータPlbscfItem
     */
    'yValue'?: number;
    /**
     * 一か月毎の入力値 or 計算値
     * @type {Array<number>}
     * @memberof CデータPlbscfItem
     */
    'monthlyValues'?: Array<number>;
    /**
     * 一か月毎の古い入力値 or 古い計算値
     * @type {Array<number>}
     * @memberof CデータPlbscfItem
     */
    'oldMonthlyValues'?: Array<number>;
    /**
     * t計画書データ.c計画0期の決算期以降のデータでは必須、取込時は10固定
     * @type {number}
     * @memberof CデータPlbscfItem
     */
    '科目別計画明細No'?: number;
    /**
     * 計算コード(Nxx)
     * @type {string}
     * @memberof CデータPlbscfItem
     */
    '計算Code'?: string;
}
/**
 * 
 * @export
 * @interface CデータPlbscfItemCommon
 */
export interface CデータPlbscfItemCommon {
    /**
     * 
     * @type {number}
     * @memberof CデータPlbscfItemCommon
     */
    '勘定科目Pk'?: number;
    /**
     * 指定年の入力値 or 計算値
     * @type {number}
     * @memberof CデータPlbscfItemCommon
     */
    'value': number;
    /**
     * 指定年(損益計算書)の入力値 or 計算値
     * @type {number}
     * @memberof CデータPlbscfItemCommon
     */
    'yValue'?: number;
    /**
     * 一か月毎の入力値 or 計算値
     * @type {Array<number>}
     * @memberof CデータPlbscfItemCommon
     */
    'monthlyValues'?: Array<number>;
    /**
     * 一か月毎の古い入力値 or 古い計算値
     * @type {Array<number>}
     * @memberof CデータPlbscfItemCommon
     */
    'oldMonthlyValues'?: Array<number>;
}
/**
 * 
 * @export
 * @interface Cデータ保有不動産
 */
export interface Cデータ保有不動産 {
    /**
     * 
     * @type {E不動産種類}
     * @memberof Cデータ保有不動産
     */
    '種類': E不動産種類;
    /**
     * 
     * @type {string}
     * @memberof Cデータ保有不動産
     */
    '所在'?: string;
    /**
     * 
     * @type {string}
     * @memberof Cデータ保有不動産
     */
    '地番'?: string;
    /**
     * 
     * @type {string}
     * @memberof Cデータ保有不動産
     */
    '名義'?: string;
    /**
     * 
     * @type {string}
     * @memberof Cデータ保有不動産
     */
    '地目構造'?: string;
    /**
     * 
     * @type {string}
     * @memberof Cデータ保有不動産
     */
    '地籍床面積'?: string;
    /**
     * 
     * @type {string}
     * @memberof Cデータ保有不動産
     */
    '取得日'?: string;
    /**
     * 
     * @type {string}
     * @memberof Cデータ保有不動産
     */
    '備考'?: string;
    /**
     * 
     * @type {不動産価格}
     * @memberof Cデータ保有不動産
     */
    '簿価'?: 不動産価格;
    /**
     * 
     * @type {不動産価格}
     * @memberof Cデータ保有不動産
     */
    '評価額'?: 不動産価格;
}
/**
 * 
 * @export
 * @interface Cデータ償却
 */
export interface Cデータ償却 {
    /**
     * 
     * @type {number}
     * @memberof Cデータ償却
     */
    '勘定科目Pk'?: number;
    /**
     * 
     * @type {string}
     * @memberof Cデータ償却
     */
    '資産コード'?: string;
    /**
     * 
     * @type {string}
     * @memberof Cデータ償却
     */
    '名称': string;
    /**
     * 
     * @type {E償却方法}
     * @memberof Cデータ償却
     */
    '償却方法': E償却方法;
    /**
     * 
     * @type {number}
     * @memberof Cデータ償却
     */
    '数量'?: number;
    /**
     * 
     * @type {string}
     * @memberof Cデータ償却
     */
    '事業供用日': string;
    /**
     * 
     * @type {number}
     * @memberof Cデータ償却
     */
    '取得価額': number;
    /**
     * 
     * @type {number}
     * @memberof Cデータ償却
     */
    '耐用年数'?: number;
    /**
     * 
     * @type {number}
     * @memberof Cデータ償却
     */
    '前期末簿価'?: number;
    /**
     * 
     * @type {リース償却}
     * @memberof Cデータ償却
     */
    'リース償却'?: リース償却;
    /**
     * 
     * @type {Array<YearValue>}
     * @memberof Cデータ償却
     */
    '減価償却s'?: Array<YearValue>;
    /**
     * 
     * @type {number}
     * @memberof Cデータ償却
     */
    '部門Pk'?: number;
    /**
     * 
     * @type {number}
     * @memberof Cデータ償却
     */
    '販管費割合'?: number;
    /**
     * 
     * @type {string}
     * @memberof Cデータ償却
     */
    '備考'?: string;
}
/**
 * 
 * @export
 * @interface Cデータ実態BSItem
 */
export interface Cデータ実態BSItem {
    /**
     * 
     * @type {number}
     * @memberof Cデータ実態BSItem
     */
    '勘定科目Pk'?: number;
    /**
     * 
     * @type {Cデータ実態BSValue}
     * @memberof Cデータ実態BSItem
     */
    '修正事項': Cデータ実態BSValue;
    /**
     * 
     * @type {Cデータ実態BSValue}
     * @memberof Cデータ実態BSItem
     */
    '中小企業特性の反映': Cデータ実態BSValue;
}
/**
 * 
 * @export
 * @interface Cデータ実態BSValue
 */
export interface Cデータ実態BSValue {
    /**
     * 
     * @type {string}
     * @memberof Cデータ実態BSValue
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof Cデータ実態BSValue
     */
    'value': number;
}
/**
 * 
 * @export
 * @interface Cデータ実態純資産
 */
export interface Cデータ実態純資産 {
    /**
     * 
     * @type {string}
     * @memberof Cデータ実態純資産
     */
    'label': string;
    /**
     * 
     * @type {Array<number>}
     * @memberof Cデータ実態純資産
     */
    'values': Array<number>;
}
/**
 * 
 * @export
 * @interface Cデータ役員借入
 */
export interface Cデータ役員借入 {
    /**
     * 
     * @type {string}
     * @memberof Cデータ役員借入
     */
    '役員名'?: string;
    /**
     * 
     * @type {number}
     * @memberof Cデータ役員借入
     */
    '前期末残高'?: number;
    /**
     * 
     * @type {number}
     * @memberof Cデータ役員借入
     */
    '元本返済額月'?: number;
    /**
     * 
     * @type {string}
     * @memberof Cデータ役員借入
     */
    '返済開始時期'?: string;
    /**
     * 
     * @type {number}
     * @memberof Cデータ役員借入
     */
    '金利'?: number;
    /**
     * 
     * @type {number}
     * @memberof Cデータ役員借入
     */
    '直近月残高'?: number;
    /**
     * 
     * @type {string}
     * @memberof Cデータ役員借入
     */
    '備考'?: string;
    /**
     * 
     * @type {Array<YearMonthValue>}
     * @memberof Cデータ役員借入
     */
    '新規借入'?: Array<YearMonthValue>;
    /**
     * 
     * @type {Array<YearMonthValue>}
     * @memberof Cデータ役員借入
     */
    '元本返済': Array<YearMonthValue>;
    /**
     * 
     * @type {Array<YearMonthValue>}
     * @memberof Cデータ役員借入
     */
    '利息': Array<YearMonthValue>;
}
/**
 * 
 * @export
 * @interface Cデータ科目別計画ConfigItem
 */
export interface Cデータ科目別計画ConfigItem {
    /**
     * 
     * @type {number}
     * @memberof Cデータ科目別計画ConfigItem
     */
    '勘定科目Pk': number;
    /**
     * 
     * @type {Array<科目別計画明細Config>}
     * @memberof Cデータ科目別計画ConfigItem
     */
    'configs': Array<科目別計画明細Config>;
}
/**
 * 
 * @export
 * @interface Cデータ納税予測
 */
export interface Cデータ納税予測 {
    /**
     * 
     * @type {Array<法人税Label>}
     * @memberof Cデータ納税予測
     */
    '法人税Labels': Array<法人税Label>;
    /**
     * 
     * @type {Array<納税YearValue>}
     * @memberof Cデータ納税予測
     */
    'yearValues': Array<納税YearValue>;
}
/**
 * 
 * @export
 * @interface Cデータ資金繰り
 */
export interface Cデータ資金繰り {
    /**
     * 
     * @type {Array<資金繰りMonthlyValue>}
     * @memberof Cデータ資金繰り
     */
    'monthlyValues': Array<資金繰りMonthlyValue>;
    /**
     * 
     * @type {資金繰りConfig}
     * @memberof Cデータ資金繰り
     */
    'config': 資金繰りConfig;
}
/**
 * 
 * @export
 * @interface Cデータ返済計画
 */
export interface Cデータ返済計画 {
    /**
     * 
     * @type {Array<string>}
     * @memberof Cデータ返済計画
     */
    '返済原資Labels': Array<string>;
    /**
     * t事業所.c計画作成期間に連動し0期～10期の返済計画を保持する
     * @type {Array<返済計画YearlyValue>}
     * @memberof Cデータ返済計画
     */
    'yearlyValues': Array<返済計画YearlyValue>;
    /**
     * 
     * @type {string}
     * @memberof Cデータ返済計画
     */
    'リスケ開始時期'?: string;
    /**
     * 
     * @type {string}
     * @memberof Cデータ返済計画
     */
    '返済開始時期'?: string;
}
/**
 * 
 * @export
 * @interface Cデータ金融機関借入
 */
export interface Cデータ金融機関借入 {
    /**
     * 
     * @type {string}
     * @memberof Cデータ金融機関借入
     */
    '金融機関'?: string;
    /**
     * 
     * @type {E金融借入種別}
     * @memberof Cデータ金融機関借入
     */
    '種別': E金融借入種別;
    /**
     * 
     * @type {E金融借入科目}
     * @memberof Cデータ金融機関借入
     */
    '科目': E金融借入科目;
    /**
     * 
     * @type {number}
     * @memberof Cデータ金融機関借入
     */
    '借入金額'?: number;
    /**
     * 
     * @type {E金融借入返済方法}
     * @memberof Cデータ金融機関借入
     */
    '返済方法': E金融借入返済方法;
    /**
     * 
     * @type {string}
     * @memberof Cデータ金融機関借入
     */
    '実行日'?: string;
    /**
     * 
     * @type {string}
     * @memberof Cデータ金融機関借入
     */
    '返済期日'?: string;
    /**
     * 
     * @type {string}
     * @memberof Cデータ金融機関借入
     */
    '元本返済開始日'?: string;
    /**
     * 
     * @type {number}
     * @memberof Cデータ金融機関借入
     */
    '返済回数'?: number;
    /**
     * 
     * @type {number}
     * @memberof Cデータ金融機関借入
     */
    '初回元本返済額'?: number;
    /**
     * 
     * @type {number}
     * @memberof Cデータ金融機関借入
     */
    '二回目以降元本返済額'?: number;
    /**
     * 
     * @type {number}
     * @memberof Cデータ金融機関借入
     */
    '最終回元本返済額'?: number;
    /**
     * 
     * @type {number}
     * @memberof Cデータ金融機関借入
     */
    '当初金利'?: number;
    /**
     * 
     * @type {number}
     * @memberof Cデータ金融機関借入
     */
    '前期末残高'?: number;
    /**
     * 
     * @type {number}
     * @memberof Cデータ金融機関借入
     */
    '直近月残高'?: number;
    /**
     * 
     * @type {string}
     * @memberof Cデータ金融機関借入
     */
    '信用保証協会付': string;
    /**
     * 
     * @type {string}
     * @memberof Cデータ金融機関借入
     */
    '保証人'?: string;
    /**
     * 
     * @type {string}
     * @memberof Cデータ金融機関借入
     */
    '備考'?: string;
    /**
     * 自動計算値は保存しない。
     * @type {Array<YearMonthValue>}
     * @memberof Cデータ金融機関借入
     */
    '返済額': Array<YearMonthValue>;
    /**
     * 
     * @type {Array<YearMonthValue>}
     * @memberof Cデータ金融機関借入
     */
    '新規借入'?: Array<YearMonthValue>;
    /**
     * 
     * @type {Array<YearMonthValue>}
     * @memberof Cデータ金融機関借入
     */
    '元本返済': Array<YearMonthValue>;
    /**
     * 
     * @type {Array<YearMonthValue>}
     * @memberof Cデータ金融機関借入
     */
    '利息': Array<YearMonthValue>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum E0円非表示フラグ {
    表示 = 0,
    非表示 = 1
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum ECF集計項目 {
    貸倒引当金 = '貸倒引当金',
    売上債権 = '売上債権',
    棚卸資産 = '棚卸資産',
    繰延資産 = '繰延資産',
    仕入債務 = '仕入債務',
    その他の流動資産 = 'その他の流動資産',
    その他の流動負債 = 'その他の流動負債',
    未払法人税等 = '未払法人税等',
    当期発生法人税等 = '当期発生法人税等',
    有価証券 = '有価証券',
    有形固定資産 = '有形固定資産',
    無形固定資産 = '無形固定資産',
    減価償却費 = '減価償却費',
    特別利益調整 = '特別利益調整',
    特別損失調整 = '特別損失調整',
    投資その他の資産 = '投資その他の資産',
    貸付金 = '貸付金',
    短期借入金 = '短期借入金',
    長期借入金 = '長期借入金',
    社債 = '社債',
    その他の固定負債 = 'その他の固定負債',
    資本金 = '資本金',
    自己株式 = '自己株式',
    配当金の支払額 = '配当金の支払額',
    受取利息及び受取配当金 = '受取利息及び受取配当金',
    支払利息等 = '支払利息等'
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum EOperator {
    addition = '+',
    subtraction = '-',
    multiplication = '×',
    division = '÷'
}


/**
 * エラーレスポンス
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * 
     * @type {HttpStatusCode}
     * @memberof ErrorResponse
     */
    'status': HttpStatusCode;
    /**
     * APIパス
     * @type {string}
     * @memberof ErrorResponse
     */
    'path': string;
    /**
     * 発生日時
     * @type {string}
     * @memberof ErrorResponse
     */
    'timestamp': string;
    /**
     * エラー概要
     * @type {string}
     * @memberof ErrorResponse
     */
    'error': string;
    /**
     * エラー概要
     * @type {string}
     * @memberof ErrorResponse
     */
    'message': string;
    /**
     * エラー詳細
     * @type {string}
     * @memberof ErrorResponse
     */
    'trace'?: string;
    /**
     * 例外クラス
     * @type {string}
     * @memberof ErrorResponse
     */
    'exception'?: string;
    /**
     * 入力エラー内容(status=400 の場合のみ)
     * @type {Array<FieldErrorResponse>}
     * @memberof ErrorResponse
     */
    'errors'?: Array<FieldErrorResponse>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum Eフェーズ種別 {
    分析フェーズ = 0,
    計画フェーズ = 1,
    モニタリングフェーズ = 2
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum Eフリーキャッシュフロー種別 {
    通常 = 0,
    CF計算書 = 1
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum Eユーザー権限 {
    ユーザー = 0,
    管理者 = 1,
    担当者 = 2
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum E不動産種類 {
    土地 = '土地',
    建物 = '建物',
    借地権 = '借地権'
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum E借入金条件 {
    入金短期 = '借入金入金（短期借入金）',
    入金長期 = '借入金入金（長期借入金）',
    入金役員 = '借入金入金（役員借入金）',
    返済短期 = '借入金返済（短期借入金）',
    返済長期 = '借入金返済（長期借入金）',
    返済役員 = '借入金返済（役員借入金）'
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum E償却方法 {
    定額法 = '定額法',
    旧定額法 = '旧定額法',
    旧定率法 = '旧定率法',
    定率法250pct = '250%定率法',
    定率法200pct = '200%定率法',
    リース期間定額法 = 'リース期間定額法',
    定額法無形固定資産 = '定額法（無形固定資産）',
    一括償却資産 = '一括償却資産',
    任意償却 = '任意償却'
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum E入力分類 {
    PLBSCF = 0,
    金融機関借入 = 1,
    役員借入 = 2,
    法人保有不動産 = 3,
    償却 = 4,
    実態BS = 5,
    科目別計画設定 = 6,
    返済計画 = 7,
    納税予測 = 8,
    資金繰り = 9,
    実態純資産 = 10,
    個人保有不動産 = 11,
    モニタリングPLBSCF = 12,
    OLDLOAN = 13,
    YEARCONFIG = 14
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum E分析非表示フラグ {
    表示 = 0,
    非表示 = 1
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum E勘定科目カテゴリ {
    貸借 = 0,
    損益 = 1,
    製造原価 = 2
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum E千円表示フラグ {
    円 = 0,
    千円 = 1
}


/**
 * -1:取込なし　はリクエストでのみ使用
 * @export
 * @enum {string}
 */

export enum E取込データ種別 {
    取込なし = -1,
    貸借対照表勘定式 = 0,
    貸借対照表報告式 = 1,
    損益計算書 = 2,
    販売費および一般管理費内訳書 = 3,
    製造原価報告書 = 4,
    固定資産台帳 = 5,
    月次貸借対照表 = 6,
    月次損益計算書 = 7,
    月次製造原価報告書 = 8,
    年次貸借対照表 = 9,
    年次損益計算書 = 10,
    年次製造原価報告書 = 11
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum E取込分類 {
    決算書 = 0,
    固定資産台帳 = 1,
    月次貸借対照表 = 2,
    月次損益計算書_月次製造原価報告書 = 3,
    実績月次貸借対照表 = 4,
    実績月次損益計算書_実績月次製造原価報告書 = 5,
    三表計画月次貸借対照表 = 6,
    三表計画月次損益計算書_三表計画月次製造原価報告書 = 7,
    三表計画年次貸借対照表 = 8,
    三表計画年次損益計算書_三表計画年次製造原価報告書 = 9
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum E取込形式 {
    pdf = 0,
    xlsx = 1
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum E回収支払条件 {
    回収0 = '当月回収',
    回収1 = '翌月回収',
    回収2 = '翌々月回収',
    回収3 = '3か月後回収',
    回収4 = '4か月後回収',
    回収5 = '5か月後回収',
    回収6 = '6か月後回収',
    支払0 = '当月支払',
    支払1 = '翌月支払',
    支払2 = '翌々月支払',
    支払3 = '3か月後支払',
    支払4 = '4か月後支払',
    支払5 = '5か月後支払',
    支払6 = '6か月後支払'
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum E固変区分 {
    固定費 = '固定費',
    変動費 = '変動費',
    棚卸増減 = '棚卸増減'
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum E帳票種別 {
    pdf = 'pdf',
    xlsx = 'xlsx'
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum E有無フラグ {
    なし = 0,
    あり = 1
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum E消費税区分 {
    免税事業者 = 0,
    課税事業者 = 1
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum E科目別計画明細ConfigType {
    直接入力 = 0,
    固定値 = 1,
    計算式 = 2,
    前年値月平均 = 3,
    前年同月値 = 4,
    前年値 = 5,
    科目選択 = 6
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum E税区分 {
    課税売上 = '課税売上',
    課税売上返還 = '課税売上返還',
    輸出売上 = '輸出売上',
    輸出売上返還 = '輸出売上返還',
    その他売上 = 'その他売上',
    課税仕入 = '課税仕入',
    課税仕入返還 = '課税仕入返還',
    その他仕入 = 'その他仕入',
    対象外 = '対象外'
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum E端数処理 {
    切上げ = 0,
    切捨て = 1,
    四捨五入 = 2
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum E経理方式 {
    税抜経理 = 0,
    税込経理 = 1
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum E補助科目フラグ {
    通常 = 0,
    補助 = 1
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum E製造原価科目未使用フラグ {
    使用する = 0,
    使用しない = 1
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum E計画表示モード {
    月次計画第0期 = 0,
    月次計画第1期 = 1,
    年次計画 = 2
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum E課税方式 {
    本則課税 = 0,
    簡易課税 = 1
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum E資金繰りType {
    営業収入 = '営業収入',
    営業外収入 = '営業外収入',
    営業支出 = '営業支出',
    営業外支出 = '営業外支出',
    財務収入 = '財務収入',
    財務支出 = '財務支出'
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum E金融借入科目 {
    短期借入金 = '短期借入金',
    長期借入金 = '長期借入金'
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum E金融借入種別 {
    証書貸付 = '証書貸付',
    手形貸付 = '手形貸付',
    手形割引 = '手形割引',
    当座貸越 = '当座貸越',
    その他 = 'その他'
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum E金融借入返済方法 {
    元金均等 = '元金均等',
    元利均等 = '元利均等',
    その他 = 'その他'
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum E集計転記科目 {
    現金及び預金 = '現金及び預金',
    売上債権 = '売上債権',
    棚卸資産 = '棚卸資産',
    建物 = '建物',
    建物附属設備 = '建物附属設備',
    建物付属設備 = '建物付属設備',
    設備造作 = '設備造作',
    構築物 = '構築物',
    機械装置 = '機械装置',
    車両運搬具 = '車両運搬具',
    工具器具備品 = '工具器具備品',
    什器備品 = '什器備品',
    リース資産 = 'リース資産',
    一括償却資産 = '一括償却資産',
    減価償却累計額 = '減価償却累計額',
    土地 = '土地',
    電話加入権 = '電話加入権',
    借地権 = '借地権',
    ソフトウェア = 'ソフトウェア',
    投資有価証券 = '投資有価証券',
    関係会社株式 = '関係会社株式',
    敷金 = '敷金',
    差入保証金 = '差入保証金',
    保証金 = '保証金',
    保険積立金 = '保険積立金',
    配当金積立金 = '配当金積立金',
    長期前払費用 = '長期前払費用',
    長期貸付金 = '長期貸付金',
    預託金 = '預託金',
    出資金 = '出資金',
    リサイクル預託金 = 'リサイクル預託金',
    会員権 = '会員権',
    貸倒引当金投 = '貸倒引当金(投)',
    創立費 = '創立費',
    開業費 = '開業費',
    開発費 = '開発費',
    仕入債務 = '仕入債務',
    有利子負債短期借入金 = '有利子負債（短期借入金）',
    有利子負債長期借入金 = '有利子負債（長期借入金）',
    役員借入金 = '役員借入金',
    減価償却費販管費 = '減価償却費（販管費）',
    減価償却費製造原価 = '減価償却費（製造原価）',
    支払利息 = '支払利息',
    当期純利益 = '当期純利益',
    法人税等 = '法人税等',
    未払法人税等 = '未払法人税等',
    未払消費税等 = '未払消費税等',
    期末商品棚卸高 = '期末商品棚卸高',
    期末製品棚卸高 = '期末製品棚卸高',
    期末材料棚卸高 = '期末材料棚卸高',
    期末仕掛品棚卸高 = '期末仕掛品棚卸高',
    棚卸資産PL期末商品 = '棚卸資産（PL期末商品）',
    棚卸資産PL期末製品 = '棚卸資産（PL期末製品）',
    棚卸資産CR期末材料 = '棚卸資産（CR期末材料）',
    棚卸資産CR期末仕掛品 = '棚卸資産（CR期末仕掛品）'
}


/**
 * 入力フィールドエラー
 * @export
 * @interface FieldErrorResponse
 */
export interface FieldErrorResponse {
    /**
     * 入力フィールド
     * @type {string}
     * @memberof FieldErrorResponse
     */
    'field': string;
    /**
     * 入力オブジェクト
     * @type {string}
     * @memberof FieldErrorResponse
     */
    'objectName': string;
    /**
     * エラー内容
     * @type {string}
     * @memberof FieldErrorResponse
     */
    'defaultMessage': string;
}
/**
 * ファイル入力
 * @export
 * @interface FileRequest
 */
export interface FileRequest {
    /**
     * ファイルオブジェクト
     * @type {any}
     * @memberof FileRequest
     */
    'file': any;
}
/**
 * HTTPステータスコード
 * @export
 * @enum {string}
 */

export enum HttpStatusCode {
    badRequest = 400,
    unauthorized = 401,
    forbidden = 403,
    notFound = 404,
    requestTimeout = 408,
    internalServerError = 500
}


/**
 * 
 * @export
 * @interface ListItemResponseAllOf
 */
export interface ListItemResponseAllOf {
    /**
     * 
     * @type {number}
     * @memberof ListItemResponseAllOf
     */
    'c計画0期の決算期': number;
}
/**
 * 
 * @export
 * @interface ListItemResponseAllOf1
 */
export interface ListItemResponseAllOf1 {
    /**
     * 
     * @type {string}
     * @memberof ListItemResponseAllOf1
     */
    'c最終ログイン日時'?: string;
}
/**
 * 認証情報
 * @export
 * @interface LoginRequest
 */
export interface LoginRequest {
    /**
     * 
     * @type {string}
     * @memberof LoginRequest
     */
    'cユーザーメールアドレス': string;
    /**
     * 
     * @type {string}
     * @memberof LoginRequest
     */
    'cユーザーパスワード': string;
}
/**
 * 
 * @export
 * @interface MeResponseAllOf
 */
export interface MeResponseAllOf {
    /**
     * 
     * @type {string}
     * @memberof MeResponseAllOf
     */
    'c企業名': string;
    /**
     * 
     * @type {number}
     * @memberof MeResponseAllOf
     */
    'cライセンス数': number;
    /**
     * 
     * @type {number}
     * @memberof MeResponseAllOf
     */
    'c事業所pk'?: number;
}
/**
 * 
 * @export
 * @interface MonthlyValues
 */
export interface MonthlyValues {
    /**
     * 一か月毎の入力値 or 計算値
     * @type {Array<number>}
     * @memberof MonthlyValues
     */
    'monthlyValues'?: Array<number>;
}
/**
 * 
 * @export
 * @interface OldMonthlyValues
 */
export interface OldMonthlyValues {
    /**
     * 一か月毎の古い入力値 or 古い計算値
     * @type {Array<number>}
     * @memberof OldMonthlyValues
     */
    'oldMonthlyValues'?: Array<number>;
}
/**
 * 
 * @export
 * @interface PasswordResetRequest
 */
export interface PasswordResetRequest {
    /**
     * パスワード再設定用トークン
     * @type {string}
     * @memberof PasswordResetRequest
     */
    'jwt': string;
    /**
     * 
     * @type {string}
     * @memberof PasswordResetRequest
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof PasswordResetRequest
     */
    'passwordConfirm': string;
}
/**
 * 
 * @export
 * @interface PasswordResetRequestAllOf
 */
export interface PasswordResetRequestAllOf {
    /**
     * パスワード再設定用トークン
     * @type {string}
     * @memberof PasswordResetRequestAllOf
     */
    'jwt': string;
    /**
     * 
     * @type {string}
     * @memberof PasswordResetRequestAllOf
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof PasswordResetRequestAllOf
     */
    'passwordConfirm': string;
}
/**
 * 
 * @export
 * @interface PdfListItemRequestAllOf
 */
export interface PdfListItemRequestAllOf {
    /**
     * 
     * @type {Array<string>}
     * @memberof PdfListItemRequestAllOf
     */
    'values'?: Array<string>;
}
/**
 * 
 * @export
 * @interface PdfPlbscfListItemRequestAllOf
 */
export interface PdfPlbscfListItemRequestAllOf {
    /**
     * 
     * @type {取込勘定科目Request}
     * @memberof PdfPlbscfListItemRequestAllOf
     */
    '取込勘定科目'?: 取込勘定科目Request;
}
/**
 * 主キー
 * @export
 * @interface Pk
 */
export interface Pk {
    /**
     * 
     * @type {number}
     * @memberof Pk
     */
    'pk': number;
}
/**
 * 主キー
 * @export
 * @interface PkOptional
 */
export interface PkOptional {
    /**
     * 
     * @type {number}
     * @memberof PkOptional
     */
    'pk'?: number;
}
/**
 * 
 * @export
 * @interface PlbscfYearValueAllOf
 */
export interface PlbscfYearValueAllOf {
    /**
     * 
     * @type {number}
     * @memberof PlbscfYearValueAllOf
     */
    'year': number;
    /**
     * 
     * @type {number}
     * @memberof PlbscfYearValueAllOf
     */
    'c部門pK'?: number;
    /**
     * 計画0, 1期の場合はmonthlyValuesは必須
     * @type {Array<CデータPlbscfItemCommon>}
     * @memberof PlbscfYearValueAllOf
     */
    'values': Array<CデータPlbscfItemCommon>;
}
/**
 * 
 * @export
 * @interface PlbscfデータRequest
 */
export interface PlbscfデータRequest {
    /**
     * 
     * @type {Eフェーズ種別}
     * @memberof PlbscfデータRequest
     */
    'cフェーズ種別': Eフェーズ種別;
    /**
     * 
     * @type {Array<PlbscfデータYearValue>}
     * @memberof PlbscfデータRequest
     */
    'yearValues': Array<PlbscfデータYearValue>;
    /**
     * 
     * @type {boolean}
     * @memberof PlbscfデータRequest
     */
    'saveOldValues'?: boolean;
}
/**
 * 
 * @export
 * @interface PlbscfデータYearValue
 */
export interface PlbscfデータYearValue {
    /**
     * 
     * @type {number}
     * @memberof PlbscfデータYearValue
     */
    'year': number;
    /**
     * 
     * @type {number}
     * @memberof PlbscfデータYearValue
     */
    'c部門pK'?: number;
    /**
     * 計画0, 1期の場合はmonthlyValuesは必須
     * @type {Array<CデータPlbscfItemCommon>}
     * @memberof PlbscfデータYearValue
     */
    'values': Array<CデータPlbscfItemCommon>;
}
/**
 * 
 * @export
 * @interface ResponseAllOf
 */
export interface ResponseAllOf {
    /**
     * 
     * @type {number}
     * @memberof ResponseAllOf
     */
    'c枚数': number;
}
/**
 * 更新日時
 * @export
 * @interface UpdateDt
 */
export interface UpdateDt {
    /**
     * 
     * @type {string}
     * @memberof UpdateDt
     */
    'c更新日時': string;
}
/**
 * 
 * @export
 * @interface ValueAllOf
 */
export interface ValueAllOf {
    /**
     * 
     * @type {E資金繰りType}
     * @memberof ValueAllOf
     */
    'type': E資金繰りType;
    /**
     * 資金繰り表のE資金繰りType内行インデックス
     * @type {number}
     * @memberof ValueAllOf
     */
    'typeRowIndex': number;
}
/**
 * 
 * @export
 * @interface XlsxImportListItemResponseAllOf
 */
export interface XlsxImportListItemResponseAllOf {
    /**
     * 
     * @type {E取込データ種別}
     * @memberof XlsxImportListItemResponseAllOf
     */
    '取込データ種別': E取込データ種別;
}
/**
 * 
 * @export
 * @interface XlsxImportListItemResponseAllOf1
 */
export interface XlsxImportListItemResponseAllOf1 {
    /**
     * 
     * @type {Array<取込FileListItemResponse>}
     * @memberof XlsxImportListItemResponseAllOf1
     */
    'list': Array<取込FileListItemResponse>;
}
/**
 * 
 * @export
 * @interface YearMonthValue
 */
export interface YearMonthValue {
    /**
     * 
     * @type {number}
     * @memberof YearMonthValue
     */
    'ym': number;
    /**
     * 
     * @type {number}
     * @memberof YearMonthValue
     */
    'value': number;
}
/**
 * 
 * @export
 * @interface YearValue
 */
export interface YearValue {
    /**
     * 
     * @type {number}
     * @memberof YearValue
     */
    'year': number;
    /**
     * 
     * @type {number}
     * @memberof YearValue
     */
    'value': number;
}
/**
 * 
 * @export
 * @interface データCommon
 */
export interface データCommon {
    /**
     * 
     * @type {E入力分類}
     * @memberof データCommon
     */
    'c入力分類': E入力分類;
    /**
     * 
     * @type {number}
     * @memberof データCommon
     */
    'c番号': number;
    /**
     * 
     * @type {string}
     * @memberof データCommon
     */
    'c取り込みキー'?: string;
    /**
     * 
     * @type {number}
     * @memberof データCommon
     */
    'c部門pK'?: number;
    /**
     * 
     * @type {Eフェーズ種別}
     * @memberof データCommon
     */
    'cフェーズ種別': Eフェーズ種別;
    /**
     * 
     * @type {string}
     * @memberof データCommon
     */
    'cデータ': string;
    /**
     * 
     * @type {string}
     * @memberof データCommon
     */
    'oldLoan'?: string;
}
/**
 * 
 * @export
 * @interface データListItemRequest
 */
export interface データListItemRequest {
    /**
     * 
     * @type {number}
     * @memberof データListItemRequest
     */
    'pk'?: number;
    /**
     * 
     * @type {E入力分類}
     * @memberof データListItemRequest
     */
    'c入力分類': E入力分類;
    /**
     * 
     * @type {number}
     * @memberof データListItemRequest
     */
    'c番号': number;
    /**
     * 
     * @type {string}
     * @memberof データListItemRequest
     */
    'c取り込みキー'?: string;
    /**
     * 
     * @type {number}
     * @memberof データListItemRequest
     */
    'c部門pK'?: number;
    /**
     * 
     * @type {Eフェーズ種別}
     * @memberof データListItemRequest
     */
    'cフェーズ種別': Eフェーズ種別;
    /**
     * 
     * @type {string}
     * @memberof データListItemRequest
     */
    'cデータ': string;
    /**
     * 
     * @type {string}
     * @memberof データListItemRequest
     */
    'oldLoan'?: string;
}
/**
 * 
 * @export
 * @interface データListItemResponse
 */
export interface データListItemResponse {
    /**
     * 
     * @type {number}
     * @memberof データListItemResponse
     */
    'pk': number;
    /**
     * 
     * @type {E入力分類}
     * @memberof データListItemResponse
     */
    'c入力分類': E入力分類;
    /**
     * 
     * @type {number}
     * @memberof データListItemResponse
     */
    'c番号': number;
    /**
     * 
     * @type {string}
     * @memberof データListItemResponse
     */
    'c取り込みキー'?: string;
    /**
     * 
     * @type {number}
     * @memberof データListItemResponse
     */
    'c部門pK'?: number;
    /**
     * 
     * @type {Eフェーズ種別}
     * @memberof データListItemResponse
     */
    'cフェーズ種別': Eフェーズ種別;
    /**
     * 
     * @type {string}
     * @memberof データListItemResponse
     */
    'cデータ': string;
    /**
     * 
     * @type {string}
     * @memberof データListItemResponse
     */
    'oldLoan'?: string;
}
/**
 * 
 * @export
 * @interface データRequest
 */
export interface データRequest {
    /**
     * 
     * @type {E入力分類}
     * @memberof データRequest
     */
    'c入力分類': E入力分類;
    /**
     * 
     * @type {number}
     * @memberof データRequest
     */
    'c番号': number;
    /**
     * 
     * @type {string}
     * @memberof データRequest
     */
    'c取り込みキー'?: string;
    /**
     * 
     * @type {number}
     * @memberof データRequest
     */
    'c部門pK'?: number;
    /**
     * 
     * @type {Eフェーズ種別}
     * @memberof データRequest
     */
    'cフェーズ種別': Eフェーズ種別;
    /**
     * 
     * @type {string}
     * @memberof データRequest
     */
    'cデータ': string;
    /**
     * 
     * @type {string}
     * @memberof データRequest
     */
    'oldLoan'?: string;
}
/**
 * 
 * @export
 * @interface モニタリング会計期間
 */
export interface モニタリング会計期間 {
    /**
     * 
     * @type {number}
     * @memberof モニタリング会計期間
     */
    'cモニタリング会計期間'?: number;
}
/**
 * 
 * @export
 * @interface モニタリング会計期間Request
 */
export interface モニタリング会計期間Request {
    /**
     * 
     * @type {number}
     * @memberof モニタリング会計期間Request
     */
    'cモニタリング会計期間': number;
}
/**
 * 
 * @export
 * @interface ユーザーCommon
 */
export interface ユーザーCommon {
    /**
     * 
     * @type {string}
     * @memberof ユーザーCommon
     */
    'cユーザーパスワード'?: string;
    /**
     * 
     * @type {number}
     * @memberof ユーザーCommon
     */
    'cライセンス番号': number;
}
/**
 * 
 * @export
 * @interface ユーザーListItemResponse
 */
export interface ユーザーListItemResponse {
    /**
     * 
     * @type {number}
     * @memberof ユーザーListItemResponse
     */
    'pk': number;
    /**
     * 
     * @type {string}
     * @memberof ユーザーListItemResponse
     */
    'cユーザーメールアドレス': string;
    /**
     * 
     * @type {string}
     * @memberof ユーザーListItemResponse
     */
    'cユーザーパスワード'?: string;
    /**
     * 
     * @type {number}
     * @memberof ユーザーListItemResponse
     */
    'cライセンス番号': number;
    /**
     * 
     * @type {string}
     * @memberof ユーザーListItemResponse
     */
    'cユーザー名'?: string;
    /**
     * 
     * @type {Eユーザー権限}
     * @memberof ユーザーListItemResponse
     */
    'cユーザー権限': Eユーザー権限;
    /**
     * 
     * @type {string}
     * @memberof ユーザーListItemResponse
     */
    'c最終ログイン日時'?: string;
}
/**
 * 
 * @export
 * @interface ユーザーMeResponse
 */
export interface ユーザーMeResponse {
    /**
     * 
     * @type {string}
     * @memberof ユーザーMeResponse
     */
    'cユーザー名'?: string;
    /**
     * 
     * @type {Eユーザー権限}
     * @memberof ユーザーMeResponse
     */
    'cユーザー権限': Eユーザー権限;
    /**
     * 
     * @type {string}
     * @memberof ユーザーMeResponse
     */
    'c企業名': string;
    /**
     * 
     * @type {number}
     * @memberof ユーザーMeResponse
     */
    'cライセンス数': number;
    /**
     * 
     * @type {number}
     * @memberof ユーザーMeResponse
     */
    'c事業所pk'?: number;
}
/**
 * 
 * @export
 * @interface ユーザーRequest
 */
export interface ユーザーRequest {
    /**
     * 
     * @type {string}
     * @memberof ユーザーRequest
     */
    'cユーザーメールアドレス': string;
    /**
     * 
     * @type {string}
     * @memberof ユーザーRequest
     */
    'cユーザーパスワード'?: string;
    /**
     * 
     * @type {number}
     * @memberof ユーザーRequest
     */
    'cライセンス番号': number;
    /**
     * 
     * @type {string}
     * @memberof ユーザーRequest
     */
    'cユーザー名'?: string;
}
/**
 * 
 * @export
 * @interface ユーザーパスワード
 */
export interface ユーザーパスワード {
    /**
     * 
     * @type {string}
     * @memberof ユーザーパスワード
     */
    'cユーザーパスワード'?: string;
}
/**
 * 
 * @export
 * @interface ユーザーメールアドレス
 */
export interface ユーザーメールアドレス {
    /**
     * 
     * @type {string}
     * @memberof ユーザーメールアドレス
     */
    'cユーザーメールアドレス': string;
}
/**
 * 
 * @export
 * @interface ユーザーメールアドレスRequest
 */
export interface ユーザーメールアドレスRequest {
    /**
     * 
     * @type {string}
     * @memberof ユーザーメールアドレスRequest
     */
    'cユーザーメールアドレス': string;
}
/**
 * 
 * @export
 * @interface ユーザー名
 */
export interface ユーザー名 {
    /**
     * 
     * @type {string}
     * @memberof ユーザー名
     */
    'cユーザー名'?: string;
}
/**
 * 
 * @export
 * @interface ユーザー権限
 */
export interface ユーザー権限 {
    /**
     * 
     * @type {Eユーザー権限}
     * @memberof ユーザー権限
     */
    'cユーザー権限': Eユーザー権限;
}
/**
 * 
 * @export
 * @interface リース償却
 */
export interface リース償却 {
    /**
     * 
     * @type {number}
     * @memberof リース償却
     */
    '月数': number;
    /**
     * 
     * @type {number}
     * @memberof リース償却
     */
    '残価保証額'?: number;
}
/**
 * 
 * @export
 * @interface 不動産価格
 */
export interface 不動産価格 {
    /**
     * 
     * @type {number}
     * @memberof 不動産価格
     */
    '土地'?: number;
    /**
     * 
     * @type {number}
     * @memberof 不動産価格
     */
    '建物'?: number;
    /**
     * 
     * @type {number}
     * @memberof 不動産価格
     */
    '借地権'?: number;
}
/**
 * 
 * @export
 * @interface 事業所
 */
export interface 事業所 {
    /**
     * 
     * @type {string}
     * @memberof 事業所
     */
    'c事業所コード': string;
    /**
     * 
     * @type {string}
     * @memberof 事業所
     */
    'c事業所名': string;
    /**
     * 
     * @type {number}
     * @memberof 事業所
     */
    'c決算月': number;
    /**
     * 
     * @type {string}
     * @memberof 事業所
     */
    'c事業所住所'?: string;
    /**
     * 
     * @type {string}
     * @memberof 事業所
     */
    'c事業所電話番号'?: string;
    /**
     * 
     * @type {string}
     * @memberof 事業所
     */
    'c事業所代表者名'?: string;
    /**
     * 
     * @type {string}
     * @memberof 事業所
     */
    'c担当者名'?: string;
    /**
     * 
     * @type {string}
     * @memberof 事業所
     */
    'c担当者メールアドレス'?: string;
    /**
     * 
     * @type {string}
     * @memberof 事業所
     */
    'c担当者パスワード'?: string;
    /**
     * 
     * @type {number}
     * @memberof 事業所
     */
    'c計画作成期間': number;
    /**
     * 
     * @type {number}
     * @memberof 事業所
     */
    'c計画0期の決算期': number;
    /**
     * 
     * @type {E消費税区分}
     * @memberof 事業所
     */
    'c消費税区分': E消費税区分;
    /**
     * 
     * @type {number}
     * @memberof 事業所
     */
    'c消費税率': number;
    /**
     * 
     * @type {E課税方式}
     * @memberof 事業所
     */
    'c課税方式': E課税方式;
    /**
     * 
     * @type {E経理方式}
     * @memberof 事業所
     */
    'c経理方式': E経理方式;
    /**
     * 
     * @type {number}
     * @memberof 事業所
     */
    'c簡易課税事業区分': number;
    /**
     * 
     * @type {E端数処理}
     * @memberof 事業所
     */
    'c消費税端数処理': E端数処理;
    /**
     * 
     * @type {E端数処理}
     * @memberof 事業所
     */
    'c減価償却費端数処理': E端数処理;
    /**
     * 
     * @type {E端数処理}
     * @memberof 事業所
     */
    'c実績値及び計画値端数処理': E端数処理;
    /**
     * 
     * @type {E製造原価科目未使用フラグ}
     * @memberof 事業所
     */
    'c製造原価科目未使用フラグ': E製造原価科目未使用フラグ;
}
/**
 * 
 * @export
 * @interface 事業所Common
 */
export interface 事業所Common {
    /**
     * 
     * @type {string}
     * @memberof 事業所Common
     */
    'c事業所コード': string;
    /**
     * 
     * @type {string}
     * @memberof 事業所Common
     */
    'c事業所名': string;
    /**
     * 
     * @type {number}
     * @memberof 事業所Common
     */
    'c決算月': number;
}
/**
 * 
 * @export
 * @interface 事業所ListItemResponse
 */
export interface 事業所ListItemResponse {
    /**
     * 
     * @type {number}
     * @memberof 事業所ListItemResponse
     */
    'pk': number;
    /**
     * 
     * @type {string}
     * @memberof 事業所ListItemResponse
     */
    'c事業所コード': string;
    /**
     * 
     * @type {string}
     * @memberof 事業所ListItemResponse
     */
    'c事業所名': string;
    /**
     * 
     * @type {number}
     * @memberof 事業所ListItemResponse
     */
    'c決算月': number;
    /**
     * 
     * @type {string}
     * @memberof 事業所ListItemResponse
     */
    'c更新日時': string;
    /**
     * 
     * @type {string}
     * @memberof 事業所ListItemResponse
     */
    'cユーザー名'?: string;
    /**
     * 
     * @type {string}
     * @memberof 事業所ListItemResponse
     */
    'cアクセス日時'?: string;
}
/**
 * 
 * @export
 * @interface 事業所Request
 */
export interface 事業所Request {
    /**
     * 
     * @type {string}
     * @memberof 事業所Request
     */
    'c事業所コード': string;
    /**
     * 
     * @type {string}
     * @memberof 事業所Request
     */
    'c事業所名': string;
    /**
     * 
     * @type {number}
     * @memberof 事業所Request
     */
    'c決算月': number;
    /**
     * 
     * @type {string}
     * @memberof 事業所Request
     */
    'c事業所住所'?: string;
    /**
     * 
     * @type {string}
     * @memberof 事業所Request
     */
    'c事業所電話番号'?: string;
    /**
     * 
     * @type {string}
     * @memberof 事業所Request
     */
    'c事業所代表者名'?: string;
    /**
     * 
     * @type {string}
     * @memberof 事業所Request
     */
    'c担当者名'?: string;
    /**
     * 
     * @type {string}
     * @memberof 事業所Request
     */
    'c担当者メールアドレス'?: string;
    /**
     * 
     * @type {string}
     * @memberof 事業所Request
     */
    'c担当者パスワード'?: string;
    /**
     * 
     * @type {number}
     * @memberof 事業所Request
     */
    'c計画作成期間': number;
    /**
     * 
     * @type {number}
     * @memberof 事業所Request
     */
    'c計画0期の決算期': number;
    /**
     * 
     * @type {E消費税区分}
     * @memberof 事業所Request
     */
    'c消費税区分': E消費税区分;
    /**
     * 
     * @type {number}
     * @memberof 事業所Request
     */
    'c消費税率': number;
    /**
     * 
     * @type {E課税方式}
     * @memberof 事業所Request
     */
    'c課税方式': E課税方式;
    /**
     * 
     * @type {E経理方式}
     * @memberof 事業所Request
     */
    'c経理方式': E経理方式;
    /**
     * 
     * @type {number}
     * @memberof 事業所Request
     */
    'c簡易課税事業区分': number;
    /**
     * 
     * @type {E端数処理}
     * @memberof 事業所Request
     */
    'c消費税端数処理': E端数処理;
    /**
     * 
     * @type {E端数処理}
     * @memberof 事業所Request
     */
    'c減価償却費端数処理': E端数処理;
    /**
     * 
     * @type {E端数処理}
     * @memberof 事業所Request
     */
    'c実績値及び計画値端数処理': E端数処理;
    /**
     * 
     * @type {E製造原価科目未使用フラグ}
     * @memberof 事業所Request
     */
    'c製造原価科目未使用フラグ': E製造原価科目未使用フラグ;
}
/**
 * 
 * @export
 * @interface 事業所Response
 */
export interface 事業所Response {
    /**
     * 
     * @type {string}
     * @memberof 事業所Response
     */
    'c事業所コード': string;
    /**
     * 
     * @type {string}
     * @memberof 事業所Response
     */
    'c事業所名': string;
    /**
     * 
     * @type {number}
     * @memberof 事業所Response
     */
    'c決算月': number;
    /**
     * 
     * @type {string}
     * @memberof 事業所Response
     */
    'c事業所住所'?: string;
    /**
     * 
     * @type {string}
     * @memberof 事業所Response
     */
    'c事業所電話番号'?: string;
    /**
     * 
     * @type {string}
     * @memberof 事業所Response
     */
    'c事業所代表者名'?: string;
    /**
     * 
     * @type {string}
     * @memberof 事業所Response
     */
    'c担当者名'?: string;
    /**
     * 
     * @type {string}
     * @memberof 事業所Response
     */
    'c担当者メールアドレス'?: string;
    /**
     * 
     * @type {string}
     * @memberof 事業所Response
     */
    'c担当者パスワード'?: string;
    /**
     * 
     * @type {number}
     * @memberof 事業所Response
     */
    'c計画作成期間': number;
    /**
     * 
     * @type {number}
     * @memberof 事業所Response
     */
    'c計画0期の決算期': number;
    /**
     * 
     * @type {E消費税区分}
     * @memberof 事業所Response
     */
    'c消費税区分': E消費税区分;
    /**
     * 
     * @type {number}
     * @memberof 事業所Response
     */
    'c消費税率': number;
    /**
     * 
     * @type {E課税方式}
     * @memberof 事業所Response
     */
    'c課税方式': E課税方式;
    /**
     * 
     * @type {E経理方式}
     * @memberof 事業所Response
     */
    'c経理方式': E経理方式;
    /**
     * 
     * @type {number}
     * @memberof 事業所Response
     */
    'c簡易課税事業区分': number;
    /**
     * 
     * @type {E端数処理}
     * @memberof 事業所Response
     */
    'c消費税端数処理': E端数処理;
    /**
     * 
     * @type {E端数処理}
     * @memberof 事業所Response
     */
    'c減価償却費端数処理': E端数処理;
    /**
     * 
     * @type {E端数処理}
     * @memberof 事業所Response
     */
    'c実績値及び計画値端数処理': E端数処理;
    /**
     * 
     * @type {E製造原価科目未使用フラグ}
     * @memberof 事業所Response
     */
    'c製造原価科目未使用フラグ': E製造原価科目未使用フラグ;
}
/**
 * 
 * @export
 * @interface 勘定科目Common
 */
export interface 勘定科目Common {
    /**
     * 
     * @type {E勘定科目カテゴリ}
     * @memberof 勘定科目Common
     */
    'cカテゴリ': E勘定科目カテゴリ;
    /**
     * 
     * @type {E補助科目フラグ}
     * @memberof 勘定科目Common
     */
    'c補助科目フラグ': E補助科目フラグ;
    /**
     * 
     * @type {string}
     * @memberof 勘定科目Common
     */
    'c大分類': string;
    /**
     * 
     * @type {string}
     * @memberof 勘定科目Common
     */
    'c中分類'?: string;
    /**
     * 
     * @type {string}
     * @memberof 勘定科目Common
     */
    'c勘定科目': string;
    /**
     * 
     * @type {string}
     * @memberof 勘定科目Common
     */
    'c補助科目'?: string;
    /**
     * 
     * @type {E税区分}
     * @memberof 勘定科目Common
     */
    'c税区分'?: E税区分;
    /**
     * 
     * @type {ECF集計項目}
     * @memberof 勘定科目Common
     */
    'cCF集計項目'?: ECF集計項目;
    /**
     * 
     * @type {E集計転記科目}
     * @memberof 勘定科目Common
     */
    'c集計転記科目'?: E集計転記科目;
    /**
     * 
     * @type {E固変区分}
     * @memberof 勘定科目Common
     */
    'c固変区分'?: E固変区分;
    /**
     * 
     * @type {E有無フラグ}
     * @memberof 勘定科目Common
     */
    'c科目別計画フラグ': E有無フラグ;
    /**
     * 
     * @type {E分析非表示フラグ}
     * @memberof 勘定科目Common
     */
    'c分析非表示フラグ': E分析非表示フラグ;
}
/**
 * 
 * @export
 * @interface 勘定科目ListItemResponse
 */
export interface 勘定科目ListItemResponse {
    /**
     * 
     * @type {number}
     * @memberof 勘定科目ListItemResponse
     */
    'pk': number;
    /**
     * 
     * @type {E勘定科目カテゴリ}
     * @memberof 勘定科目ListItemResponse
     */
    'cカテゴリ': E勘定科目カテゴリ;
    /**
     * 
     * @type {E補助科目フラグ}
     * @memberof 勘定科目ListItemResponse
     */
    'c補助科目フラグ': E補助科目フラグ;
    /**
     * 
     * @type {string}
     * @memberof 勘定科目ListItemResponse
     */
    'c大分類': string;
    /**
     * 
     * @type {string}
     * @memberof 勘定科目ListItemResponse
     */
    'c中分類'?: string;
    /**
     * 
     * @type {string}
     * @memberof 勘定科目ListItemResponse
     */
    'c勘定科目': string;
    /**
     * 
     * @type {string}
     * @memberof 勘定科目ListItemResponse
     */
    'c補助科目'?: string;
    /**
     * 
     * @type {E税区分}
     * @memberof 勘定科目ListItemResponse
     */
    'c税区分'?: E税区分;
    /**
     * 
     * @type {ECF集計項目}
     * @memberof 勘定科目ListItemResponse
     */
    'cCF集計項目'?: ECF集計項目;
    /**
     * 
     * @type {E集計転記科目}
     * @memberof 勘定科目ListItemResponse
     */
    'c集計転記科目'?: E集計転記科目;
    /**
     * 
     * @type {E固変区分}
     * @memberof 勘定科目ListItemResponse
     */
    'c固変区分'?: E固変区分;
    /**
     * 
     * @type {E有無フラグ}
     * @memberof 勘定科目ListItemResponse
     */
    'c科目別計画フラグ': E有無フラグ;
    /**
     * 
     * @type {E分析非表示フラグ}
     * @memberof 勘定科目ListItemResponse
     */
    'c分析非表示フラグ': E分析非表示フラグ;
    /**
     * 
     * @type {number}
     * @memberof 勘定科目ListItemResponse
     */
    'c並び順': number;
}
/**
 * 
 * @export
 * @interface 勘定科目Pk
 */
export interface 勘定科目Pk {
    /**
     * 
     * @type {number}
     * @memberof 勘定科目Pk
     */
    '勘定科目Pk'?: number;
}
/**
 * 
 * @export
 * @interface 勘定科目Request
 */
export interface 勘定科目Request {
    /**
     * 
     * @type {E勘定科目カテゴリ}
     * @memberof 勘定科目Request
     */
    'cカテゴリ': E勘定科目カテゴリ;
    /**
     * 
     * @type {E補助科目フラグ}
     * @memberof 勘定科目Request
     */
    'c補助科目フラグ': E補助科目フラグ;
    /**
     * 
     * @type {string}
     * @memberof 勘定科目Request
     */
    'c大分類': string;
    /**
     * 
     * @type {string}
     * @memberof 勘定科目Request
     */
    'c中分類'?: string;
    /**
     * 
     * @type {string}
     * @memberof 勘定科目Request
     */
    'c勘定科目': string;
    /**
     * 
     * @type {string}
     * @memberof 勘定科目Request
     */
    'c補助科目'?: string;
    /**
     * 
     * @type {E税区分}
     * @memberof 勘定科目Request
     */
    'c税区分'?: E税区分;
    /**
     * 
     * @type {ECF集計項目}
     * @memberof 勘定科目Request
     */
    'cCF集計項目'?: ECF集計項目;
    /**
     * 
     * @type {E集計転記科目}
     * @memberof 勘定科目Request
     */
    'c集計転記科目'?: E集計転記科目;
    /**
     * 
     * @type {E固変区分}
     * @memberof 勘定科目Request
     */
    'c固変区分'?: E固変区分;
    /**
     * 
     * @type {E有無フラグ}
     * @memberof 勘定科目Request
     */
    'c科目別計画フラグ': E有無フラグ;
    /**
     * 
     * @type {E分析非表示フラグ}
     * @memberof 勘定科目Request
     */
    'c分析非表示フラグ': E分析非表示フラグ;
}
/**
 * 
 * @export
 * @interface 取込FileListItemResponse
 */
export interface 取込FileListItemResponse {
    /**
     * 
     * @type {string}
     * @memberof 取込FileListItemResponse
     */
    '勘定科目'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof 取込FileListItemResponse
     */
    'values': Array<string>;
}
/**
 * 
 * @export
 * @interface 取込ListHeader
 */
export interface 取込ListHeader {
    /**
     * listのカラム定義
     * @type {Array<string>}
     * @memberof 取込ListHeader
     */
    'header'?: Array<string>;
}
/**
 * 
 * @export
 * @interface 取込ListItemResponse
 */
export interface 取込ListItemResponse {
    /**
     * 
     * @type {number}
     * @memberof 取込ListItemResponse
     */
    'pk': number;
    /**
     * 
     * @type {E取込形式}
     * @memberof 取込ListItemResponse
     */
    'c取込形式': E取込形式;
    /**
     * 
     * @type {E取込分類}
     * @memberof 取込ListItemResponse
     */
    'c取込分類': E取込分類;
    /**
     * 
     * @type {number}
     * @memberof 取込ListItemResponse
     */
    'c年': number;
    /**
     * 
     * @type {number}
     * @memberof 取込ListItemResponse
     */
    'c部門PK'?: number;
}
/**
 * 
 * @export
 * @interface 取込PdfImportResponse
 */
export interface 取込PdfImportResponse {
    /**
     * 総ページ数
     * @type {number}
     * @memberof 取込PdfImportResponse
     */
    'totalPage': number;
}
/**
 * 
 * @export
 * @interface 取込PdfListItemResponse
 */
export interface 取込PdfListItemResponse {
    /**
     * 
     * @type {E取込データ種別}
     * @memberof 取込PdfListItemResponse
     */
    '取込データ種別'?: E取込データ種別;
    /**
     * 
     * @type {Array<取込FileListItemResponse>}
     * @memberof 取込PdfListItemResponse
     */
    'list'?: Array<取込FileListItemResponse>;
}
/**
 * 
 * @export
 * @interface 取込PdfPlbscfListItemRequest
 */
export interface 取込PdfPlbscfListItemRequest {
    /**
     * 
     * @type {number}
     * @memberof 取込PdfPlbscfListItemRequest
     */
    '勘定科目Pk'?: number;
    /**
     * 
     * @type {取込勘定科目Request}
     * @memberof 取込PdfPlbscfListItemRequest
     */
    '取込勘定科目'?: 取込勘定科目Request;
}
/**
 * 
 * @export
 * @interface 取込Pdfカテゴリ決算書ListItemRequest
 */
export interface 取込Pdfカテゴリ決算書ListItemRequest {
    /**
     * 
     * @type {E勘定科目カテゴリ}
     * @memberof 取込Pdfカテゴリ決算書ListItemRequest
     */
    'cカテゴリ'?: E勘定科目カテゴリ;
    /**
     * 
     * @type {Array<取込Pdf決算書ListItemRequest>}
     * @memberof 取込Pdfカテゴリ決算書ListItemRequest
     */
    'list'?: Array<取込Pdf決算書ListItemRequest>;
}
/**
 * 
 * @export
 * @interface 取込Pdfカテゴリ試算表ListItemRequest
 */
export interface 取込Pdfカテゴリ試算表ListItemRequest {
    /**
     * 
     * @type {E勘定科目カテゴリ}
     * @memberof 取込Pdfカテゴリ試算表ListItemRequest
     */
    'cカテゴリ'?: E勘定科目カテゴリ;
    /**
     * 
     * @type {Array<取込Pdf試算表ListItemRequest>}
     * @memberof 取込Pdfカテゴリ試算表ListItemRequest
     */
    'list'?: Array<取込Pdf試算表ListItemRequest>;
}
/**
 * 
 * @export
 * @interface 取込Pdf固定資産ListItemRequest
 */
export interface 取込Pdf固定資産ListItemRequest {
    /**
     * 
     * @type {number}
     * @memberof 取込Pdf固定資産ListItemRequest
     */
    '勘定科目Pk'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof 取込Pdf固定資産ListItemRequest
     */
    'values'?: Array<string>;
}
/**
 * 
 * @export
 * @interface 取込Pdf固定資産Request
 */
export interface 取込Pdf固定資産Request {
    /**
     * 
     * @type {Array<string>}
     * @memberof 取込Pdf固定資産Request
     */
    'tsvs': Array<string>;
}
/**
 * 
 * @export
 * @interface 取込Pdf決算書ListItemRequest
 */
export interface 取込Pdf決算書ListItemRequest {
    /**
     * 
     * @type {number}
     * @memberof 取込Pdf決算書ListItemRequest
     */
    '勘定科目Pk'?: number;
    /**
     * 
     * @type {取込勘定科目Request}
     * @memberof 取込Pdf決算書ListItemRequest
     */
    '取込勘定科目'?: 取込勘定科目Request;
    /**
     * 値を入力しない場合はundefined
     * @type {number}
     * @memberof 取込Pdf決算書ListItemRequest
     */
    'value'?: number;
}
/**
 * 
 * @export
 * @interface 取込Pdf試算表ListItemRequest
 */
export interface 取込Pdf試算表ListItemRequest {
    /**
     * 
     * @type {number}
     * @memberof 取込Pdf試算表ListItemRequest
     */
    '勘定科目Pk'?: number;
    /**
     * 
     * @type {取込勘定科目Request}
     * @memberof 取込Pdf試算表ListItemRequest
     */
    '取込勘定科目'?: 取込勘定科目Request;
    /**
     * 一か月毎の入力値 or 計算値
     * @type {Array<number>}
     * @memberof 取込Pdf試算表ListItemRequest
     */
    'monthlyValues': Array<number>;
}
/**
 * 
 * @export
 * @interface 取込XlsxImportListItemResponse
 */
export interface 取込XlsxImportListItemResponse {
    /**
     * 
     * @type {E取込データ種別}
     * @memberof 取込XlsxImportListItemResponse
     */
    '取込データ種別': E取込データ種別;
    /**
     * listのカラム定義
     * @type {Array<string>}
     * @memberof 取込XlsxImportListItemResponse
     */
    'header'?: Array<string>;
    /**
     * 
     * @type {Array<取込FileListItemResponse>}
     * @memberof 取込XlsxImportListItemResponse
     */
    'list': Array<取込FileListItemResponse>;
}
/**
 * 
 * @export
 * @interface 取込勘定科目Request
 */
export interface 取込勘定科目Request {
    /**
     * 
     * @type {string}
     * @memberof 取込勘定科目Request
     */
    'c大分類': string;
    /**
     * 
     * @type {string}
     * @memberof 取込勘定科目Request
     */
    'c中分類'?: string;
    /**
     * 
     * @type {string}
     * @memberof 取込勘定科目Request
     */
    'c勘定科目': string;
}
/**
 * 
 * @export
 * @interface 変換枚数Response
 */
export interface 変換枚数Response {
    /**
     * 
     * @type {number}
     * @memberof 変換枚数Response
     */
    'pk': number;
    /**
     * 
     * @type {number}
     * @memberof 変換枚数Response
     */
    'c枚数': number;
}
/**
 * 
 * @export
 * @interface 帳票DynamicConfig
 */
export interface 帳票DynamicConfig {
    /**
     * 
     * @type {Array<number>}
     * @memberof 帳票DynamicConfig
     */
    'rows'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof 帳票DynamicConfig
     */
    'columns'?: Array<number>;
}
/**
 * 
 * @export
 * @interface 帳票ListItemRequest
 */
export interface 帳票ListItemRequest {
    /**
     * テンプレートXlsxシート名
     * @type {string}
     * @memberof 帳票ListItemRequest
     */
    'templateName': string;
    /**
     * 出力シート名<br /> 以下は禁則文字<br /> \\:\\\\?[ ]/_*\'￥
     * @type {string}
     * @memberof 帳票ListItemRequest
     */
    'sheetName'?: string;
    /**
     * テンプレートXlsxシート内行インデックス配列<br /> valuesと同要素数<br /> ※転送量削減のために values とのオブジェクト化を回避
     * @type {Array<number>}
     * @memberof 帳票ListItemRequest
     */
    'templateRows': Array<number>;
    /**
     * テンプレートXlsxシート内出力値配列<br /> templateRowsと同要素数<br /> ※転送量削減のために templateRows とのオブジェクト化を回避
     * @type {Array<Array<any>>}
     * @memberof 帳票ListItemRequest
     */
    'values': Array<Array<any>>;
    /**
     * 列に関する動的設定
     * @type {Array<帳票DynamicConfig>}
     * @memberof 帳票ListItemRequest
     */
    'dynamicConfigs'?: Array<帳票DynamicConfig>;
}
/**
 * 
 * @export
 * @interface 法人税
 */
export interface 法人税 {
    /**
     * 
     * @type {Array<法人税加減算値>}
     * @memberof 法人税
     */
    '加減算値s': Array<法人税加減算値>;
    /**
     * 
     * @type {number}
     * @memberof 法人税
     */
    '実効税率': number;
    /**
     * 
     * @type {number}
     * @memberof 法人税
     */
    '法人税等'?: number;
    /**
     * 
     * @type {number}
     * @memberof 法人税
     */
    '予定納税額': number;
}
/**
 * 
 * @export
 * @interface 法人税Label
 */
export interface 法人税Label {
    /**
     * 
     * @type {string}
     * @memberof 法人税Label
     */
    '加算': string;
    /**
     * 
     * @type {string}
     * @memberof 法人税Label
     */
    '減算': string;
}
/**
 * 
 * @export
 * @interface 法人税加減算値
 */
export interface 法人税加減算値 {
    /**
     * 
     * @type {number}
     * @memberof 法人税加減算値
     */
    '加算': number;
    /**
     * 
     * @type {number}
     * @memberof 法人税加減算値
     */
    '減算': number;
}
/**
 * 
 * @export
 * @interface 科目別計画明細Config
 */
export interface 科目別計画明細Config {
    /**
     * t計画書データ.c計画0期の決算期以降のデータでは必須、取込時は10固定
     * @type {number}
     * @memberof 科目別計画明細Config
     */
    '科目別計画明細No': number;
    /**
     * 
     * @type {E科目別計画明細ConfigType}
     * @memberof 科目別計画明細Config
     */
    'type': E科目別計画明細ConfigType;
    /**
     * 
     * @type {string}
     * @memberof 科目別計画明細Config
     */
    'label': string;
    /**
     * type = 1 の場合は必須
     * @type {number}
     * @memberof 科目別計画明細Config
     */
    'fixedValue'?: number;
    /**
     * 
     * @type {科目別計画明細Formula}
     * @memberof 科目別計画明細Config
     */
    'formula'?: 科目別計画明細Formula;
    /**
     * 表示要否<br /> 但し、科目別計画明細No.1, 2, 10 は本値に関わらず必ず表示<br /> また、紐付くCデータPlbscfItemは、本値に関わらず各種計算に利用
     * @type {boolean}
     * @memberof 科目別計画明細Config
     */
    'isVisible'?: boolean;
}
/**
 * 
 * @export
 * @interface 科目別計画明細Formula
 */
export interface 科目別計画明細Formula {
    /**
     * 
     * @type {Array<number>}
     * @memberof 科目別計画明細Formula
     */
    'nos': Array<number>;
    /**
     * 
     * @type {Array<EOperator>}
     * @memberof 科目別計画明細Formula
     */
    'operators': Array<EOperator>;
}
/**
 * 
 * @export
 * @interface 科目別計画明細No
 */
export interface 科目別計画明細No {
    /**
     * t計画書データ.c計画0期の決算期以降のデータでは必須、取込時は10固定
     * @type {number}
     * @memberof 科目別計画明細No
     */
    '科目別計画明細No'?: number;
}
/**
 * 
 * @export
 * @interface 納税YearValue
 */
export interface 納税YearValue {
    /**
     * 
     * @type {法人税}
     * @memberof 納税YearValue
     */
    '法人税': 法人税;
    /**
     * 
     * @type {繰越欠損金}
     * @memberof 納税YearValue
     */
    '繰越欠損金': 繰越欠損金;
    /**
     * 
     * @type {number}
     * @memberof 納税YearValue
     */
    '消費税中間納付額'?: number;
}
/**
 * 
 * @export
 * @interface 繰越欠損金
 */
export interface 繰越欠損金 {
    /**
     * 
     * @type {number}
     * @memberof 繰越欠損金
     */
    '残高'?: number;
    /**
     * 
     * @type {number}
     * @memberof 繰越欠損金
     */
    '増加額': number;
    /**
     * 
     * @type {number}
     * @memberof 繰越欠損金
     */
    '減少額': number;
}
/**
 * 
 * @export
 * @interface 計画書データCommon
 */
export interface 計画書データCommon {
    /**
     * 
     * @type {number}
     * @memberof 計画書データCommon
     */
    'c計画書データ番号': number;
    /**
     * 
     * @type {string}
     * @memberof 計画書データCommon
     */
    'c計画書データ名': string;
    /**
     * 
     * @type {number}
     * @memberof 計画書データCommon
     */
    'c実績直近月': number;
    /**
     * 
     * @type {string}
     * @memberof 計画書データCommon
     */
    'c備考'?: string;
}
/**
 * 
 * @export
 * @interface 計画書データListItemResponse
 */
export interface 計画書データListItemResponse {
    /**
     * 
     * @type {number}
     * @memberof 計画書データListItemResponse
     */
    'pk': number;
    /**
     * 
     * @type {number}
     * @memberof 計画書データListItemResponse
     */
    'c計画書データ番号': number;
    /**
     * 
     * @type {string}
     * @memberof 計画書データListItemResponse
     */
    'c計画書データ名': string;
    /**
     * 
     * @type {number}
     * @memberof 計画書データListItemResponse
     */
    'c実績直近月': number;
    /**
     * 
     * @type {string}
     * @memberof 計画書データListItemResponse
     */
    'c備考'?: string;
    /**
     * 
     * @type {string}
     * @memberof 計画書データListItemResponse
     */
    'c更新日時': string;
    /**
     * 
     * @type {E有無フラグ}
     * @memberof 計画書データListItemResponse
     */
    'c過去データ表示フラグ': E有無フラグ;
    /**
     * 
     * @type {E有無フラグ}
     * @memberof 計画書データListItemResponse
     */
    'c第1期月次作成フラグ': E有無フラグ;
    /**
     * 
     * @type {E千円表示フラグ}
     * @memberof 計画書データListItemResponse
     */
    'c千円表示フラグ': E千円表示フラグ;
    /**
     * 
     * @type {E0円非表示フラグ}
     * @memberof 計画書データListItemResponse
     */
    'c分析0円非表示フラグ': E0円非表示フラグ;
    /**
     * 
     * @type {E0円非表示フラグ}
     * @memberof 計画書データListItemResponse
     */
    'c計画0円非表示フラグ': E0円非表示フラグ;
    /**
     * 
     * @type {E0円非表示フラグ}
     * @memberof 計画書データListItemResponse
     */
    'cモニタリング0円非表示フラグ': E0円非表示フラグ;
    /**
     * 
     * @type {E計画表示モード}
     * @memberof 計画書データListItemResponse
     */
    'c計画表示モード': E計画表示モード;
    /**
     * 
     * @type {Eフリーキャッシュフロー種別}
     * @memberof 計画書データListItemResponse
     */
    'cフリーキャッシュフロー種別': Eフリーキャッシュフロー種別;
    /**
     * 
     * @type {number}
     * @memberof 計画書データListItemResponse
     */
    'c計画0期の決算期': number;
    /**
     * 
     * @type {number}
     * @memberof 計画書データListItemResponse
     */
    'cモニタリング会計期間'?: number;
}
/**
 * 
 * @export
 * @interface 計画書データRequest
 */
export interface 計画書データRequest {
    /**
     * 
     * @type {number}
     * @memberof 計画書データRequest
     */
    'c計画書データ番号': number;
    /**
     * 
     * @type {string}
     * @memberof 計画書データRequest
     */
    'c計画書データ名': string;
    /**
     * 
     * @type {number}
     * @memberof 計画書データRequest
     */
    'c実績直近月': number;
    /**
     * 
     * @type {string}
     * @memberof 計画書データRequest
     */
    'c備考'?: string;
}
/**
 * 
 * @export
 * @interface 計画書データ表示設定Request
 */
export interface 計画書データ表示設定Request {
    /**
     * 
     * @type {E有無フラグ}
     * @memberof 計画書データ表示設定Request
     */
    'c過去データ表示フラグ'?: E有無フラグ;
    /**
     * 
     * @type {E有無フラグ}
     * @memberof 計画書データ表示設定Request
     */
    'c第1期月次作成フラグ'?: E有無フラグ;
    /**
     * 
     * @type {E千円表示フラグ}
     * @memberof 計画書データ表示設定Request
     */
    'c千円表示フラグ'?: E千円表示フラグ;
    /**
     * 
     * @type {E0円非表示フラグ}
     * @memberof 計画書データ表示設定Request
     */
    'c分析0円非表示フラグ'?: E0円非表示フラグ;
    /**
     * 
     * @type {E0円非表示フラグ}
     * @memberof 計画書データ表示設定Request
     */
    'c計画0円非表示フラグ'?: E0円非表示フラグ;
    /**
     * 
     * @type {E0円非表示フラグ}
     * @memberof 計画書データ表示設定Request
     */
    'cモニタリング0円非表示フラグ'?: E0円非表示フラグ;
    /**
     * 
     * @type {E計画表示モード}
     * @memberof 計画書データ表示設定Request
     */
    'c計画表示モード'?: E計画表示モード;
    /**
     * 
     * @type {Eフリーキャッシュフロー種別}
     * @memberof 計画書データ表示設定Request
     */
    'cフリーキャッシュフロー種別'?: Eフリーキャッシュフロー種別;
}
/**
 * 
 * @export
 * @interface 資金繰りConfig
 */
export interface 資金繰りConfig {
    /**
     * 
     * @type {string}
     * @memberof 資金繰りConfig
     */
    '開始月'?: string;
    /**
     * 
     * @type {資金繰り経常Config}
     * @memberof 資金繰りConfig
     */
    '経常収支': 資金繰り経常Config;
    /**
     * 
     * @type {資金繰り財務Config}
     * @memberof 資金繰りConfig
     */
    '財務収支': 資金繰り財務Config;
}
/**
 * 
 * @export
 * @interface 資金繰りMonthlyValue
 */
export interface 資金繰りMonthlyValue {
    /**
     * 
     * @type {number}
     * @memberof 資金繰りMonthlyValue
     */
    '月初資金残高'?: number;
    /**
     * 自動計算値は保存しない。
     * @type {Array<資金繰りValue>}
     * @memberof 資金繰りMonthlyValue
     */
    'values': Array<資金繰りValue>;
}
/**
 * 
 * @export
 * @interface 資金繰りValue
 */
export interface 資金繰りValue {
    /**
     * 
     * @type {E資金繰りType}
     * @memberof 資金繰りValue
     */
    'type': E資金繰りType;
    /**
     * 資金繰り表のE資金繰りType内行インデックス
     * @type {number}
     * @memberof 資金繰りValue
     */
    'typeRowIndex': number;
    /**
     * 
     * @type {number}
     * @memberof 資金繰りValue
     */
    'ym': number;
    /**
     * 
     * @type {number}
     * @memberof 資金繰りValue
     */
    'value': number;
}
/**
 * 
 * @export
 * @interface 資金繰り経常Config
 */
export interface 資金繰り経常Config {
    /**
     * 
     * @type {Array<資金繰り経常収支Config>}
     * @memberof 資金繰り経常Config
     */
    '営業収入s': Array<資金繰り経常収支Config>;
    /**
     * 
     * @type {Array<資金繰り経常収支Config>}
     * @memberof 資金繰り経常Config
     */
    '営業外収入s': Array<資金繰り経常収支Config>;
    /**
     * 
     * @type {Array<資金繰り経常収支Config>}
     * @memberof 資金繰り経常Config
     */
    '営業支出s': Array<資金繰り経常収支Config>;
    /**
     * 
     * @type {Array<資金繰り経常収支Config>}
     * @memberof 資金繰り経常Config
     */
    '営業外支出s': Array<資金繰り経常収支Config>;
}
/**
 * 
 * @export
 * @interface 資金繰り経常収支Config
 */
export interface 資金繰り経常収支Config {
    /**
     * 
     * @type {string}
     * @memberof 資金繰り経常収支Config
     */
    'label': string;
    /**
     * 
     * @type {Array<number>}
     * @memberof 資金繰り経常収支Config
     */
    '勘定科目Pks': Array<number>;
    /**
     * 
     * @type {E回収支払条件}
     * @memberof 資金繰り経常収支Config
     */
    '回収支払条件'?: E回収支払条件;
}
/**
 * 
 * @export
 * @interface 資金繰り財務Config
 */
export interface 資金繰り財務Config {
    /**
     * 
     * @type {Array<資金繰り財務収支Config>}
     * @memberof 資金繰り財務Config
     */
    '財務収入s': Array<資金繰り財務収支Config>;
    /**
     * 
     * @type {Array<資金繰り財務収支Config>}
     * @memberof 資金繰り財務Config
     */
    '財務支出s': Array<資金繰り財務収支Config>;
}
/**
 * 
 * @export
 * @interface 資金繰り財務収支Config
 */
export interface 資金繰り財務収支Config {
    /**
     * 
     * @type {string}
     * @memberof 資金繰り財務収支Config
     */
    'label': string;
    /**
     * 
     * @type {E借入金条件}
     * @memberof 資金繰り財務収支Config
     */
    '借入金条件'?: E借入金条件;
}
/**
 * 自動計算値は保存しない。 0期を登録する場合は月毎、1期～10期は年毎で保持する。
 * @export
 * @interface 返済明細
 */
export interface 返済明細 {
    /**
     * 
     * @type {Array<YearMonthValue>}
     * @memberof 返済明細
     */
    '新規借入'?: Array<YearMonthValue>;
    /**
     * 
     * @type {Array<YearMonthValue>}
     * @memberof 返済明細
     */
    '元本返済': Array<YearMonthValue>;
    /**
     * 
     * @type {Array<YearMonthValue>}
     * @memberof 返済明細
     */
    '利息': Array<YearMonthValue>;
}
/**
 * 
 * @export
 * @interface 返済計画YearlyValue
 */
export interface 返済計画YearlyValue {
    /**
     * 
     * @type {Array<number>}
     * @memberof 返済計画YearlyValue
     */
    'values': Array<number>;
    /**
     * 
     * @type {number}
     * @memberof 返済計画YearlyValue
     */
    '返済率': number;
    /**
     * 
     * @type {number}
     * @memberof 返済計画YearlyValue
     */
    '返済額合計'?: number;
}
/**
 * 
 * @export
 * @interface 部門Common
 */
export interface 部門Common {
    /**
     * 
     * @type {string}
     * @memberof 部門Common
     */
    'c部門コード': string;
    /**
     * 
     * @type {string}
     * @memberof 部門Common
     */
    'c部門名': string;
    /**
     * 
     * @type {string}
     * @memberof 部門Common
     */
    'c備考'?: string;
}
/**
 * 
 * @export
 * @interface 部門ListItemResponse
 */
export interface 部門ListItemResponse {
    /**
     * 
     * @type {number}
     * @memberof 部門ListItemResponse
     */
    'pk': number;
    /**
     * 
     * @type {string}
     * @memberof 部門ListItemResponse
     */
    'c部門コード': string;
    /**
     * 
     * @type {string}
     * @memberof 部門ListItemResponse
     */
    'c部門名': string;
    /**
     * 
     * @type {string}
     * @memberof 部門ListItemResponse
     */
    'c備考'?: string;
}
/**
 * 
 * @export
 * @interface 部門Request
 */
export interface 部門Request {
    /**
     * 
     * @type {string}
     * @memberof 部門Request
     */
    'c部門コード': string;
    /**
     * 
     * @type {string}
     * @memberof 部門Request
     */
    'c部門名': string;
    /**
     * 
     * @type {string}
     * @memberof 部門Request
     */
    'c備考'?: string;
}

/**
 * LoginApi - axios parameter creator
 * @export
 */
export const LoginApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 認証成功時はレスポンスヘッダーに認証/認可トークンを返却します
         * @summary ログイン
         * @param {LoginRequest} loginRequest 認証情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: async (loginRequest: LoginRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginRequest' is not null or undefined
            assertParamExists('login', 'loginRequest', loginRequest)
            let localVarPath = `/login`;
            if (process.env.VUE_APP_IS_MOCK === "true") localVarPath = ApiUtility.convertSampleUrl('POST', '/login', options);
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            // jsonファイルアクセス時、PUT/DELETEの場合apacheの仕様（default-handler）で弾かれてしまうため、GETへ変換している
            const method = process.env.VUE_APP_IS_MOCK === "true" && ['PUT', 'DELETE'].includes('POST')
              ? 'GET'
              : 'POST';
            const localVarRequestOptions = { method, ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LoginApi - functional programming interface
 * @export
 */
export const LoginApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LoginApiAxiosParamCreator(configuration)
    return {
        /**
         * 認証成功時はレスポンスヘッダーに認証/認可トークンを返却します
         * @summary ログイン
         * @param {LoginRequest} loginRequest 認証情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async login(loginRequest: LoginRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.login(loginRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LoginApi - factory interface
 * @export
 */
export const LoginApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LoginApiFp(configuration)
    return {
        /**
         * 認証成功時はレスポンスヘッダーに認証/認可トークンを返却します
         * @summary ログイン
         * @param {LoginRequest} loginRequest 認証情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(loginRequest: LoginRequest, options?: any): AxiosPromise<void> {
            return localVarFp.login(loginRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LoginApi - object-oriented interface
 * @export
 * @class LoginApi
 * @extends {BaseAPI}
 */
export class LoginApi extends BaseAPI {
    /**
     * 認証成功時はレスポンスヘッダーに認証/認可トークンを返却します
     * @summary ログイン
     * @param {LoginRequest} loginRequest 認証情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginApi
     */
    public login(loginRequest: LoginRequest, options?: AxiosRequestConfig) {
        return LoginApiFp(this.configuration).login(loginRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * データApi - axios parameter creator
 * @export
 */
export const データApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 認証/認可トークンのt企業、指定計画書データpkに紐付くtデータを一括保存します
         * @summary データ一括保存
         * @param {number} 計画書データpk 
         * @param {Array<データListItemRequest>} データlistItemRequest データ一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkSaveデータ: async (計画書データpk: number, データlistItemRequest: Array<データListItemRequest>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter '計画書データpk' is not null or undefined
            assertParamExists('bulkSaveデータ', '計画書データpk', 計画書データpk)
            // verify required parameter 'データlistItemRequest' is not null or undefined
            assertParamExists('bulkSaveデータ', 'データlistItemRequest', データlistItemRequest)
            let localVarPath = `/データ/{計画書データpk}/bulk`
                .replace(`{${"計画書データpk"}}`, encodeURIComponent(String(計画書データpk)));
            if (process.env.VUE_APP_IS_MOCK === "true") localVarPath = ApiUtility.convertSampleUrl('POST', '/データ/{計画書データpk}/bulk', options);
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            // jsonファイルアクセス時、PUT/DELETEの場合apacheの仕様（default-handler）で弾かれてしまうため、GETへ変換している
            const method = process.env.VUE_APP_IS_MOCK === "true" && ['PUT', 'DELETE'].includes('POST')
              ? 'GET'
              : 'POST';
            const localVarRequestOptions = { method, ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "userToken", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(データlistItemRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 認証/認可トークンのt企業、指定計画書データpkに紐付くtデータを保存します
         * @summary データ作成
         * @param {number} 計画書データpk 
         * @param {データRequest} データrequest データ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createデータ: async (計画書データpk: number, データrequest: データRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter '計画書データpk' is not null or undefined
            assertParamExists('createデータ', '計画書データpk', 計画書データpk)
            // verify required parameter 'データrequest' is not null or undefined
            assertParamExists('createデータ', 'データrequest', データrequest)
            let localVarPath = `/データ/{計画書データpk}`
                .replace(`{${"計画書データpk"}}`, encodeURIComponent(String(計画書データpk)));
            if (process.env.VUE_APP_IS_MOCK === "true") localVarPath = ApiUtility.convertSampleUrl('POST', '/データ/{計画書データpk}', options);
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            // jsonファイルアクセス時、PUT/DELETEの場合apacheの仕様（default-handler）で弾かれてしまうため、GETへ変換している
            const method = process.env.VUE_APP_IS_MOCK === "true" && ['PUT', 'DELETE'].includes('POST')
              ? 'GET'
              : 'POST';
            const localVarRequestOptions = { method, ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "userToken", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(データrequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 認証/認可トークンのt企業と指定データpkに紐付くtデータを削除します
         * @summary データ削除
         * @param {number} データpk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteデータ: async (データpk: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'データpk' is not null or undefined
            assertParamExists('deleteデータ', 'データpk', データpk)
            let localVarPath = `/データ/{データpk}`
                .replace(`{${"データpk"}}`, encodeURIComponent(String(データpk)));
            if (process.env.VUE_APP_IS_MOCK === "true") localVarPath = ApiUtility.convertSampleUrl('DELETE', '/データ/{データpk}', options);
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            // jsonファイルアクセス時、PUT/DELETEの場合apacheの仕様（default-handler）で弾かれてしまうため、GETへ変換している
            const method = process.env.VUE_APP_IS_MOCK === "true" && ['PUT', 'DELETE'].includes('DELETE')
              ? 'GET'
              : 'DELETE';
            const localVarRequestOptions = { method, ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "userToken", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 認証/認可トークンのt企業、指定計画書データpkと検索条件で絞り込んだtデータの一覧をc入力分類、c番号の昇順で取得します
         * @summary データ一覧
         * @param {number} 計画書データpk 
         * @param {Array<E入力分類>} 入力分類 
         * @param {Eフェーズ種別} [フェーズ種別] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listデータ: async (計画書データpk: number, 入力分類: Array<E入力分類>, フェーズ種別?: Eフェーズ種別, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter '計画書データpk' is not null or undefined
            assertParamExists('listデータ', '計画書データpk', 計画書データpk)
            // verify required parameter '入力分類' is not null or undefined
            assertParamExists('listデータ', '入力分類', 入力分類)
            let localVarPath = `/データ/{計画書データpk}`
                .replace(`{${"計画書データpk"}}`, encodeURIComponent(String(計画書データpk)));
            if (process.env.VUE_APP_IS_MOCK === "true") localVarPath = ApiUtility.convertSampleUrl('GET', '/データ/{計画書データpk}', options);
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            // jsonファイルアクセス時、PUT/DELETEの場合apacheの仕様（default-handler）で弾かれてしまうため、GETへ変換している
            const method = process.env.VUE_APP_IS_MOCK === "true" && ['PUT', 'DELETE'].includes('GET')
              ? 'GET'
              : 'GET';
            const localVarRequestOptions = { method, ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "userToken", configuration)

            if (入力分類) {
                localVarQueryParameter['入力分類'] = 入力分類.join(COLLECTION_FORMATS.csv);
            }

            if (フェーズ種別 !== undefined) {
                localVarQueryParameter['フェーズ種別'] = フェーズ種別;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 認証/認可トークンのt企業、指定計画書データpkに紐付くc入力分類=PLBSCFのtデータを保存します<br /> ※更新登録時は、cデータの一部を上書き保存します
         * @summary PLBSCFデータ保存
         * @param {number} 計画書データpk 
         * @param {PlbscfデータRequest} plbscfデータRequest データ一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePlbscfデータ: async (計画書データpk: number, plbscfデータRequest: PlbscfデータRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter '計画書データpk' is not null or undefined
            assertParamExists('savePlbscfデータ', '計画書データpk', 計画書データpk)
            // verify required parameter 'plbscfデータRequest' is not null or undefined
            assertParamExists('savePlbscfデータ', 'plbscfデータRequest', plbscfデータRequest)
            let localVarPath = `/データ/{計画書データpk}/plbscf`
                .replace(`{${"計画書データpk"}}`, encodeURIComponent(String(計画書データpk)));
            if (process.env.VUE_APP_IS_MOCK === "true") localVarPath = ApiUtility.convertSampleUrl('POST', '/データ/{計画書データpk}/plbscf', options);
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            // jsonファイルアクセス時、PUT/DELETEの場合apacheの仕様（default-handler）で弾かれてしまうため、GETへ変換している
            const method = process.env.VUE_APP_IS_MOCK === "true" && ['PUT', 'DELETE'].includes('POST')
              ? 'GET'
              : 'POST';
            const localVarRequestOptions = { method, ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "userToken", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(plbscfデータRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 認証/認可トークンのt企業と指定データpkに紐付くtデータを更新します
         * @summary データ更新
         * @param {number} データpk 
         * @param {データRequest} データrequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateデータ: async (データpk: number, データrequest: データRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'データpk' is not null or undefined
            assertParamExists('updateデータ', 'データpk', データpk)
            // verify required parameter 'データrequest' is not null or undefined
            assertParamExists('updateデータ', 'データrequest', データrequest)
            let localVarPath = `/データ/{データpk}`
                .replace(`{${"データpk"}}`, encodeURIComponent(String(データpk)));
            if (process.env.VUE_APP_IS_MOCK === "true") localVarPath = ApiUtility.convertSampleUrl('PUT', '/データ/{データpk}', options);
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            // jsonファイルアクセス時、PUT/DELETEの場合apacheの仕様（default-handler）で弾かれてしまうため、GETへ変換している
            const method = process.env.VUE_APP_IS_MOCK === "true" && ['PUT', 'DELETE'].includes('PUT')
              ? 'GET'
              : 'PUT';
            const localVarRequestOptions = { method, ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "userToken", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(データrequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * データApi - functional programming interface
 * @export
 */
export const データApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = データApiAxiosParamCreator(configuration)
    return {
        /**
         * 認証/認可トークンのt企業、指定計画書データpkに紐付くtデータを一括保存します
         * @summary データ一括保存
         * @param {number} 計画書データpk 
         * @param {Array<データListItemRequest>} データlistItemRequest データ一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkSaveデータ(計画書データpk: number, データlistItemRequest: Array<データListItemRequest>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkSaveデータ(計画書データpk, データlistItemRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 認証/認可トークンのt企業、指定計画書データpkに紐付くtデータを保存します
         * @summary データ作成
         * @param {number} 計画書データpk 
         * @param {データRequest} データrequest データ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createデータ(計画書データpk: number, データrequest: データRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createデータ(計画書データpk, データrequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 認証/認可トークンのt企業と指定データpkに紐付くtデータを削除します
         * @summary データ削除
         * @param {number} データpk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteデータ(データpk: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteデータ(データpk, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 認証/認可トークンのt企業、指定計画書データpkと検索条件で絞り込んだtデータの一覧をc入力分類、c番号の昇順で取得します
         * @summary データ一覧
         * @param {number} 計画書データpk 
         * @param {Array<E入力分類>} 入力分類 
         * @param {Eフェーズ種別} [フェーズ種別] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listデータ(計画書データpk: number, 入力分類: Array<E入力分類>, フェーズ種別?: Eフェーズ種別, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<データListItemResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listデータ(計画書データpk, 入力分類, フェーズ種別, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 認証/認可トークンのt企業、指定計画書データpkに紐付くc入力分類=PLBSCFのtデータを保存します<br /> ※更新登録時は、cデータの一部を上書き保存します
         * @summary PLBSCFデータ保存
         * @param {number} 計画書データpk 
         * @param {PlbscfデータRequest} plbscfデータRequest データ一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async savePlbscfデータ(計画書データpk: number, plbscfデータRequest: PlbscfデータRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.savePlbscfデータ(計画書データpk, plbscfデータRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 認証/認可トークンのt企業と指定データpkに紐付くtデータを更新します
         * @summary データ更新
         * @param {number} データpk 
         * @param {データRequest} データrequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateデータ(データpk: number, データrequest: データRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateデータ(データpk, データrequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * データApi - factory interface
 * @export
 */
export const データApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = データApiFp(configuration)
    return {
        /**
         * 認証/認可トークンのt企業、指定計画書データpkに紐付くtデータを一括保存します
         * @summary データ一括保存
         * @param {number} 計画書データpk 
         * @param {Array<データListItemRequest>} データlistItemRequest データ一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkSaveデータ(計画書データpk: number, データlistItemRequest: Array<データListItemRequest>, options?: any): AxiosPromise<void> {
            return localVarFp.bulkSaveデータ(計画書データpk, データlistItemRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 認証/認可トークンのt企業、指定計画書データpkに紐付くtデータを保存します
         * @summary データ作成
         * @param {number} 計画書データpk 
         * @param {データRequest} データrequest データ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createデータ(計画書データpk: number, データrequest: データRequest, options?: any): AxiosPromise<void> {
            return localVarFp.createデータ(計画書データpk, データrequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 認証/認可トークンのt企業と指定データpkに紐付くtデータを削除します
         * @summary データ削除
         * @param {number} データpk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteデータ(データpk: number, options?: any): AxiosPromise<void> {
            return localVarFp.deleteデータ(データpk, options).then((request) => request(axios, basePath));
        },
        /**
         * 認証/認可トークンのt企業、指定計画書データpkと検索条件で絞り込んだtデータの一覧をc入力分類、c番号の昇順で取得します
         * @summary データ一覧
         * @param {number} 計画書データpk 
         * @param {Array<E入力分類>} 入力分類 
         * @param {Eフェーズ種別} [フェーズ種別] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listデータ(計画書データpk: number, 入力分類: Array<E入力分類>, フェーズ種別?: Eフェーズ種別, options?: any): AxiosPromise<Array<データListItemResponse>> {
            return localVarFp.listデータ(計画書データpk, 入力分類, フェーズ種別, options).then((request) => request(axios, basePath));
        },
        /**
         * 認証/認可トークンのt企業、指定計画書データpkに紐付くc入力分類=PLBSCFのtデータを保存します<br /> ※更新登録時は、cデータの一部を上書き保存します
         * @summary PLBSCFデータ保存
         * @param {number} 計画書データpk 
         * @param {PlbscfデータRequest} plbscfデータRequest データ一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePlbscfデータ(計画書データpk: number, plbscfデータRequest: PlbscfデータRequest, options?: any): AxiosPromise<void> {
            return localVarFp.savePlbscfデータ(計画書データpk, plbscfデータRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 認証/認可トークンのt企業と指定データpkに紐付くtデータを更新します
         * @summary データ更新
         * @param {number} データpk 
         * @param {データRequest} データrequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateデータ(データpk: number, データrequest: データRequest, options?: any): AxiosPromise<void> {
            return localVarFp.updateデータ(データpk, データrequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * データApi - object-oriented interface
 * @export
 * @class データApi
 * @extends {BaseAPI}
 */
export class データApi extends BaseAPI {
    /**
     * 認証/認可トークンのt企業、指定計画書データpkに紐付くtデータを一括保存します
     * @summary データ一括保存
     * @param {number} 計画書データpk 
     * @param {Array<データListItemRequest>} データlistItemRequest データ一覧
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof データApi
     */
    public bulkSaveデータ(計画書データpk: number, データlistItemRequest: Array<データListItemRequest>, options?: AxiosRequestConfig) {
        return データApiFp(this.configuration).bulkSaveデータ(計画書データpk, データlistItemRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 認証/認可トークンのt企業、指定計画書データpkに紐付くtデータを保存します
     * @summary データ作成
     * @param {number} 計画書データpk 
     * @param {データRequest} データrequest データ
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof データApi
     */
    public createデータ(計画書データpk: number, データrequest: データRequest, options?: AxiosRequestConfig) {
        return データApiFp(this.configuration).createデータ(計画書データpk, データrequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 認証/認可トークンのt企業と指定データpkに紐付くtデータを削除します
     * @summary データ削除
     * @param {number} データpk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof データApi
     */
    public deleteデータ(データpk: number, options?: AxiosRequestConfig) {
        return データApiFp(this.configuration).deleteデータ(データpk, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 認証/認可トークンのt企業、指定計画書データpkと検索条件で絞り込んだtデータの一覧をc入力分類、c番号の昇順で取得します
     * @summary データ一覧
     * @param {number} 計画書データpk 
     * @param {Array<E入力分類>} 入力分類 
     * @param {Eフェーズ種別} [フェーズ種別] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof データApi
     */
    public listデータ(計画書データpk: number, 入力分類: Array<E入力分類>, フェーズ種別?: Eフェーズ種別, options?: AxiosRequestConfig) {
        return データApiFp(this.configuration).listデータ(計画書データpk, 入力分類, フェーズ種別, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 認証/認可トークンのt企業、指定計画書データpkに紐付くc入力分類=PLBSCFのtデータを保存します<br /> ※更新登録時は、cデータの一部を上書き保存します
     * @summary PLBSCFデータ保存
     * @param {number} 計画書データpk 
     * @param {PlbscfデータRequest} plbscfデータRequest データ一覧
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof データApi
     */
    public savePlbscfデータ(計画書データpk: number, plbscfデータRequest: PlbscfデータRequest, options?: AxiosRequestConfig) {
        return データApiFp(this.configuration).savePlbscfデータ(計画書データpk, plbscfデータRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 認証/認可トークンのt企業と指定データpkに紐付くtデータを更新します
     * @summary データ更新
     * @param {number} データpk 
     * @param {データRequest} データrequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof データApi
     */
    public updateデータ(データpk: number, データrequest: データRequest, options?: AxiosRequestConfig) {
        return データApiFp(this.configuration).updateデータ(データpk, データrequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ユーザーApi - axios parameter creator
 * @export
 */
export const ユーザーApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * ※ cユーザー権限＝管理者のみ使用可能<br /> 入力情報から認証/認可トークンのt企業に紐付くtユーザーを作成します
         * @summary ユーザー作成
         * @param {ユーザーRequest} ユーザーrequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createユーザー: async (ユーザーrequest: ユーザーRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ユーザーrequest' is not null or undefined
            assertParamExists('createユーザー', 'ユーザーrequest', ユーザーrequest)
            let localVarPath = `/ユーザー`;
            if (process.env.VUE_APP_IS_MOCK === "true") localVarPath = ApiUtility.convertSampleUrl('POST', '/ユーザー', options);
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            // jsonファイルアクセス時、PUT/DELETEの場合apacheの仕様（default-handler）で弾かれてしまうため、GETへ変換している
            const method = process.env.VUE_APP_IS_MOCK === "true" && ['PUT', 'DELETE'].includes('POST')
              ? 'GET'
              : 'POST';
            const localVarRequestOptions = { method, ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "userToken", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ユーザーrequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ※ cユーザー権限＝管理者のみ使用可能<br /> 認証/認可トークンのt企業とユーザーpkに紐付くtユーザーを削除します
         * @summary ユーザー削除
         * @param {number} ユーザーpk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteユーザー: async (ユーザーpk: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ユーザーpk' is not null or undefined
            assertParamExists('deleteユーザー', 'ユーザーpk', ユーザーpk)
            let localVarPath = `/ユーザー/{ユーザーpk}`
                .replace(`{${"ユーザーpk"}}`, encodeURIComponent(String(ユーザーpk)));
            if (process.env.VUE_APP_IS_MOCK === "true") localVarPath = ApiUtility.convertSampleUrl('DELETE', '/ユーザー/{ユーザーpk}', options);
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            // jsonファイルアクセス時、PUT/DELETEの場合apacheの仕様（default-handler）で弾かれてしまうため、GETへ変換している
            const method = process.env.VUE_APP_IS_MOCK === "true" && ['PUT', 'DELETE'].includes('DELETE')
              ? 'GET'
              : 'DELETE';
            const localVarRequestOptions = { method, ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "userToken", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ※ cユーザー権限＝管理者のみ使用可能<br /> 認証/認可トークンのt企業に紐付くcユーザー権限が通常または管理者のtユーザーの一覧をcライセンス番号の昇順で取得します
         * @summary ユーザー一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listユーザー: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            let localVarPath = `/ユーザー`;
            if (process.env.VUE_APP_IS_MOCK === "true") localVarPath = ApiUtility.convertSampleUrl('GET', '/ユーザー', options);
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            // jsonファイルアクセス時、PUT/DELETEの場合apacheの仕様（default-handler）で弾かれてしまうため、GETへ変換している
            const method = process.env.VUE_APP_IS_MOCK === "true" && ['PUT', 'DELETE'].includes('GET')
              ? 'GET'
              : 'GET';
            const localVarRequestOptions = { method, ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "userToken", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * パスワード再設定用トークン(JWT)に紐付くユーザーのパスワードを再設定します
         * @summary パスワード再設定
         * @param {PasswordResetRequest} passwordResetRequest パスワード情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword: async (passwordResetRequest: PasswordResetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'passwordResetRequest' is not null or undefined
            assertParamExists('resetPassword', 'passwordResetRequest', passwordResetRequest)
            let localVarPath = `/ユーザー/passwordReset`;
            if (process.env.VUE_APP_IS_MOCK === "true") localVarPath = ApiUtility.convertSampleUrl('PUT', '/ユーザー/passwordReset', options);
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            // jsonファイルアクセス時、PUT/DELETEの場合apacheの仕様（default-handler）で弾かれてしまうため、GETへ変換している
            const method = process.env.VUE_APP_IS_MOCK === "true" && ['PUT', 'DELETE'].includes('PUT')
              ? 'GET'
              : 'PUT';
            const localVarRequestOptions = { method, ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(passwordResetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * パスワード再設定用トークン(JWT、60分有効)を発行し、入力メールアドレス宛てにパスワード再設定用のURLをメール送信します
         * @summary パスワード再設定メール送信
         * @param {ユーザーメールアドレスRequest} ユーザーメールアドレスrequest メールアドレス
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendPasswordResetMail: async (ユーザーメールアドレスrequest: ユーザーメールアドレスRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ユーザーメールアドレスrequest' is not null or undefined
            assertParamExists('sendPasswordResetMail', 'ユーザーメールアドレスrequest', ユーザーメールアドレスrequest)
            let localVarPath = `/ユーザー/passwordReset`;
            if (process.env.VUE_APP_IS_MOCK === "true") localVarPath = ApiUtility.convertSampleUrl('POST', '/ユーザー/passwordReset', options);
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            // jsonファイルアクセス時、PUT/DELETEの場合apacheの仕様（default-handler）で弾かれてしまうため、GETへ変換している
            const method = process.env.VUE_APP_IS_MOCK === "true" && ['PUT', 'DELETE'].includes('POST')
              ? 'GET'
              : 'POST';
            const localVarRequestOptions = { method, ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ユーザーメールアドレスrequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 認証/認可トークンのtユーザーとt企業を取得します
         * @summary 認証済ユーザー情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        showMe: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            let localVarPath = `/ユーザー/me`;
            if (process.env.VUE_APP_IS_MOCK === "true") localVarPath = ApiUtility.convertSampleUrl('GET', '/ユーザー/me', options);
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            // jsonファイルアクセス時、PUT/DELETEの場合apacheの仕様（default-handler）で弾かれてしまうため、GETへ変換している
            const method = process.env.VUE_APP_IS_MOCK === "true" && ['PUT', 'DELETE'].includes('GET')
              ? 'GET'
              : 'GET';
            const localVarRequestOptions = { method, ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "userToken", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ユーザーApi - functional programming interface
 * @export
 */
export const ユーザーApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ユーザーApiAxiosParamCreator(configuration)
    return {
        /**
         * ※ cユーザー権限＝管理者のみ使用可能<br /> 入力情報から認証/認可トークンのt企業に紐付くtユーザーを作成します
         * @summary ユーザー作成
         * @param {ユーザーRequest} ユーザーrequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createユーザー(ユーザーrequest: ユーザーRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createユーザー(ユーザーrequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ※ cユーザー権限＝管理者のみ使用可能<br /> 認証/認可トークンのt企業とユーザーpkに紐付くtユーザーを削除します
         * @summary ユーザー削除
         * @param {number} ユーザーpk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteユーザー(ユーザーpk: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteユーザー(ユーザーpk, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ※ cユーザー権限＝管理者のみ使用可能<br /> 認証/認可トークンのt企業に紐付くcユーザー権限が通常または管理者のtユーザーの一覧をcライセンス番号の昇順で取得します
         * @summary ユーザー一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listユーザー(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ユーザーListItemResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listユーザー(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * パスワード再設定用トークン(JWT)に紐付くユーザーのパスワードを再設定します
         * @summary パスワード再設定
         * @param {PasswordResetRequest} passwordResetRequest パスワード情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetPassword(passwordResetRequest: PasswordResetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetPassword(passwordResetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * パスワード再設定用トークン(JWT、60分有効)を発行し、入力メールアドレス宛てにパスワード再設定用のURLをメール送信します
         * @summary パスワード再設定メール送信
         * @param {ユーザーメールアドレスRequest} ユーザーメールアドレスrequest メールアドレス
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendPasswordResetMail(ユーザーメールアドレスrequest: ユーザーメールアドレスRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendPasswordResetMail(ユーザーメールアドレスrequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 認証/認可トークンのtユーザーとt企業を取得します
         * @summary 認証済ユーザー情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async showMe(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ユーザーMeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.showMe(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ユーザーApi - factory interface
 * @export
 */
export const ユーザーApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ユーザーApiFp(configuration)
    return {
        /**
         * ※ cユーザー権限＝管理者のみ使用可能<br /> 入力情報から認証/認可トークンのt企業に紐付くtユーザーを作成します
         * @summary ユーザー作成
         * @param {ユーザーRequest} ユーザーrequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createユーザー(ユーザーrequest: ユーザーRequest, options?: any): AxiosPromise<void> {
            return localVarFp.createユーザー(ユーザーrequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ※ cユーザー権限＝管理者のみ使用可能<br /> 認証/認可トークンのt企業とユーザーpkに紐付くtユーザーを削除します
         * @summary ユーザー削除
         * @param {number} ユーザーpk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteユーザー(ユーザーpk: number, options?: any): AxiosPromise<void> {
            return localVarFp.deleteユーザー(ユーザーpk, options).then((request) => request(axios, basePath));
        },
        /**
         * ※ cユーザー権限＝管理者のみ使用可能<br /> 認証/認可トークンのt企業に紐付くcユーザー権限が通常または管理者のtユーザーの一覧をcライセンス番号の昇順で取得します
         * @summary ユーザー一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listユーザー(options?: any): AxiosPromise<Array<ユーザーListItemResponse>> {
            return localVarFp.listユーザー(options).then((request) => request(axios, basePath));
        },
        /**
         * パスワード再設定用トークン(JWT)に紐付くユーザーのパスワードを再設定します
         * @summary パスワード再設定
         * @param {PasswordResetRequest} passwordResetRequest パスワード情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword(passwordResetRequest: PasswordResetRequest, options?: any): AxiosPromise<void> {
            return localVarFp.resetPassword(passwordResetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * パスワード再設定用トークン(JWT、60分有効)を発行し、入力メールアドレス宛てにパスワード再設定用のURLをメール送信します
         * @summary パスワード再設定メール送信
         * @param {ユーザーメールアドレスRequest} ユーザーメールアドレスrequest メールアドレス
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendPasswordResetMail(ユーザーメールアドレスrequest: ユーザーメールアドレスRequest, options?: any): AxiosPromise<void> {
            return localVarFp.sendPasswordResetMail(ユーザーメールアドレスrequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 認証/認可トークンのtユーザーとt企業を取得します
         * @summary 認証済ユーザー情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        showMe(options?: any): AxiosPromise<ユーザーMeResponse> {
            return localVarFp.showMe(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ユーザーApi - object-oriented interface
 * @export
 * @class ユーザーApi
 * @extends {BaseAPI}
 */
export class ユーザーApi extends BaseAPI {
    /**
     * ※ cユーザー権限＝管理者のみ使用可能<br /> 入力情報から認証/認可トークンのt企業に紐付くtユーザーを作成します
     * @summary ユーザー作成
     * @param {ユーザーRequest} ユーザーrequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ユーザーApi
     */
    public createユーザー(ユーザーrequest: ユーザーRequest, options?: AxiosRequestConfig) {
        return ユーザーApiFp(this.configuration).createユーザー(ユーザーrequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ※ cユーザー権限＝管理者のみ使用可能<br /> 認証/認可トークンのt企業とユーザーpkに紐付くtユーザーを削除します
     * @summary ユーザー削除
     * @param {number} ユーザーpk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ユーザーApi
     */
    public deleteユーザー(ユーザーpk: number, options?: AxiosRequestConfig) {
        return ユーザーApiFp(this.configuration).deleteユーザー(ユーザーpk, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ※ cユーザー権限＝管理者のみ使用可能<br /> 認証/認可トークンのt企業に紐付くcユーザー権限が通常または管理者のtユーザーの一覧をcライセンス番号の昇順で取得します
     * @summary ユーザー一覧
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ユーザーApi
     */
    public listユーザー(options?: AxiosRequestConfig) {
        return ユーザーApiFp(this.configuration).listユーザー(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * パスワード再設定用トークン(JWT)に紐付くユーザーのパスワードを再設定します
     * @summary パスワード再設定
     * @param {PasswordResetRequest} passwordResetRequest パスワード情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ユーザーApi
     */
    public resetPassword(passwordResetRequest: PasswordResetRequest, options?: AxiosRequestConfig) {
        return ユーザーApiFp(this.configuration).resetPassword(passwordResetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * パスワード再設定用トークン(JWT、60分有効)を発行し、入力メールアドレス宛てにパスワード再設定用のURLをメール送信します
     * @summary パスワード再設定メール送信
     * @param {ユーザーメールアドレスRequest} ユーザーメールアドレスrequest メールアドレス
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ユーザーApi
     */
    public sendPasswordResetMail(ユーザーメールアドレスrequest: ユーザーメールアドレスRequest, options?: AxiosRequestConfig) {
        return ユーザーApiFp(this.configuration).sendPasswordResetMail(ユーザーメールアドレスrequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 認証/認可トークンのtユーザーとt企業を取得します
     * @summary 認証済ユーザー情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ユーザーApi
     */
    public showMe(options?: AxiosRequestConfig) {
        return ユーザーApiFp(this.configuration).showMe(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * 事業所Api - axios parameter creator
 * @export
 */
export const 事業所ApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 事業所情報のバックアップを行います<br /> ※Media typeのプルダウンは異常系確認時にはapplication/json、正常系確認時はその他に切り替えてください
         * @summary 事業所バックアップ
         * @param {number} 事業所pk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        backup事業所: async (事業所pk: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter '事業所pk' is not null or undefined
            assertParamExists('backup事業所', '事業所pk', 事業所pk)
            let localVarPath = `/事業所/{事業所pk}/backup`
                .replace(`{${"事業所pk"}}`, encodeURIComponent(String(事業所pk)));
            if (process.env.VUE_APP_IS_MOCK === "true") localVarPath = ApiUtility.convertSampleUrl('POST', '/事業所/{事業所pk}/backup', options);
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            // jsonファイルアクセス時、PUT/DELETEの場合apacheの仕様（default-handler）で弾かれてしまうため、GETへ変換している
            const method = process.env.VUE_APP_IS_MOCK === "true" && ['PUT', 'DELETE'].includes('POST')
              ? 'GET'
              : 'POST';
            const localVarRequestOptions = { method, ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "userToken", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 認証/認可トークンのt企業に紐付くt事業所を作成します
         * @summary 事業所作成
         * @param {事業所Request} 事業所request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create事業所: async (事業所request: 事業所Request, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter '事業所request' is not null or undefined
            assertParamExists('create事業所', '事業所request', 事業所request)
            let localVarPath = `/事業所`;
            if (process.env.VUE_APP_IS_MOCK === "true") localVarPath = ApiUtility.convertSampleUrl('POST', '/事業所', options);
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            // jsonファイルアクセス時、PUT/DELETEの場合apacheの仕様（default-handler）で弾かれてしまうため、GETへ変換している
            const method = process.env.VUE_APP_IS_MOCK === "true" && ['PUT', 'DELETE'].includes('POST')
              ? 'GET'
              : 'POST';
            const localVarRequestOptions = { method, ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "userToken", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(事業所request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 認証/認可トークンのt企業に紐付く有効なt事業所の一覧をc事業所コードの昇順で取得します
         * @summary 事業所一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list事業所: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            let localVarPath = `/事業所`;
            if (process.env.VUE_APP_IS_MOCK === "true") localVarPath = ApiUtility.convertSampleUrl('GET', '/事業所', options);
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            // jsonファイルアクセス時、PUT/DELETEの場合apacheの仕様（default-handler）で弾かれてしまうため、GETへ変換している
            const method = process.env.VUE_APP_IS_MOCK === "true" && ['PUT', 'DELETE'].includes('GET')
              ? 'GET'
              : 'GET';
            const localVarRequestOptions = { method, ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "userToken", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 認証/認可トークンのt企業と指定事業所pkに紐付くt事業所を論理削除します
         * @summary 事業所論理削除
         * @param {number} 事業所pk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logicalDelete事業所: async (事業所pk: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter '事業所pk' is not null or undefined
            assertParamExists('logicalDelete事業所', '事業所pk', 事業所pk)
            let localVarPath = `/事業所/{事業所pk}`
                .replace(`{${"事業所pk"}}`, encodeURIComponent(String(事業所pk)));
            if (process.env.VUE_APP_IS_MOCK === "true") localVarPath = ApiUtility.convertSampleUrl('DELETE', '/事業所/{事業所pk}', options);
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            // jsonファイルアクセス時、PUT/DELETEの場合apacheの仕様（default-handler）で弾かれてしまうため、GETへ変換している
            const method = process.env.VUE_APP_IS_MOCK === "true" && ['PUT', 'DELETE'].includes('DELETE')
              ? 'GET'
              : 'DELETE';
            const localVarRequestOptions = { method, ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "userToken", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 認証/認可トークンのt企業と指定事業所pkに紐付く有効なt事業所を取得します
         * @summary 事業所詳細
         * @param {number} 事業所pk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        show事業所: async (事業所pk: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter '事業所pk' is not null or undefined
            assertParamExists('show事業所', '事業所pk', 事業所pk)
            let localVarPath = `/事業所/{事業所pk}`
                .replace(`{${"事業所pk"}}`, encodeURIComponent(String(事業所pk)));
            if (process.env.VUE_APP_IS_MOCK === "true") localVarPath = ApiUtility.convertSampleUrl('GET', '/事業所/{事業所pk}', options);
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            // jsonファイルアクセス時、PUT/DELETEの場合apacheの仕様（default-handler）で弾かれてしまうため、GETへ変換している
            const method = process.env.VUE_APP_IS_MOCK === "true" && ['PUT', 'DELETE'].includes('GET')
              ? 'GET'
              : 'GET';
            const localVarRequestOptions = { method, ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "userToken", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 認証/認可トークンのt企業と指定事業所pkに紐付く有効なt事業所を更新します
         * @summary 事業所更新
         * @param {number} 事業所pk 
         * @param {事業所Request} 事業所request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update事業所: async (事業所pk: number, 事業所request: 事業所Request, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter '事業所pk' is not null or undefined
            assertParamExists('update事業所', '事業所pk', 事業所pk)
            // verify required parameter '事業所request' is not null or undefined
            assertParamExists('update事業所', '事業所request', 事業所request)
            let localVarPath = `/事業所/{事業所pk}`
                .replace(`{${"事業所pk"}}`, encodeURIComponent(String(事業所pk)));
            if (process.env.VUE_APP_IS_MOCK === "true") localVarPath = ApiUtility.convertSampleUrl('PUT', '/事業所/{事業所pk}', options);
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            // jsonファイルアクセス時、PUT/DELETEの場合apacheの仕様（default-handler）で弾かれてしまうため、GETへ変換している
            const method = process.env.VUE_APP_IS_MOCK === "true" && ['PUT', 'DELETE'].includes('PUT')
              ? 'GET'
              : 'PUT';
            const localVarRequestOptions = { method, ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "userToken", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(事業所request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 認証/認可トークンのt企業と指定事業所pkに紐付く有効なt事業所の cアクセス日時を現在日時、cアクセスユーザーpkを認証/認可トークンのtユーザーの情報で更新します
         * @summary 事業所メニューログ更新
         * @param {number} 事業所pk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update事業所MenuLog: async (事業所pk: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter '事業所pk' is not null or undefined
            assertParamExists('update事業所MenuLog', '事業所pk', 事業所pk)
            let localVarPath = `/事業所/{事業所pk}/menuLog`
                .replace(`{${"事業所pk"}}`, encodeURIComponent(String(事業所pk)));
            if (process.env.VUE_APP_IS_MOCK === "true") localVarPath = ApiUtility.convertSampleUrl('PUT', '/事業所/{事業所pk}/menuLog', options);
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            // jsonファイルアクセス時、PUT/DELETEの場合apacheの仕様（default-handler）で弾かれてしまうため、GETへ変換している
            const method = process.env.VUE_APP_IS_MOCK === "true" && ['PUT', 'DELETE'].includes('PUT')
              ? 'GET'
              : 'PUT';
            const localVarRequestOptions = { method, ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "userToken", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * 事業所Api - functional programming interface
 * @export
 */
export const 事業所ApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = 事業所ApiAxiosParamCreator(configuration)
    return {
        /**
         * 事業所情報のバックアップを行います<br /> ※Media typeのプルダウンは異常系確認時にはapplication/json、正常系確認時はその他に切り替えてください
         * @summary 事業所バックアップ
         * @param {number} 事業所pk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async backup事業所(事業所pk: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.backup事業所(事業所pk, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 認証/認可トークンのt企業に紐付くt事業所を作成します
         * @summary 事業所作成
         * @param {事業所Request} 事業所request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create事業所(事業所request: 事業所Request, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create事業所(事業所request, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 認証/認可トークンのt企業に紐付く有効なt事業所の一覧をc事業所コードの昇順で取得します
         * @summary 事業所一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async list事業所(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<事業所ListItemResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.list事業所(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 認証/認可トークンのt企業と指定事業所pkに紐付くt事業所を論理削除します
         * @summary 事業所論理削除
         * @param {number} 事業所pk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logicalDelete事業所(事業所pk: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logicalDelete事業所(事業所pk, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 認証/認可トークンのt企業と指定事業所pkに紐付く有効なt事業所を取得します
         * @summary 事業所詳細
         * @param {number} 事業所pk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async show事業所(事業所pk: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<事業所Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.show事業所(事業所pk, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 認証/認可トークンのt企業と指定事業所pkに紐付く有効なt事業所を更新します
         * @summary 事業所更新
         * @param {number} 事業所pk 
         * @param {事業所Request} 事業所request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update事業所(事業所pk: number, 事業所request: 事業所Request, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update事業所(事業所pk, 事業所request, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 認証/認可トークンのt企業と指定事業所pkに紐付く有効なt事業所の cアクセス日時を現在日時、cアクセスユーザーpkを認証/認可トークンのtユーザーの情報で更新します
         * @summary 事業所メニューログ更新
         * @param {number} 事業所pk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update事業所MenuLog(事業所pk: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<事業所Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update事業所MenuLog(事業所pk, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * 事業所Api - factory interface
 * @export
 */
export const 事業所ApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = 事業所ApiFp(configuration)
    return {
        /**
         * 事業所情報のバックアップを行います<br /> ※Media typeのプルダウンは異常系確認時にはapplication/json、正常系確認時はその他に切り替えてください
         * @summary 事業所バックアップ
         * @param {number} 事業所pk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        backup事業所(事業所pk: number, options?: any): AxiosPromise<any> {
            return localVarFp.backup事業所(事業所pk, options).then((request) => request(axios, basePath));
        },
        /**
         * 認証/認可トークンのt企業に紐付くt事業所を作成します
         * @summary 事業所作成
         * @param {事業所Request} 事業所request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create事業所(事業所request: 事業所Request, options?: any): AxiosPromise<void> {
            return localVarFp.create事業所(事業所request, options).then((request) => request(axios, basePath));
        },
        /**
         * 認証/認可トークンのt企業に紐付く有効なt事業所の一覧をc事業所コードの昇順で取得します
         * @summary 事業所一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list事業所(options?: any): AxiosPromise<Array<事業所ListItemResponse>> {
            return localVarFp.list事業所(options).then((request) => request(axios, basePath));
        },
        /**
         * 認証/認可トークンのt企業と指定事業所pkに紐付くt事業所を論理削除します
         * @summary 事業所論理削除
         * @param {number} 事業所pk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logicalDelete事業所(事業所pk: number, options?: any): AxiosPromise<void> {
            return localVarFp.logicalDelete事業所(事業所pk, options).then((request) => request(axios, basePath));
        },
        /**
         * 認証/認可トークンのt企業と指定事業所pkに紐付く有効なt事業所を取得します
         * @summary 事業所詳細
         * @param {number} 事業所pk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        show事業所(事業所pk: number, options?: any): AxiosPromise<事業所Response> {
            return localVarFp.show事業所(事業所pk, options).then((request) => request(axios, basePath));
        },
        /**
         * 認証/認可トークンのt企業と指定事業所pkに紐付く有効なt事業所を更新します
         * @summary 事業所更新
         * @param {number} 事業所pk 
         * @param {事業所Request} 事業所request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update事業所(事業所pk: number, 事業所request: 事業所Request, options?: any): AxiosPromise<void> {
            return localVarFp.update事業所(事業所pk, 事業所request, options).then((request) => request(axios, basePath));
        },
        /**
         * 認証/認可トークンのt企業と指定事業所pkに紐付く有効なt事業所の cアクセス日時を現在日時、cアクセスユーザーpkを認証/認可トークンのtユーザーの情報で更新します
         * @summary 事業所メニューログ更新
         * @param {number} 事業所pk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update事業所MenuLog(事業所pk: number, options?: any): AxiosPromise<事業所Response> {
            return localVarFp.update事業所MenuLog(事業所pk, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * 事業所Api - object-oriented interface
 * @export
 * @class 事業所Api
 * @extends {BaseAPI}
 */
export class 事業所Api extends BaseAPI {
    /**
     * 事業所情報のバックアップを行います<br /> ※Media typeのプルダウンは異常系確認時にはapplication/json、正常系確認時はその他に切り替えてください
     * @summary 事業所バックアップ
     * @param {number} 事業所pk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof 事業所Api
     */
    public backup事業所(事業所pk: number, options?: AxiosRequestConfig) {
        return 事業所ApiFp(this.configuration).backup事業所(事業所pk, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 認証/認可トークンのt企業に紐付くt事業所を作成します
     * @summary 事業所作成
     * @param {事業所Request} 事業所request 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof 事業所Api
     */
    public create事業所(事業所request: 事業所Request, options?: AxiosRequestConfig) {
        return 事業所ApiFp(this.configuration).create事業所(事業所request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 認証/認可トークンのt企業に紐付く有効なt事業所の一覧をc事業所コードの昇順で取得します
     * @summary 事業所一覧
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof 事業所Api
     */
    public list事業所(options?: AxiosRequestConfig) {
        return 事業所ApiFp(this.configuration).list事業所(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 認証/認可トークンのt企業と指定事業所pkに紐付くt事業所を論理削除します
     * @summary 事業所論理削除
     * @param {number} 事業所pk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof 事業所Api
     */
    public logicalDelete事業所(事業所pk: number, options?: AxiosRequestConfig) {
        return 事業所ApiFp(this.configuration).logicalDelete事業所(事業所pk, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 認証/認可トークンのt企業と指定事業所pkに紐付く有効なt事業所を取得します
     * @summary 事業所詳細
     * @param {number} 事業所pk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof 事業所Api
     */
    public show事業所(事業所pk: number, options?: AxiosRequestConfig) {
        return 事業所ApiFp(this.configuration).show事業所(事業所pk, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 認証/認可トークンのt企業と指定事業所pkに紐付く有効なt事業所を更新します
     * @summary 事業所更新
     * @param {number} 事業所pk 
     * @param {事業所Request} 事業所request 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof 事業所Api
     */
    public update事業所(事業所pk: number, 事業所request: 事業所Request, options?: AxiosRequestConfig) {
        return 事業所ApiFp(this.configuration).update事業所(事業所pk, 事業所request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 認証/認可トークンのt企業と指定事業所pkに紐付く有効なt事業所の cアクセス日時を現在日時、cアクセスユーザーpkを認証/認可トークンのtユーザーの情報で更新します
     * @summary 事業所メニューログ更新
     * @param {number} 事業所pk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof 事業所Api
     */
    public update事業所MenuLog(事業所pk: number, options?: AxiosRequestConfig) {
        return 事業所ApiFp(this.configuration).update事業所MenuLog(事業所pk, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * 勘定科目Api - axios parameter creator
 * @export
 */
export const 勘定科目ApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 以下の場合に、認証/認可トークンのt企業と指定勘定科目pkに紐付くt勘定科目のc科目別計画フラグを1：ありに更新します<br /> t勘定科目.cカテゴリ＝1：損益<br /> t勘定科目.cカテゴリ＝2：製造原価
         * @summary 勘定科目科目別計画フラグ活性化
         * @param {number} 勘定科目pk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activate勘定科目科目別計画フラグ: async (勘定科目pk: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter '勘定科目pk' is not null or undefined
            assertParamExists('activate勘定科目科目別計画フラグ', '勘定科目pk', 勘定科目pk)
            let localVarPath = `/勘定科目/{勘定科目pk}/科目別計画フラグ`
                .replace(`{${"勘定科目pk"}}`, encodeURIComponent(String(勘定科目pk)));
            if (process.env.VUE_APP_IS_MOCK === "true") localVarPath = ApiUtility.convertSampleUrl('PUT', '/勘定科目/{勘定科目pk}/科目別計画フラグ', options);
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            // jsonファイルアクセス時、PUT/DELETEの場合apacheの仕様（default-handler）で弾かれてしまうため、GETへ変換している
            const method = process.env.VUE_APP_IS_MOCK === "true" && ['PUT', 'DELETE'].includes('PUT')
              ? 'GET'
              : 'PUT';
            const localVarRequestOptions = { method, ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "userToken", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 認証/認可トークンのt企業と指定事業所pkに紐付くt勘定科目を作成します
         * @summary 勘定科目作成
         * @param {number} 事業所pk 
         * @param {勘定科目Request} 勘定科目request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create勘定科目: async (事業所pk: number, 勘定科目request: 勘定科目Request, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter '事業所pk' is not null or undefined
            assertParamExists('create勘定科目', '事業所pk', 事業所pk)
            // verify required parameter '勘定科目request' is not null or undefined
            assertParamExists('create勘定科目', '勘定科目request', 勘定科目request)
            let localVarPath = `/勘定科目/{事業所pk}`
                .replace(`{${"事業所pk"}}`, encodeURIComponent(String(事業所pk)));
            if (process.env.VUE_APP_IS_MOCK === "true") localVarPath = ApiUtility.convertSampleUrl('POST', '/勘定科目/{事業所pk}', options);
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            // jsonファイルアクセス時、PUT/DELETEの場合apacheの仕様（default-handler）で弾かれてしまうため、GETへ変換している
            const method = process.env.VUE_APP_IS_MOCK === "true" && ['PUT', 'DELETE'].includes('POST')
              ? 'GET'
              : 'POST';
            const localVarRequestOptions = { method, ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "userToken", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(勘定科目request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 認証/認可トークンのt企業と指定勘定科目pkに紐付くt勘定科目を削除します<br /> 勘定科目削除の場合は、子の補助科目（同じ勘定科目をもつt勘定科目）も全て削除します<br /> 補助科目削除の場合は、指定勘定科目pkに紐付くt勘定科目だけを削除します
         * @summary 勘定科目削除
         * @param {number} 勘定科目pk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delete勘定科目: async (勘定科目pk: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter '勘定科目pk' is not null or undefined
            assertParamExists('delete勘定科目', '勘定科目pk', 勘定科目pk)
            let localVarPath = `/勘定科目/{勘定科目pk}`
                .replace(`{${"勘定科目pk"}}`, encodeURIComponent(String(勘定科目pk)));
            if (process.env.VUE_APP_IS_MOCK === "true") localVarPath = ApiUtility.convertSampleUrl('DELETE', '/勘定科目/{勘定科目pk}', options);
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            // jsonファイルアクセス時、PUT/DELETEの場合apacheの仕様（default-handler）で弾かれてしまうため、GETへ変換している
            const method = process.env.VUE_APP_IS_MOCK === "true" && ['PUT', 'DELETE'].includes('DELETE')
              ? 'GET'
              : 'DELETE';
            const localVarRequestOptions = { method, ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "userToken", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 認証/認可トークンのt企業、指定事業所pkと検索条件で絞り込んだt勘定科目の一覧をc並び順の昇順で取得します
         * @summary 勘定科目一覧
         * @param {number} 事業所pk 
         * @param {E補助科目フラグ} [補助科目フラグ] 
         * @param {E勘定科目カテゴリ} [勘定科目カテゴリ] 
         * @param {string} [勘定科目] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list勘定科目: async (事業所pk: number, 補助科目フラグ?: E補助科目フラグ, 勘定科目カテゴリ?: E勘定科目カテゴリ, 勘定科目?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter '事業所pk' is not null or undefined
            assertParamExists('list勘定科目', '事業所pk', 事業所pk)
            let localVarPath = `/勘定科目/{事業所pk}`
                .replace(`{${"事業所pk"}}`, encodeURIComponent(String(事業所pk)));
            if (process.env.VUE_APP_IS_MOCK === "true") localVarPath = ApiUtility.convertSampleUrl('GET', '/勘定科目/{事業所pk}', options);
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            // jsonファイルアクセス時、PUT/DELETEの場合apacheの仕様（default-handler）で弾かれてしまうため、GETへ変換している
            const method = process.env.VUE_APP_IS_MOCK === "true" && ['PUT', 'DELETE'].includes('GET')
              ? 'GET'
              : 'GET';
            const localVarRequestOptions = { method, ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "userToken", configuration)

            if (補助科目フラグ !== undefined) {
                localVarQueryParameter['補助科目フラグ'] = 補助科目フラグ;
            }

            if (勘定科目カテゴリ !== undefined) {
                localVarQueryParameter['勘定科目カテゴリ'] = 勘定科目カテゴリ;
            }

            if (勘定科目 !== undefined) {
                localVarQueryParameter['勘定科目'] = 勘定科目;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 認証/認可トークンのt企業と指定勘定科目pkに紐付くt勘定科目を更新します
         * @summary 勘定科目更新
         * @param {number} 勘定科目pk 
         * @param {勘定科目Request} 勘定科目request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update勘定科目: async (勘定科目pk: number, 勘定科目request: 勘定科目Request, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter '勘定科目pk' is not null or undefined
            assertParamExists('update勘定科目', '勘定科目pk', 勘定科目pk)
            // verify required parameter '勘定科目request' is not null or undefined
            assertParamExists('update勘定科目', '勘定科目request', 勘定科目request)
            let localVarPath = `/勘定科目/{勘定科目pk}`
                .replace(`{${"勘定科目pk"}}`, encodeURIComponent(String(勘定科目pk)));
            if (process.env.VUE_APP_IS_MOCK === "true") localVarPath = ApiUtility.convertSampleUrl('PUT', '/勘定科目/{勘定科目pk}', options);
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            // jsonファイルアクセス時、PUT/DELETEの場合apacheの仕様（default-handler）で弾かれてしまうため、GETへ変換している
            const method = process.env.VUE_APP_IS_MOCK === "true" && ['PUT', 'DELETE'].includes('PUT')
              ? 'GET'
              : 'PUT';
            const localVarRequestOptions = { method, ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "userToken", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(勘定科目request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 認証/認可トークンのt企業と指定勘定科目pkに紐付くt勘定科目のc並び順を一つ前のt勘定科目のc並び順と入れ替えて更新します
         * @summary 勘定科目並び順更新
         * @param {number} 勘定科目pk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update勘定科目並び順: async (勘定科目pk: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter '勘定科目pk' is not null or undefined
            assertParamExists('update勘定科目並び順', '勘定科目pk', 勘定科目pk)
            let localVarPath = `/勘定科目/{勘定科目pk}/order`
                .replace(`{${"勘定科目pk"}}`, encodeURIComponent(String(勘定科目pk)));
            if (process.env.VUE_APP_IS_MOCK === "true") localVarPath = ApiUtility.convertSampleUrl('PUT', '/勘定科目/{勘定科目pk}/order', options);
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            // jsonファイルアクセス時、PUT/DELETEの場合apacheの仕様（default-handler）で弾かれてしまうため、GETへ変換している
            const method = process.env.VUE_APP_IS_MOCK === "true" && ['PUT', 'DELETE'].includes('PUT')
              ? 'GET'
              : 'PUT';
            const localVarRequestOptions = { method, ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "userToken", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * 勘定科目Api - functional programming interface
 * @export
 */
export const 勘定科目ApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = 勘定科目ApiAxiosParamCreator(configuration)
    return {
        /**
         * 以下の場合に、認証/認可トークンのt企業と指定勘定科目pkに紐付くt勘定科目のc科目別計画フラグを1：ありに更新します<br /> t勘定科目.cカテゴリ＝1：損益<br /> t勘定科目.cカテゴリ＝2：製造原価
         * @summary 勘定科目科目別計画フラグ活性化
         * @param {number} 勘定科目pk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activate勘定科目科目別計画フラグ(勘定科目pk: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activate勘定科目科目別計画フラグ(勘定科目pk, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 認証/認可トークンのt企業と指定事業所pkに紐付くt勘定科目を作成します
         * @summary 勘定科目作成
         * @param {number} 事業所pk 
         * @param {勘定科目Request} 勘定科目request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create勘定科目(事業所pk: number, 勘定科目request: 勘定科目Request, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create勘定科目(事業所pk, 勘定科目request, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 認証/認可トークンのt企業と指定勘定科目pkに紐付くt勘定科目を削除します<br /> 勘定科目削除の場合は、子の補助科目（同じ勘定科目をもつt勘定科目）も全て削除します<br /> 補助科目削除の場合は、指定勘定科目pkに紐付くt勘定科目だけを削除します
         * @summary 勘定科目削除
         * @param {number} 勘定科目pk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delete勘定科目(勘定科目pk: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delete勘定科目(勘定科目pk, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 認証/認可トークンのt企業、指定事業所pkと検索条件で絞り込んだt勘定科目の一覧をc並び順の昇順で取得します
         * @summary 勘定科目一覧
         * @param {number} 事業所pk 
         * @param {E補助科目フラグ} [補助科目フラグ] 
         * @param {E勘定科目カテゴリ} [勘定科目カテゴリ] 
         * @param {string} [勘定科目] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async list勘定科目(事業所pk: number, 補助科目フラグ?: E補助科目フラグ, 勘定科目カテゴリ?: E勘定科目カテゴリ, 勘定科目?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<勘定科目ListItemResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.list勘定科目(事業所pk, 補助科目フラグ, 勘定科目カテゴリ, 勘定科目, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 認証/認可トークンのt企業と指定勘定科目pkに紐付くt勘定科目を更新します
         * @summary 勘定科目更新
         * @param {number} 勘定科目pk 
         * @param {勘定科目Request} 勘定科目request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update勘定科目(勘定科目pk: number, 勘定科目request: 勘定科目Request, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update勘定科目(勘定科目pk, 勘定科目request, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 認証/認可トークンのt企業と指定勘定科目pkに紐付くt勘定科目のc並び順を一つ前のt勘定科目のc並び順と入れ替えて更新します
         * @summary 勘定科目並び順更新
         * @param {number} 勘定科目pk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update勘定科目並び順(勘定科目pk: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update勘定科目並び順(勘定科目pk, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * 勘定科目Api - factory interface
 * @export
 */
export const 勘定科目ApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = 勘定科目ApiFp(configuration)
    return {
        /**
         * 以下の場合に、認証/認可トークンのt企業と指定勘定科目pkに紐付くt勘定科目のc科目別計画フラグを1：ありに更新します<br /> t勘定科目.cカテゴリ＝1：損益<br /> t勘定科目.cカテゴリ＝2：製造原価
         * @summary 勘定科目科目別計画フラグ活性化
         * @param {number} 勘定科目pk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activate勘定科目科目別計画フラグ(勘定科目pk: number, options?: any): AxiosPromise<void> {
            return localVarFp.activate勘定科目科目別計画フラグ(勘定科目pk, options).then((request) => request(axios, basePath));
        },
        /**
         * 認証/認可トークンのt企業と指定事業所pkに紐付くt勘定科目を作成します
         * @summary 勘定科目作成
         * @param {number} 事業所pk 
         * @param {勘定科目Request} 勘定科目request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create勘定科目(事業所pk: number, 勘定科目request: 勘定科目Request, options?: any): AxiosPromise<void> {
            return localVarFp.create勘定科目(事業所pk, 勘定科目request, options).then((request) => request(axios, basePath));
        },
        /**
         * 認証/認可トークンのt企業と指定勘定科目pkに紐付くt勘定科目を削除します<br /> 勘定科目削除の場合は、子の補助科目（同じ勘定科目をもつt勘定科目）も全て削除します<br /> 補助科目削除の場合は、指定勘定科目pkに紐付くt勘定科目だけを削除します
         * @summary 勘定科目削除
         * @param {number} 勘定科目pk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delete勘定科目(勘定科目pk: number, options?: any): AxiosPromise<void> {
            return localVarFp.delete勘定科目(勘定科目pk, options).then((request) => request(axios, basePath));
        },
        /**
         * 認証/認可トークンのt企業、指定事業所pkと検索条件で絞り込んだt勘定科目の一覧をc並び順の昇順で取得します
         * @summary 勘定科目一覧
         * @param {number} 事業所pk 
         * @param {E補助科目フラグ} [補助科目フラグ] 
         * @param {E勘定科目カテゴリ} [勘定科目カテゴリ] 
         * @param {string} [勘定科目] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list勘定科目(事業所pk: number, 補助科目フラグ?: E補助科目フラグ, 勘定科目カテゴリ?: E勘定科目カテゴリ, 勘定科目?: string, options?: any): AxiosPromise<Array<勘定科目ListItemResponse>> {
            return localVarFp.list勘定科目(事業所pk, 補助科目フラグ, 勘定科目カテゴリ, 勘定科目, options).then((request) => request(axios, basePath));
        },
        /**
         * 認証/認可トークンのt企業と指定勘定科目pkに紐付くt勘定科目を更新します
         * @summary 勘定科目更新
         * @param {number} 勘定科目pk 
         * @param {勘定科目Request} 勘定科目request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update勘定科目(勘定科目pk: number, 勘定科目request: 勘定科目Request, options?: any): AxiosPromise<void> {
            return localVarFp.update勘定科目(勘定科目pk, 勘定科目request, options).then((request) => request(axios, basePath));
        },
        /**
         * 認証/認可トークンのt企業と指定勘定科目pkに紐付くt勘定科目のc並び順を一つ前のt勘定科目のc並び順と入れ替えて更新します
         * @summary 勘定科目並び順更新
         * @param {number} 勘定科目pk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update勘定科目並び順(勘定科目pk: number, options?: any): AxiosPromise<void> {
            return localVarFp.update勘定科目並び順(勘定科目pk, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * 勘定科目Api - object-oriented interface
 * @export
 * @class 勘定科目Api
 * @extends {BaseAPI}
 */
export class 勘定科目Api extends BaseAPI {
    /**
     * 以下の場合に、認証/認可トークンのt企業と指定勘定科目pkに紐付くt勘定科目のc科目別計画フラグを1：ありに更新します<br /> t勘定科目.cカテゴリ＝1：損益<br /> t勘定科目.cカテゴリ＝2：製造原価
     * @summary 勘定科目科目別計画フラグ活性化
     * @param {number} 勘定科目pk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof 勘定科目Api
     */
    public activate勘定科目科目別計画フラグ(勘定科目pk: number, options?: AxiosRequestConfig) {
        return 勘定科目ApiFp(this.configuration).activate勘定科目科目別計画フラグ(勘定科目pk, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 認証/認可トークンのt企業と指定事業所pkに紐付くt勘定科目を作成します
     * @summary 勘定科目作成
     * @param {number} 事業所pk 
     * @param {勘定科目Request} 勘定科目request 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof 勘定科目Api
     */
    public create勘定科目(事業所pk: number, 勘定科目request: 勘定科目Request, options?: AxiosRequestConfig) {
        return 勘定科目ApiFp(this.configuration).create勘定科目(事業所pk, 勘定科目request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 認証/認可トークンのt企業と指定勘定科目pkに紐付くt勘定科目を削除します<br /> 勘定科目削除の場合は、子の補助科目（同じ勘定科目をもつt勘定科目）も全て削除します<br /> 補助科目削除の場合は、指定勘定科目pkに紐付くt勘定科目だけを削除します
     * @summary 勘定科目削除
     * @param {number} 勘定科目pk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof 勘定科目Api
     */
    public delete勘定科目(勘定科目pk: number, options?: AxiosRequestConfig) {
        return 勘定科目ApiFp(this.configuration).delete勘定科目(勘定科目pk, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 認証/認可トークンのt企業、指定事業所pkと検索条件で絞り込んだt勘定科目の一覧をc並び順の昇順で取得します
     * @summary 勘定科目一覧
     * @param {number} 事業所pk 
     * @param {E補助科目フラグ} [補助科目フラグ] 
     * @param {E勘定科目カテゴリ} [勘定科目カテゴリ] 
     * @param {string} [勘定科目] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof 勘定科目Api
     */
    public list勘定科目(事業所pk: number, 補助科目フラグ?: E補助科目フラグ, 勘定科目カテゴリ?: E勘定科目カテゴリ, 勘定科目?: string, options?: AxiosRequestConfig) {
        return 勘定科目ApiFp(this.configuration).list勘定科目(事業所pk, 補助科目フラグ, 勘定科目カテゴリ, 勘定科目, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 認証/認可トークンのt企業と指定勘定科目pkに紐付くt勘定科目を更新します
     * @summary 勘定科目更新
     * @param {number} 勘定科目pk 
     * @param {勘定科目Request} 勘定科目request 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof 勘定科目Api
     */
    public update勘定科目(勘定科目pk: number, 勘定科目request: 勘定科目Request, options?: AxiosRequestConfig) {
        return 勘定科目ApiFp(this.configuration).update勘定科目(勘定科目pk, 勘定科目request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 認証/認可トークンのt企業と指定勘定科目pkに紐付くt勘定科目のc並び順を一つ前のt勘定科目のc並び順と入れ替えて更新します
     * @summary 勘定科目並び順更新
     * @param {number} 勘定科目pk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof 勘定科目Api
     */
    public update勘定科目並び順(勘定科目pk: number, options?: AxiosRequestConfig) {
        return 勘定科目ApiFp(this.configuration).update勘定科目並び順(勘定科目pk, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * 取込Api - axios parameter creator
 * @export
 */
export const 取込ApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 指定計画書データpkの妥当性をチェックし、入力ファイルを環境設定定義ディレクトリに「{ユーザーpk}\\_{計画書データpk}\\_{取込分類}\\_{年}[\\_{部門pk}].pdf」として保存し、そのページ数を取得します。<br /> <br /> 実装メモ：<br /> ・計画書データpkの妥当性をチェック<br /> ・PDFファイルのページ数を取得（読めない場合は例外）<br /> ・PDFファイルを環境設定定義ディレクトリに「{ユーザーpk}\\_{計画書データpk}\\_{取込分類}\\_{年}[\\_{部門pk}].pdf」として保存<br /> ・ページ数を返却<br />
         * @summary 取込PDFインポート
         * @param {number} 計画書データpk 
         * @param {E取込分類} 取込分類 
         * @param {number} 年 
         * @param {any} file ファイルオブジェクト
         * @param {number} [部門pk] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        import取込Pdf: async (計画書データpk: number, 取込分類: E取込分類, 年: number, file: any, 部門pk?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter '計画書データpk' is not null or undefined
            assertParamExists('import取込Pdf', '計画書データpk', 計画書データpk)
            // verify required parameter '取込分類' is not null or undefined
            assertParamExists('import取込Pdf', '取込分類', 取込分類)
            // verify required parameter '年' is not null or undefined
            assertParamExists('import取込Pdf', '年', 年)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('import取込Pdf', 'file', file)
            let localVarPath = `/取込/{計画書データpk}/pdf/{取込分類}/{年}/import`
                .replace(`{${"計画書データpk"}}`, encodeURIComponent(String(計画書データpk)))
                .replace(`{${"取込分類"}}`, encodeURIComponent(String(取込分類)))
                .replace(`{${"年"}}`, encodeURIComponent(String(年)));
            if (process.env.VUE_APP_IS_MOCK === "true") localVarPath = ApiUtility.convertSampleUrl('POST', '/取込/{計画書データpk}/pdf/{取込分類}/{年}/import', options);
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            // jsonファイルアクセス時、PUT/DELETEの場合apacheの仕様（default-handler）で弾かれてしまうため、GETへ変換している
            const method = process.env.VUE_APP_IS_MOCK === "true" && ['PUT', 'DELETE'].includes('POST')
              ? 'GET'
              : 'POST';
            const localVarRequestOptions = { method, ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "userToken", configuration)

            if (部門pk !== undefined) {
                localVarQueryParameter['部門pk'] = 部門pk;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 指定計画書データpkの妥当性をチェック、入力ファイル内容をチェックして問題なければ、ファイル内容を加工して環境設定定義ディレクトリに「{ユーザーpk}\\_{計画書データpk}\\_{取込分類}[\\_{部門pk}].json」として保存し、その内容を取込データ種別の昇順に並び替えて返却します。<br /> <br /> 実装メモ：<br /> ・計画書データpkの妥当性をチェック<br /> ・XLSXファイルの解析（決算書、試算表はB列にデータがある行のみ）、入力チェック（勘定科目存在チェック、データ型チェック）<br /> ・解析データを環境設定定義ディレクトリに「{ユーザーpk}\\_{計画書データpk}\\_{取込分類}[\\_{部門pk}].json」として保存<br /> 　保存内容は以下<br /> 　■決算書　CデータPlbscfItem[]\\[](5年分の CデータPlbscfItem[] を年の昇順で並べる)<br /> 　■固定資産台帳 Cデータ償却[]<br /> 　■試算表　CデータPlbscfItem[]<br /> ・解析データを取込データ種別の昇順に並び替えて返却<br />
         * @summary 取込XLSXインポート
         * @param {number} 計画書データpk 
         * @param {E取込分類} 取込分類 
         * @param {any} file ファイルオブジェクト
         * @param {number} [部門pk] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        import取込Xlsx: async (計画書データpk: number, 取込分類: E取込分類, file: any, 部門pk?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter '計画書データpk' is not null or undefined
            assertParamExists('import取込Xlsx', '計画書データpk', 計画書データpk)
            // verify required parameter '取込分類' is not null or undefined
            assertParamExists('import取込Xlsx', '取込分類', 取込分類)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('import取込Xlsx', 'file', file)
            let localVarPath = `/取込/{計画書データpk}/xlsx/{取込分類}/import`
                .replace(`{${"計画書データpk"}}`, encodeURIComponent(String(計画書データpk)))
                .replace(`{${"取込分類"}}`, encodeURIComponent(String(取込分類)));
            if (process.env.VUE_APP_IS_MOCK === "true") localVarPath = ApiUtility.convertSampleUrl('POST', '/取込/{計画書データpk}/xlsx/{取込分類}/import', options);
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            // jsonファイルアクセス時、PUT/DELETEの場合apacheの仕様（default-handler）で弾かれてしまうため、GETへ変換している
            const method = process.env.VUE_APP_IS_MOCK === "true" && ['PUT', 'DELETE'].includes('POST')
              ? 'GET'
              : 'POST';
            const localVarRequestOptions = { method, ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "userToken", configuration)

            if (部門pk !== undefined) {
                localVarQueryParameter['部門pk'] = 部門pk;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 指定計画書データpkの妥当性をチェック、入力ファイル内容をチェックして問題なければt取込、tデータを保存します。<br /> <br /> 実装メモ：<br /> ・計画書データpkの妥当性をチェック<br /> ・XLSXファイルの解析（シート名が取込分類と計画表示モードとマッチしている、B列にデータがある行のみ）、入力チェック（勘定科目存在チェック、データ型チェック）<br /> ・t取込、tデータに保存<br />
         * @summary 取込三表計画XLSXインポート
         * @param {number} 計画書データpk 
         * @param {E取込分類} 取込分類 
         * @param {any} file ファイルオブジェクト
         * @param {number} [部門pk] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        import取込三表計画Xlsx: async (計画書データpk: number, 取込分類: E取込分類, file: any, 部門pk?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter '計画書データpk' is not null or undefined
            assertParamExists('import取込三表計画Xlsx', '計画書データpk', 計画書データpk)
            // verify required parameter '取込分類' is not null or undefined
            assertParamExists('import取込三表計画Xlsx', '取込分類', 取込分類)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('import取込三表計画Xlsx', 'file', file)
            let localVarPath = `/取込/{計画書データpk}/三表計画xlsx/{取込分類}/import`
                .replace(`{${"計画書データpk"}}`, encodeURIComponent(String(計画書データpk)))
                .replace(`{${"取込分類"}}`, encodeURIComponent(String(取込分類)));
            if (process.env.VUE_APP_IS_MOCK === "true") localVarPath = ApiUtility.convertSampleUrl('POST', '/取込/{計画書データpk}/三表計画xlsx/{取込分類}/import', options);
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            // jsonファイルアクセス時、PUT/DELETEの場合apacheの仕様（default-handler）で弾かれてしまうため、GETへ変換している
            const method = process.env.VUE_APP_IS_MOCK === "true" && ['PUT', 'DELETE'].includes('POST')
              ? 'GET'
              : 'POST';
            const localVarRequestOptions = { method, ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "userToken", configuration)

            if (部門pk !== undefined) {
                localVarQueryParameter['部門pk'] = 部門pk;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 認証/認可トークンのt企業と指定計画書データpkに紐付くt取込の一覧を取得します
         * @summary 取込一覧
         * @param {number} 計画書データpk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list取込: async (計画書データpk: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter '計画書データpk' is not null or undefined
            assertParamExists('list取込', '計画書データpk', 計画書データpk)
            let localVarPath = `/取込/{計画書データpk}`
                .replace(`{${"計画書データpk"}}`, encodeURIComponent(String(計画書データpk)));
            if (process.env.VUE_APP_IS_MOCK === "true") localVarPath = ApiUtility.convertSampleUrl('GET', '/取込/{計画書データpk}', options);
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            // jsonファイルアクセス時、PUT/DELETEの場合apacheの仕様（default-handler）で弾かれてしまうため、GETへ変換している
            const method = process.env.VUE_APP_IS_MOCK === "true" && ['PUT', 'DELETE'].includes('GET')
              ? 'GET'
              : 'GET';
            const localVarRequestOptions = { method, ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "userToken", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 指定計画書データpkの妥当性をチェックし、環境設定定義ディレクトリの「{ユーザーpk}\\_{計画書データpk}\\_{取込分類}\\_{年}[\\_{部門pk}].pdf」を指定ページ情報で分割、統合し、外部データ変換プログラムでTSV化して、その内容を取得します。<br /> データ返却時に合わせてt変換枚数を加算、更新します。<br /> 取込データ種別の昇順に並び替えされたデータを返却します。<br /> <br /> 実装メモ：<br /> ・計画書データpkの妥当性をチェック<br /> ・「{ユーザーpk}\\_{計画書データpk}\\_{取込分類}\\_{年}[\\_{部門pk}.pdf」をクエリの取込データ種別毎に分割して「{ユーザーpk}\\_{計画書データpk}\\_{取込分類}\\_{年}[\\_{部門pk}]\\_{取込データ種別}.pdf」を保存<br /> ・上記の分割ファイル数回だけPythonでTSV変換を実行<br /> ・t変換枚数を加算、更新<br /> ・変換TSVデータを整形、取込データ種別の昇順に並び替えて返却<br />
         * @summary 取込PDFデータ一覧
         * @param {number} 計画書データpk 
         * @param {E取込分類} 取込分類 
         * @param {number} 年 
         * @param {Array<E取込データ種別>} 取込データ種別s 
         * @param {number} [部門pk] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list取込Pdfデータ: async (計画書データpk: number, 取込分類: E取込分類, 年: number, 取込データ種別s: Array<E取込データ種別>, 部門pk?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter '計画書データpk' is not null or undefined
            assertParamExists('list取込Pdfデータ', '計画書データpk', 計画書データpk)
            // verify required parameter '取込分類' is not null or undefined
            assertParamExists('list取込Pdfデータ', '取込分類', 取込分類)
            // verify required parameter '年' is not null or undefined
            assertParamExists('list取込Pdfデータ', '年', 年)
            // verify required parameter '取込データ種別s' is not null or undefined
            assertParamExists('list取込Pdfデータ', '取込データ種別s', 取込データ種別s)
            let localVarPath = `/取込/{計画書データpk}/pdf/{取込分類}/{年}`
                .replace(`{${"計画書データpk"}}`, encodeURIComponent(String(計画書データpk)))
                .replace(`{${"取込分類"}}`, encodeURIComponent(String(取込分類)))
                .replace(`{${"年"}}`, encodeURIComponent(String(年)));
            if (process.env.VUE_APP_IS_MOCK === "true") localVarPath = ApiUtility.convertSampleUrl('GET', '/取込/{計画書データpk}/pdf/{取込分類}/{年}', options);
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            // jsonファイルアクセス時、PUT/DELETEの場合apacheの仕様（default-handler）で弾かれてしまうため、GETへ変換している
            const method = process.env.VUE_APP_IS_MOCK === "true" && ['PUT', 'DELETE'].includes('GET')
              ? 'GET'
              : 'GET';
            const localVarRequestOptions = { method, ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "userToken", configuration)

            if (取込データ種別s) {
                localVarQueryParameter['取込データ種別s'] = 取込データ種別s.join(COLLECTION_FORMATS.csv);
            }

            if (部門pk !== undefined) {
                localVarQueryParameter['部門pk'] = 部門pk;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 認証/認可トークンのt企業と指定計画書データpkに紐付くt取込、tデータを保存します。<br /> リクエストはTSV文字列でE償却項目の並びに整形して作成します。<br /> <br /> 実装メモ：<br /> ・入力チェック（入力データの必須と型チェック）<br /> ・データをCデータ償却の配列に整形して、t取込、tデータに保存<br />
         * @summary 取込PDF固定資産保存
         * @param {number} 計画書データpk 
         * @param {取込Pdf固定資産Request} 取込pdf固定資産Request 取込Pdf固定資産情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        save取込Pdf固定資産: async (計画書データpk: number, 取込pdf固定資産Request: 取込Pdf固定資産Request, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter '計画書データpk' is not null or undefined
            assertParamExists('save取込Pdf固定資産', '計画書データpk', 計画書データpk)
            // verify required parameter '取込pdf固定資産Request' is not null or undefined
            assertParamExists('save取込Pdf固定資産', '取込pdf固定資産Request', 取込pdf固定資産Request)
            let localVarPath = `/取込/{計画書データpk}/pdf/固定資産`
                .replace(`{${"計画書データpk"}}`, encodeURIComponent(String(計画書データpk)));
            if (process.env.VUE_APP_IS_MOCK === "true") localVarPath = ApiUtility.convertSampleUrl('POST', '/取込/{計画書データpk}/pdf/固定資産', options);
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            // jsonファイルアクセス時、PUT/DELETEの場合apacheの仕様（default-handler）で弾かれてしまうため、GETへ変換している
            const method = process.env.VUE_APP_IS_MOCK === "true" && ['PUT', 'DELETE'].includes('POST')
              ? 'GET'
              : 'POST';
            const localVarRequestOptions = { method, ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "userToken", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(取込pdf固定資産Request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 認証/認可トークンのt企業と指定計画書データpkに紐付くt取込、tデータを保存します。<br /> <br /> 実装メモ：<br /> ・追加登録の勘定科目を登録<br /> ・リクエストデータをCデータPlbscfItemの配列に整形して、t取込、tデータに保存<br /> ※入力チェックはクライアント側で行う想定<br />
         * @summary 取込PDF決算書保存
         * @param {number} 計画書データpk 
         * @param {number} 年 
         * @param {Array<取込Pdfカテゴリ決算書ListItemRequest>} 取込pdfカテゴリ決算書ListItemRequest 取込PDF決算書
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        save取込Pdf決算書: async (計画書データpk: number, 年: number, 取込pdfカテゴリ決算書ListItemRequest: Array<取込Pdfカテゴリ決算書ListItemRequest>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter '計画書データpk' is not null or undefined
            assertParamExists('save取込Pdf決算書', '計画書データpk', 計画書データpk)
            // verify required parameter '年' is not null or undefined
            assertParamExists('save取込Pdf決算書', '年', 年)
            // verify required parameter '取込pdfカテゴリ決算書ListItemRequest' is not null or undefined
            assertParamExists('save取込Pdf決算書', '取込pdfカテゴリ決算書ListItemRequest', 取込pdfカテゴリ決算書ListItemRequest)
            let localVarPath = `/取込/{計画書データpk}/pdf/決算書/{年}`
                .replace(`{${"計画書データpk"}}`, encodeURIComponent(String(計画書データpk)))
                .replace(`{${"年"}}`, encodeURIComponent(String(年)));
            if (process.env.VUE_APP_IS_MOCK === "true") localVarPath = ApiUtility.convertSampleUrl('POST', '/取込/{計画書データpk}/pdf/決算書/{年}', options);
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            // jsonファイルアクセス時、PUT/DELETEの場合apacheの仕様（default-handler）で弾かれてしまうため、GETへ変換している
            const method = process.env.VUE_APP_IS_MOCK === "true" && ['PUT', 'DELETE'].includes('POST')
              ? 'GET'
              : 'POST';
            const localVarRequestOptions = { method, ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "userToken", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(取込pdfカテゴリ決算書ListItemRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 認証/認可トークンのt企業と指定計画書データpkに紐付くt取込、tデータを保存します。<br /> <br /> 実装メモ：<br /> ・追加登録の勘定科目を登録<br /> ・データをCデータPlbscfItemの配列に整形して、t取込、tデータに保存<br /> ※入力チェックはクライアント側で行う想定<br />
         * @summary 取込PDF試算表保存
         * @param {number} 計画書データpk 
         * @param {E取込分類} 取込分類 
         * @param {Array<取込Pdfカテゴリ試算表ListItemRequest>} 取込pdfカテゴリ試算表ListItemRequest 取込Pdf試算表情報
         * @param {number} [部門pk] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        save取込Pdf試算表: async (計画書データpk: number, 取込分類: E取込分類, 取込pdfカテゴリ試算表ListItemRequest: Array<取込Pdfカテゴリ試算表ListItemRequest>, 部門pk?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter '計画書データpk' is not null or undefined
            assertParamExists('save取込Pdf試算表', '計画書データpk', 計画書データpk)
            // verify required parameter '取込分類' is not null or undefined
            assertParamExists('save取込Pdf試算表', '取込分類', 取込分類)
            // verify required parameter '取込pdfカテゴリ試算表ListItemRequest' is not null or undefined
            assertParamExists('save取込Pdf試算表', '取込pdfカテゴリ試算表ListItemRequest', 取込pdfカテゴリ試算表ListItemRequest)
            let localVarPath = `/取込/{計画書データpk}/pdf/試算表/{取込分類}`
                .replace(`{${"計画書データpk"}}`, encodeURIComponent(String(計画書データpk)))
                .replace(`{${"取込分類"}}`, encodeURIComponent(String(取込分類)));
            if (process.env.VUE_APP_IS_MOCK === "true") localVarPath = ApiUtility.convertSampleUrl('POST', '/取込/{計画書データpk}/pdf/試算表/{取込分類}', options);
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            // jsonファイルアクセス時、PUT/DELETEの場合apacheの仕様（default-handler）で弾かれてしまうため、GETへ変換している
            const method = process.env.VUE_APP_IS_MOCK === "true" && ['PUT', 'DELETE'].includes('POST')
              ? 'GET'
              : 'POST';
            const localVarRequestOptions = { method, ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "userToken", configuration)

            if (部門pk !== undefined) {
                localVarQueryParameter['部門pk'] = 部門pk;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(取込pdfカテゴリ試算表ListItemRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 認証/認可トークンのt企業と指定計画書データpkに紐付くt取込、tデータを保存します。<br /> <br /> 実装メモ：<br /> ・インポートで保存済みの「{ユーザーpk}\\_{計画書データpk}\\_{取込分類}[\\_{部門pk}].json」を読み込んで、t取込、tデータに保存<br />
         * @summary 取込XLSX保存
         * @param {number} 計画書データpk 
         * @param {E取込分類} 取込分類 
         * @param {number} [部門pk] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        save取込Xlsx: async (計画書データpk: number, 取込分類: E取込分類, 部門pk?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter '計画書データpk' is not null or undefined
            assertParamExists('save取込Xlsx', '計画書データpk', 計画書データpk)
            // verify required parameter '取込分類' is not null or undefined
            assertParamExists('save取込Xlsx', '取込分類', 取込分類)
            let localVarPath = `/取込/{計画書データpk}/xlsx/{取込分類}`
                .replace(`{${"計画書データpk"}}`, encodeURIComponent(String(計画書データpk)))
                .replace(`{${"取込分類"}}`, encodeURIComponent(String(取込分類)));
            if (process.env.VUE_APP_IS_MOCK === "true") localVarPath = ApiUtility.convertSampleUrl('POST', '/取込/{計画書データpk}/xlsx/{取込分類}', options);
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            // jsonファイルアクセス時、PUT/DELETEの場合apacheの仕様（default-handler）で弾かれてしまうため、GETへ変換している
            const method = process.env.VUE_APP_IS_MOCK === "true" && ['PUT', 'DELETE'].includes('POST')
              ? 'GET'
              : 'POST';
            const localVarRequestOptions = { method, ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "userToken", configuration)

            if (部門pk !== undefined) {
                localVarQueryParameter['部門pk'] = 部門pk;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * 取込Api - functional programming interface
 * @export
 */
export const 取込ApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = 取込ApiAxiosParamCreator(configuration)
    return {
        /**
         * 指定計画書データpkの妥当性をチェックし、入力ファイルを環境設定定義ディレクトリに「{ユーザーpk}\\_{計画書データpk}\\_{取込分類}\\_{年}[\\_{部門pk}].pdf」として保存し、そのページ数を取得します。<br /> <br /> 実装メモ：<br /> ・計画書データpkの妥当性をチェック<br /> ・PDFファイルのページ数を取得（読めない場合は例外）<br /> ・PDFファイルを環境設定定義ディレクトリに「{ユーザーpk}\\_{計画書データpk}\\_{取込分類}\\_{年}[\\_{部門pk}].pdf」として保存<br /> ・ページ数を返却<br />
         * @summary 取込PDFインポート
         * @param {number} 計画書データpk 
         * @param {E取込分類} 取込分類 
         * @param {number} 年 
         * @param {any} file ファイルオブジェクト
         * @param {number} [部門pk] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async import取込Pdf(計画書データpk: number, 取込分類: E取込分類, 年: number, file: any, 部門pk?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<取込PdfImportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.import取込Pdf(計画書データpk, 取込分類, 年, file, 部門pk, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 指定計画書データpkの妥当性をチェック、入力ファイル内容をチェックして問題なければ、ファイル内容を加工して環境設定定義ディレクトリに「{ユーザーpk}\\_{計画書データpk}\\_{取込分類}[\\_{部門pk}].json」として保存し、その内容を取込データ種別の昇順に並び替えて返却します。<br /> <br /> 実装メモ：<br /> ・計画書データpkの妥当性をチェック<br /> ・XLSXファイルの解析（決算書、試算表はB列にデータがある行のみ）、入力チェック（勘定科目存在チェック、データ型チェック）<br /> ・解析データを環境設定定義ディレクトリに「{ユーザーpk}\\_{計画書データpk}\\_{取込分類}[\\_{部門pk}].json」として保存<br /> 　保存内容は以下<br /> 　■決算書　CデータPlbscfItem[]\\[](5年分の CデータPlbscfItem[] を年の昇順で並べる)<br /> 　■固定資産台帳 Cデータ償却[]<br /> 　■試算表　CデータPlbscfItem[]<br /> ・解析データを取込データ種別の昇順に並び替えて返却<br />
         * @summary 取込XLSXインポート
         * @param {number} 計画書データpk 
         * @param {E取込分類} 取込分類 
         * @param {any} file ファイルオブジェクト
         * @param {number} [部門pk] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async import取込Xlsx(計画書データpk: number, 取込分類: E取込分類, file: any, 部門pk?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<取込XlsxImportListItemResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.import取込Xlsx(計画書データpk, 取込分類, file, 部門pk, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 指定計画書データpkの妥当性をチェック、入力ファイル内容をチェックして問題なければt取込、tデータを保存します。<br /> <br /> 実装メモ：<br /> ・計画書データpkの妥当性をチェック<br /> ・XLSXファイルの解析（シート名が取込分類と計画表示モードとマッチしている、B列にデータがある行のみ）、入力チェック（勘定科目存在チェック、データ型チェック）<br /> ・t取込、tデータに保存<br />
         * @summary 取込三表計画XLSXインポート
         * @param {number} 計画書データpk 
         * @param {E取込分類} 取込分類 
         * @param {any} file ファイルオブジェクト
         * @param {number} [部門pk] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async import取込三表計画Xlsx(計画書データpk: number, 取込分類: E取込分類, file: any, 部門pk?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.import取込三表計画Xlsx(計画書データpk, 取込分類, file, 部門pk, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 認証/認可トークンのt企業と指定計画書データpkに紐付くt取込の一覧を取得します
         * @summary 取込一覧
         * @param {number} 計画書データpk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async list取込(計画書データpk: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<取込ListItemResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.list取込(計画書データpk, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 指定計画書データpkの妥当性をチェックし、環境設定定義ディレクトリの「{ユーザーpk}\\_{計画書データpk}\\_{取込分類}\\_{年}[\\_{部門pk}].pdf」を指定ページ情報で分割、統合し、外部データ変換プログラムでTSV化して、その内容を取得します。<br /> データ返却時に合わせてt変換枚数を加算、更新します。<br /> 取込データ種別の昇順に並び替えされたデータを返却します。<br /> <br /> 実装メモ：<br /> ・計画書データpkの妥当性をチェック<br /> ・「{ユーザーpk}\\_{計画書データpk}\\_{取込分類}\\_{年}[\\_{部門pk}.pdf」をクエリの取込データ種別毎に分割して「{ユーザーpk}\\_{計画書データpk}\\_{取込分類}\\_{年}[\\_{部門pk}]\\_{取込データ種別}.pdf」を保存<br /> ・上記の分割ファイル数回だけPythonでTSV変換を実行<br /> ・t変換枚数を加算、更新<br /> ・変換TSVデータを整形、取込データ種別の昇順に並び替えて返却<br />
         * @summary 取込PDFデータ一覧
         * @param {number} 計画書データpk 
         * @param {E取込分類} 取込分類 
         * @param {number} 年 
         * @param {Array<E取込データ種別>} 取込データ種別s 
         * @param {number} [部門pk] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async list取込Pdfデータ(計画書データpk: number, 取込分類: E取込分類, 年: number, 取込データ種別s: Array<E取込データ種別>, 部門pk?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<取込PdfListItemResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.list取込Pdfデータ(計画書データpk, 取込分類, 年, 取込データ種別s, 部門pk, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 認証/認可トークンのt企業と指定計画書データpkに紐付くt取込、tデータを保存します。<br /> リクエストはTSV文字列でE償却項目の並びに整形して作成します。<br /> <br /> 実装メモ：<br /> ・入力チェック（入力データの必須と型チェック）<br /> ・データをCデータ償却の配列に整形して、t取込、tデータに保存<br />
         * @summary 取込PDF固定資産保存
         * @param {number} 計画書データpk 
         * @param {取込Pdf固定資産Request} 取込pdf固定資産Request 取込Pdf固定資産情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async save取込Pdf固定資産(計画書データpk: number, 取込pdf固定資産Request: 取込Pdf固定資産Request, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.save取込Pdf固定資産(計画書データpk, 取込pdf固定資産Request, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 認証/認可トークンのt企業と指定計画書データpkに紐付くt取込、tデータを保存します。<br /> <br /> 実装メモ：<br /> ・追加登録の勘定科目を登録<br /> ・リクエストデータをCデータPlbscfItemの配列に整形して、t取込、tデータに保存<br /> ※入力チェックはクライアント側で行う想定<br />
         * @summary 取込PDF決算書保存
         * @param {number} 計画書データpk 
         * @param {number} 年 
         * @param {Array<取込Pdfカテゴリ決算書ListItemRequest>} 取込pdfカテゴリ決算書ListItemRequest 取込PDF決算書
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async save取込Pdf決算書(計画書データpk: number, 年: number, 取込pdfカテゴリ決算書ListItemRequest: Array<取込Pdfカテゴリ決算書ListItemRequest>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.save取込Pdf決算書(計画書データpk, 年, 取込pdfカテゴリ決算書ListItemRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 認証/認可トークンのt企業と指定計画書データpkに紐付くt取込、tデータを保存します。<br /> <br /> 実装メモ：<br /> ・追加登録の勘定科目を登録<br /> ・データをCデータPlbscfItemの配列に整形して、t取込、tデータに保存<br /> ※入力チェックはクライアント側で行う想定<br />
         * @summary 取込PDF試算表保存
         * @param {number} 計画書データpk 
         * @param {E取込分類} 取込分類 
         * @param {Array<取込Pdfカテゴリ試算表ListItemRequest>} 取込pdfカテゴリ試算表ListItemRequest 取込Pdf試算表情報
         * @param {number} [部門pk] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async save取込Pdf試算表(計画書データpk: number, 取込分類: E取込分類, 取込pdfカテゴリ試算表ListItemRequest: Array<取込Pdfカテゴリ試算表ListItemRequest>, 部門pk?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.save取込Pdf試算表(計画書データpk, 取込分類, 取込pdfカテゴリ試算表ListItemRequest, 部門pk, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 認証/認可トークンのt企業と指定計画書データpkに紐付くt取込、tデータを保存します。<br /> <br /> 実装メモ：<br /> ・インポートで保存済みの「{ユーザーpk}\\_{計画書データpk}\\_{取込分類}[\\_{部門pk}].json」を読み込んで、t取込、tデータに保存<br />
         * @summary 取込XLSX保存
         * @param {number} 計画書データpk 
         * @param {E取込分類} 取込分類 
         * @param {number} [部門pk] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async save取込Xlsx(計画書データpk: number, 取込分類: E取込分類, 部門pk?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.save取込Xlsx(計画書データpk, 取込分類, 部門pk, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * 取込Api - factory interface
 * @export
 */
export const 取込ApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = 取込ApiFp(configuration)
    return {
        /**
         * 指定計画書データpkの妥当性をチェックし、入力ファイルを環境設定定義ディレクトリに「{ユーザーpk}\\_{計画書データpk}\\_{取込分類}\\_{年}[\\_{部門pk}].pdf」として保存し、そのページ数を取得します。<br /> <br /> 実装メモ：<br /> ・計画書データpkの妥当性をチェック<br /> ・PDFファイルのページ数を取得（読めない場合は例外）<br /> ・PDFファイルを環境設定定義ディレクトリに「{ユーザーpk}\\_{計画書データpk}\\_{取込分類}\\_{年}[\\_{部門pk}].pdf」として保存<br /> ・ページ数を返却<br />
         * @summary 取込PDFインポート
         * @param {number} 計画書データpk 
         * @param {E取込分類} 取込分類 
         * @param {number} 年 
         * @param {any} file ファイルオブジェクト
         * @param {number} [部門pk] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        import取込Pdf(計画書データpk: number, 取込分類: E取込分類, 年: number, file: any, 部門pk?: number, options?: any): AxiosPromise<取込PdfImportResponse> {
            return localVarFp.import取込Pdf(計画書データpk, 取込分類, 年, file, 部門pk, options).then((request) => request(axios, basePath));
        },
        /**
         * 指定計画書データpkの妥当性をチェック、入力ファイル内容をチェックして問題なければ、ファイル内容を加工して環境設定定義ディレクトリに「{ユーザーpk}\\_{計画書データpk}\\_{取込分類}[\\_{部門pk}].json」として保存し、その内容を取込データ種別の昇順に並び替えて返却します。<br /> <br /> 実装メモ：<br /> ・計画書データpkの妥当性をチェック<br /> ・XLSXファイルの解析（決算書、試算表はB列にデータがある行のみ）、入力チェック（勘定科目存在チェック、データ型チェック）<br /> ・解析データを環境設定定義ディレクトリに「{ユーザーpk}\\_{計画書データpk}\\_{取込分類}[\\_{部門pk}].json」として保存<br /> 　保存内容は以下<br /> 　■決算書　CデータPlbscfItem[]\\[](5年分の CデータPlbscfItem[] を年の昇順で並べる)<br /> 　■固定資産台帳 Cデータ償却[]<br /> 　■試算表　CデータPlbscfItem[]<br /> ・解析データを取込データ種別の昇順に並び替えて返却<br />
         * @summary 取込XLSXインポート
         * @param {number} 計画書データpk 
         * @param {E取込分類} 取込分類 
         * @param {any} file ファイルオブジェクト
         * @param {number} [部門pk] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        import取込Xlsx(計画書データpk: number, 取込分類: E取込分類, file: any, 部門pk?: number, options?: any): AxiosPromise<Array<取込XlsxImportListItemResponse>> {
            return localVarFp.import取込Xlsx(計画書データpk, 取込分類, file, 部門pk, options).then((request) => request(axios, basePath));
        },
        /**
         * 指定計画書データpkの妥当性をチェック、入力ファイル内容をチェックして問題なければt取込、tデータを保存します。<br /> <br /> 実装メモ：<br /> ・計画書データpkの妥当性をチェック<br /> ・XLSXファイルの解析（シート名が取込分類と計画表示モードとマッチしている、B列にデータがある行のみ）、入力チェック（勘定科目存在チェック、データ型チェック）<br /> ・t取込、tデータに保存<br />
         * @summary 取込三表計画XLSXインポート
         * @param {number} 計画書データpk 
         * @param {E取込分類} 取込分類 
         * @param {any} file ファイルオブジェクト
         * @param {number} [部門pk] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        import取込三表計画Xlsx(計画書データpk: number, 取込分類: E取込分類, file: any, 部門pk?: number, options?: any): AxiosPromise<void> {
            return localVarFp.import取込三表計画Xlsx(計画書データpk, 取込分類, file, 部門pk, options).then((request) => request(axios, basePath));
        },
        /**
         * 認証/認可トークンのt企業と指定計画書データpkに紐付くt取込の一覧を取得します
         * @summary 取込一覧
         * @param {number} 計画書データpk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list取込(計画書データpk: number, options?: any): AxiosPromise<Array<取込ListItemResponse>> {
            return localVarFp.list取込(計画書データpk, options).then((request) => request(axios, basePath));
        },
        /**
         * 指定計画書データpkの妥当性をチェックし、環境設定定義ディレクトリの「{ユーザーpk}\\_{計画書データpk}\\_{取込分類}\\_{年}[\\_{部門pk}].pdf」を指定ページ情報で分割、統合し、外部データ変換プログラムでTSV化して、その内容を取得します。<br /> データ返却時に合わせてt変換枚数を加算、更新します。<br /> 取込データ種別の昇順に並び替えされたデータを返却します。<br /> <br /> 実装メモ：<br /> ・計画書データpkの妥当性をチェック<br /> ・「{ユーザーpk}\\_{計画書データpk}\\_{取込分類}\\_{年}[\\_{部門pk}.pdf」をクエリの取込データ種別毎に分割して「{ユーザーpk}\\_{計画書データpk}\\_{取込分類}\\_{年}[\\_{部門pk}]\\_{取込データ種別}.pdf」を保存<br /> ・上記の分割ファイル数回だけPythonでTSV変換を実行<br /> ・t変換枚数を加算、更新<br /> ・変換TSVデータを整形、取込データ種別の昇順に並び替えて返却<br />
         * @summary 取込PDFデータ一覧
         * @param {number} 計画書データpk 
         * @param {E取込分類} 取込分類 
         * @param {number} 年 
         * @param {Array<E取込データ種別>} 取込データ種別s 
         * @param {number} [部門pk] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list取込Pdfデータ(計画書データpk: number, 取込分類: E取込分類, 年: number, 取込データ種別s: Array<E取込データ種別>, 部門pk?: number, options?: any): AxiosPromise<Array<取込PdfListItemResponse>> {
            return localVarFp.list取込Pdfデータ(計画書データpk, 取込分類, 年, 取込データ種別s, 部門pk, options).then((request) => request(axios, basePath));
        },
        /**
         * 認証/認可トークンのt企業と指定計画書データpkに紐付くt取込、tデータを保存します。<br /> リクエストはTSV文字列でE償却項目の並びに整形して作成します。<br /> <br /> 実装メモ：<br /> ・入力チェック（入力データの必須と型チェック）<br /> ・データをCデータ償却の配列に整形して、t取込、tデータに保存<br />
         * @summary 取込PDF固定資産保存
         * @param {number} 計画書データpk 
         * @param {取込Pdf固定資産Request} 取込pdf固定資産Request 取込Pdf固定資産情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        save取込Pdf固定資産(計画書データpk: number, 取込pdf固定資産Request: 取込Pdf固定資産Request, options?: any): AxiosPromise<void> {
            return localVarFp.save取込Pdf固定資産(計画書データpk, 取込pdf固定資産Request, options).then((request) => request(axios, basePath));
        },
        /**
         * 認証/認可トークンのt企業と指定計画書データpkに紐付くt取込、tデータを保存します。<br /> <br /> 実装メモ：<br /> ・追加登録の勘定科目を登録<br /> ・リクエストデータをCデータPlbscfItemの配列に整形して、t取込、tデータに保存<br /> ※入力チェックはクライアント側で行う想定<br />
         * @summary 取込PDF決算書保存
         * @param {number} 計画書データpk 
         * @param {number} 年 
         * @param {Array<取込Pdfカテゴリ決算書ListItemRequest>} 取込pdfカテゴリ決算書ListItemRequest 取込PDF決算書
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        save取込Pdf決算書(計画書データpk: number, 年: number, 取込pdfカテゴリ決算書ListItemRequest: Array<取込Pdfカテゴリ決算書ListItemRequest>, options?: any): AxiosPromise<void> {
            return localVarFp.save取込Pdf決算書(計画書データpk, 年, 取込pdfカテゴリ決算書ListItemRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 認証/認可トークンのt企業と指定計画書データpkに紐付くt取込、tデータを保存します。<br /> <br /> 実装メモ：<br /> ・追加登録の勘定科目を登録<br /> ・データをCデータPlbscfItemの配列に整形して、t取込、tデータに保存<br /> ※入力チェックはクライアント側で行う想定<br />
         * @summary 取込PDF試算表保存
         * @param {number} 計画書データpk 
         * @param {E取込分類} 取込分類 
         * @param {Array<取込Pdfカテゴリ試算表ListItemRequest>} 取込pdfカテゴリ試算表ListItemRequest 取込Pdf試算表情報
         * @param {number} [部門pk] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        save取込Pdf試算表(計画書データpk: number, 取込分類: E取込分類, 取込pdfカテゴリ試算表ListItemRequest: Array<取込Pdfカテゴリ試算表ListItemRequest>, 部門pk?: number, options?: any): AxiosPromise<void> {
            return localVarFp.save取込Pdf試算表(計画書データpk, 取込分類, 取込pdfカテゴリ試算表ListItemRequest, 部門pk, options).then((request) => request(axios, basePath));
        },
        /**
         * 認証/認可トークンのt企業と指定計画書データpkに紐付くt取込、tデータを保存します。<br /> <br /> 実装メモ：<br /> ・インポートで保存済みの「{ユーザーpk}\\_{計画書データpk}\\_{取込分類}[\\_{部門pk}].json」を読み込んで、t取込、tデータに保存<br />
         * @summary 取込XLSX保存
         * @param {number} 計画書データpk 
         * @param {E取込分類} 取込分類 
         * @param {number} [部門pk] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        save取込Xlsx(計画書データpk: number, 取込分類: E取込分類, 部門pk?: number, options?: any): AxiosPromise<void> {
            return localVarFp.save取込Xlsx(計画書データpk, 取込分類, 部門pk, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * 取込Api - object-oriented interface
 * @export
 * @class 取込Api
 * @extends {BaseAPI}
 */
export class 取込Api extends BaseAPI {
    /**
     * 指定計画書データpkの妥当性をチェックし、入力ファイルを環境設定定義ディレクトリに「{ユーザーpk}\\_{計画書データpk}\\_{取込分類}\\_{年}[\\_{部門pk}].pdf」として保存し、そのページ数を取得します。<br /> <br /> 実装メモ：<br /> ・計画書データpkの妥当性をチェック<br /> ・PDFファイルのページ数を取得（読めない場合は例外）<br /> ・PDFファイルを環境設定定義ディレクトリに「{ユーザーpk}\\_{計画書データpk}\\_{取込分類}\\_{年}[\\_{部門pk}].pdf」として保存<br /> ・ページ数を返却<br />
     * @summary 取込PDFインポート
     * @param {number} 計画書データpk 
     * @param {E取込分類} 取込分類 
     * @param {number} 年 
     * @param {any} file ファイルオブジェクト
     * @param {number} [部門pk] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof 取込Api
     */
    public import取込Pdf(計画書データpk: number, 取込分類: E取込分類, 年: number, file: any, 部門pk?: number, options?: AxiosRequestConfig) {
        return 取込ApiFp(this.configuration).import取込Pdf(計画書データpk, 取込分類, 年, file, 部門pk, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 指定計画書データpkの妥当性をチェック、入力ファイル内容をチェックして問題なければ、ファイル内容を加工して環境設定定義ディレクトリに「{ユーザーpk}\\_{計画書データpk}\\_{取込分類}[\\_{部門pk}].json」として保存し、その内容を取込データ種別の昇順に並び替えて返却します。<br /> <br /> 実装メモ：<br /> ・計画書データpkの妥当性をチェック<br /> ・XLSXファイルの解析（決算書、試算表はB列にデータがある行のみ）、入力チェック（勘定科目存在チェック、データ型チェック）<br /> ・解析データを環境設定定義ディレクトリに「{ユーザーpk}\\_{計画書データpk}\\_{取込分類}[\\_{部門pk}].json」として保存<br /> 　保存内容は以下<br /> 　■決算書　CデータPlbscfItem[]\\[](5年分の CデータPlbscfItem[] を年の昇順で並べる)<br /> 　■固定資産台帳 Cデータ償却[]<br /> 　■試算表　CデータPlbscfItem[]<br /> ・解析データを取込データ種別の昇順に並び替えて返却<br />
     * @summary 取込XLSXインポート
     * @param {number} 計画書データpk 
     * @param {E取込分類} 取込分類 
     * @param {any} file ファイルオブジェクト
     * @param {number} [部門pk] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof 取込Api
     */
    public import取込Xlsx(計画書データpk: number, 取込分類: E取込分類, file: any, 部門pk?: number, options?: AxiosRequestConfig) {
        return 取込ApiFp(this.configuration).import取込Xlsx(計画書データpk, 取込分類, file, 部門pk, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 指定計画書データpkの妥当性をチェック、入力ファイル内容をチェックして問題なければt取込、tデータを保存します。<br /> <br /> 実装メモ：<br /> ・計画書データpkの妥当性をチェック<br /> ・XLSXファイルの解析（シート名が取込分類と計画表示モードとマッチしている、B列にデータがある行のみ）、入力チェック（勘定科目存在チェック、データ型チェック）<br /> ・t取込、tデータに保存<br />
     * @summary 取込三表計画XLSXインポート
     * @param {number} 計画書データpk 
     * @param {E取込分類} 取込分類 
     * @param {any} file ファイルオブジェクト
     * @param {number} [部門pk] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof 取込Api
     */
    public import取込三表計画Xlsx(計画書データpk: number, 取込分類: E取込分類, file: any, 部門pk?: number, options?: AxiosRequestConfig) {
        return 取込ApiFp(this.configuration).import取込三表計画Xlsx(計画書データpk, 取込分類, file, 部門pk, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 認証/認可トークンのt企業と指定計画書データpkに紐付くt取込の一覧を取得します
     * @summary 取込一覧
     * @param {number} 計画書データpk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof 取込Api
     */
    public list取込(計画書データpk: number, options?: AxiosRequestConfig) {
        return 取込ApiFp(this.configuration).list取込(計画書データpk, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 指定計画書データpkの妥当性をチェックし、環境設定定義ディレクトリの「{ユーザーpk}\\_{計画書データpk}\\_{取込分類}\\_{年}[\\_{部門pk}].pdf」を指定ページ情報で分割、統合し、外部データ変換プログラムでTSV化して、その内容を取得します。<br /> データ返却時に合わせてt変換枚数を加算、更新します。<br /> 取込データ種別の昇順に並び替えされたデータを返却します。<br /> <br /> 実装メモ：<br /> ・計画書データpkの妥当性をチェック<br /> ・「{ユーザーpk}\\_{計画書データpk}\\_{取込分類}\\_{年}[\\_{部門pk}.pdf」をクエリの取込データ種別毎に分割して「{ユーザーpk}\\_{計画書データpk}\\_{取込分類}\\_{年}[\\_{部門pk}]\\_{取込データ種別}.pdf」を保存<br /> ・上記の分割ファイル数回だけPythonでTSV変換を実行<br /> ・t変換枚数を加算、更新<br /> ・変換TSVデータを整形、取込データ種別の昇順に並び替えて返却<br />
     * @summary 取込PDFデータ一覧
     * @param {number} 計画書データpk 
     * @param {E取込分類} 取込分類 
     * @param {number} 年 
     * @param {Array<E取込データ種別>} 取込データ種別s 
     * @param {number} [部門pk] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof 取込Api
     */
    public list取込Pdfデータ(計画書データpk: number, 取込分類: E取込分類, 年: number, 取込データ種別s: Array<E取込データ種別>, 部門pk?: number, options?: AxiosRequestConfig) {
        return 取込ApiFp(this.configuration).list取込Pdfデータ(計画書データpk, 取込分類, 年, 取込データ種別s, 部門pk, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 認証/認可トークンのt企業と指定計画書データpkに紐付くt取込、tデータを保存します。<br /> リクエストはTSV文字列でE償却項目の並びに整形して作成します。<br /> <br /> 実装メモ：<br /> ・入力チェック（入力データの必須と型チェック）<br /> ・データをCデータ償却の配列に整形して、t取込、tデータに保存<br />
     * @summary 取込PDF固定資産保存
     * @param {number} 計画書データpk 
     * @param {取込Pdf固定資産Request} 取込pdf固定資産Request 取込Pdf固定資産情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof 取込Api
     */
    public save取込Pdf固定資産(計画書データpk: number, 取込pdf固定資産Request: 取込Pdf固定資産Request, options?: AxiosRequestConfig) {
        return 取込ApiFp(this.configuration).save取込Pdf固定資産(計画書データpk, 取込pdf固定資産Request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 認証/認可トークンのt企業と指定計画書データpkに紐付くt取込、tデータを保存します。<br /> <br /> 実装メモ：<br /> ・追加登録の勘定科目を登録<br /> ・リクエストデータをCデータPlbscfItemの配列に整形して、t取込、tデータに保存<br /> ※入力チェックはクライアント側で行う想定<br />
     * @summary 取込PDF決算書保存
     * @param {number} 計画書データpk 
     * @param {number} 年 
     * @param {Array<取込Pdfカテゴリ決算書ListItemRequest>} 取込pdfカテゴリ決算書ListItemRequest 取込PDF決算書
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof 取込Api
     */
    public save取込Pdf決算書(計画書データpk: number, 年: number, 取込pdfカテゴリ決算書ListItemRequest: Array<取込Pdfカテゴリ決算書ListItemRequest>, options?: AxiosRequestConfig) {
        return 取込ApiFp(this.configuration).save取込Pdf決算書(計画書データpk, 年, 取込pdfカテゴリ決算書ListItemRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 認証/認可トークンのt企業と指定計画書データpkに紐付くt取込、tデータを保存します。<br /> <br /> 実装メモ：<br /> ・追加登録の勘定科目を登録<br /> ・データをCデータPlbscfItemの配列に整形して、t取込、tデータに保存<br /> ※入力チェックはクライアント側で行う想定<br />
     * @summary 取込PDF試算表保存
     * @param {number} 計画書データpk 
     * @param {E取込分類} 取込分類 
     * @param {Array<取込Pdfカテゴリ試算表ListItemRequest>} 取込pdfカテゴリ試算表ListItemRequest 取込Pdf試算表情報
     * @param {number} [部門pk] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof 取込Api
     */
    public save取込Pdf試算表(計画書データpk: number, 取込分類: E取込分類, 取込pdfカテゴリ試算表ListItemRequest: Array<取込Pdfカテゴリ試算表ListItemRequest>, 部門pk?: number, options?: AxiosRequestConfig) {
        return 取込ApiFp(this.configuration).save取込Pdf試算表(計画書データpk, 取込分類, 取込pdfカテゴリ試算表ListItemRequest, 部門pk, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 認証/認可トークンのt企業と指定計画書データpkに紐付くt取込、tデータを保存します。<br /> <br /> 実装メモ：<br /> ・インポートで保存済みの「{ユーザーpk}\\_{計画書データpk}\\_{取込分類}[\\_{部門pk}].json」を読み込んで、t取込、tデータに保存<br />
     * @summary 取込XLSX保存
     * @param {number} 計画書データpk 
     * @param {E取込分類} 取込分類 
     * @param {number} [部門pk] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof 取込Api
     */
    public save取込Xlsx(計画書データpk: number, 取込分類: E取込分類, 部門pk?: number, options?: AxiosRequestConfig) {
        return 取込ApiFp(this.configuration).save取込Xlsx(計画書データpk, 取込分類, 部門pk, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * 変換枚数Api - axios parameter creator
 * @export
 */
export const 変換枚数ApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 認証/認可トークンのt企業と指定年月に紐付くt変換枚数を取得します
         * @summary 変換枚数詳細
         * @param {number} 年月 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        show変換枚数: async (年月: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter '年月' is not null or undefined
            assertParamExists('show変換枚数', '年月', 年月)
            let localVarPath = `/変換枚数/{年月}`
                .replace(`{${"年月"}}`, encodeURIComponent(String(年月)));
            if (process.env.VUE_APP_IS_MOCK === "true") localVarPath = ApiUtility.convertSampleUrl('GET', '/変換枚数/{年月}', options);
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            // jsonファイルアクセス時、PUT/DELETEの場合apacheの仕様（default-handler）で弾かれてしまうため、GETへ変換している
            const method = process.env.VUE_APP_IS_MOCK === "true" && ['PUT', 'DELETE'].includes('GET')
              ? 'GET'
              : 'GET';
            const localVarRequestOptions = { method, ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "userToken", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * 変換枚数Api - functional programming interface
 * @export
 */
export const 変換枚数ApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = 変換枚数ApiAxiosParamCreator(configuration)
    return {
        /**
         * 認証/認可トークンのt企業と指定年月に紐付くt変換枚数を取得します
         * @summary 変換枚数詳細
         * @param {number} 年月 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async show変換枚数(年月: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<変換枚数Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.show変換枚数(年月, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * 変換枚数Api - factory interface
 * @export
 */
export const 変換枚数ApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = 変換枚数ApiFp(configuration)
    return {
        /**
         * 認証/認可トークンのt企業と指定年月に紐付くt変換枚数を取得します
         * @summary 変換枚数詳細
         * @param {number} 年月 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        show変換枚数(年月: number, options?: any): AxiosPromise<変換枚数Response> {
            return localVarFp.show変換枚数(年月, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * 変換枚数Api - object-oriented interface
 * @export
 * @class 変換枚数Api
 * @extends {BaseAPI}
 */
export class 変換枚数Api extends BaseAPI {
    /**
     * 認証/認可トークンのt企業と指定年月に紐付くt変換枚数を取得します
     * @summary 変換枚数詳細
     * @param {number} 年月 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof 変換枚数Api
     */
    public show変換枚数(年月: number, options?: AxiosRequestConfig) {
        return 変換枚数ApiFp(this.configuration).show変換枚数(年月, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * 帳票Api - axios parameter creator
 * @export
 */
export const 帳票ApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 入力情報を帳票出力します<br /> ※Media typeのプルダウンは異常系確認時にはapplication/json、正常系確認時はその他に切り替えてください
         * @summary 帳票出力
         * @param {E帳票種別} 帳票種別 
         * @param {Array<帳票ListItemRequest>} 帳票listItemRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        output帳票: async (帳票種別: E帳票種別, 帳票listItemRequest: Array<帳票ListItemRequest>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter '帳票種別' is not null or undefined
            assertParamExists('output帳票', '帳票種別', 帳票種別)
            // verify required parameter '帳票listItemRequest' is not null or undefined
            assertParamExists('output帳票', '帳票listItemRequest', 帳票listItemRequest)
            let localVarPath = `/帳票/{帳票種別}`
                .replace(`{${"帳票種別"}}`, encodeURIComponent(String(帳票種別)));
            if (process.env.VUE_APP_IS_MOCK === "true") localVarPath = ApiUtility.convertSampleUrl('POST', '/帳票/{帳票種別}', options);
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            // jsonファイルアクセス時、PUT/DELETEの場合apacheの仕様（default-handler）で弾かれてしまうため、GETへ変換している
            const method = process.env.VUE_APP_IS_MOCK === "true" && ['PUT', 'DELETE'].includes('POST')
              ? 'GET'
              : 'POST';
            const localVarRequestOptions = { method, ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "userToken", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(帳票listItemRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * 帳票Api - functional programming interface
 * @export
 */
export const 帳票ApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = 帳票ApiAxiosParamCreator(configuration)
    return {
        /**
         * 入力情報を帳票出力します<br /> ※Media typeのプルダウンは異常系確認時にはapplication/json、正常系確認時はその他に切り替えてください
         * @summary 帳票出力
         * @param {E帳票種別} 帳票種別 
         * @param {Array<帳票ListItemRequest>} 帳票listItemRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async output帳票(帳票種別: E帳票種別, 帳票listItemRequest: Array<帳票ListItemRequest>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.output帳票(帳票種別, 帳票listItemRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * 帳票Api - factory interface
 * @export
 */
export const 帳票ApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = 帳票ApiFp(configuration)
    return {
        /**
         * 入力情報を帳票出力します<br /> ※Media typeのプルダウンは異常系確認時にはapplication/json、正常系確認時はその他に切り替えてください
         * @summary 帳票出力
         * @param {E帳票種別} 帳票種別 
         * @param {Array<帳票ListItemRequest>} 帳票listItemRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        output帳票(帳票種別: E帳票種別, 帳票listItemRequest: Array<帳票ListItemRequest>, options?: any): AxiosPromise<any> {
            return localVarFp.output帳票(帳票種別, 帳票listItemRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * 帳票Api - object-oriented interface
 * @export
 * @class 帳票Api
 * @extends {BaseAPI}
 */
export class 帳票Api extends BaseAPI {
    /**
     * 入力情報を帳票出力します<br /> ※Media typeのプルダウンは異常系確認時にはapplication/json、正常系確認時はその他に切り替えてください
     * @summary 帳票出力
     * @param {E帳票種別} 帳票種別 
     * @param {Array<帳票ListItemRequest>} 帳票listItemRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof 帳票Api
     */
    public output帳票(帳票種別: E帳票種別, 帳票listItemRequest: Array<帳票ListItemRequest>, options?: AxiosRequestConfig) {
        return 帳票ApiFp(this.configuration).output帳票(帳票種別, 帳票listItemRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * 計画書データApi - axios parameter creator
 * @export
 */
export const 計画書データApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 認証/認可トークンのt企業と指定計画書データpkに紐づくt計画書データを基として、 c計画書データ名を変更したt計画書データを新たに作成します
         * @summary 計画書データコピー
         * @param {number} 計画書データpk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copy計画書データ: async (計画書データpk: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter '計画書データpk' is not null or undefined
            assertParamExists('copy計画書データ', '計画書データpk', 計画書データpk)
            let localVarPath = `/計画書データ/{計画書データpk}`
                .replace(`{${"計画書データpk"}}`, encodeURIComponent(String(計画書データpk)));
            if (process.env.VUE_APP_IS_MOCK === "true") localVarPath = ApiUtility.convertSampleUrl('POST', '/計画書データ/{計画書データpk}', options);
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            // jsonファイルアクセス時、PUT/DELETEの場合apacheの仕様（default-handler）で弾かれてしまうため、GETへ変換している
            const method = process.env.VUE_APP_IS_MOCK === "true" && ['PUT', 'DELETE'].includes('POST')
              ? 'GET'
              : 'POST';
            const localVarRequestOptions = { method, ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "userToken", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 認証/認可トークンのt企業と指定事業所pkに紐付くt計画書データを作成します
         * @summary 計画書データ作成
         * @param {number} 事業所pk 
         * @param {計画書データRequest} 計画書データrequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create計画書データ: async (事業所pk: number, 計画書データrequest: 計画書データRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter '事業所pk' is not null or undefined
            assertParamExists('create計画書データ', '事業所pk', 事業所pk)
            // verify required parameter '計画書データrequest' is not null or undefined
            assertParamExists('create計画書データ', '計画書データrequest', 計画書データrequest)
            let localVarPath = `/計画書データ/{事業所pk}`
                .replace(`{${"事業所pk"}}`, encodeURIComponent(String(事業所pk)));
            if (process.env.VUE_APP_IS_MOCK === "true") localVarPath = ApiUtility.convertSampleUrl('POST', '/計画書データ/{事業所pk}', options);
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            // jsonファイルアクセス時、PUT/DELETEの場合apacheの仕様（default-handler）で弾かれてしまうため、GETへ変換している
            const method = process.env.VUE_APP_IS_MOCK === "true" && ['PUT', 'DELETE'].includes('POST')
              ? 'GET'
              : 'POST';
            const localVarRequestOptions = { method, ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "userToken", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(計画書データrequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 認証/認可トークンのt企業と指定事業所pkに紐付く有効なt計画書データの一覧をc計画書データ番号の昇順で取得します
         * @summary 計画書データ一覧
         * @param {number} 事業所pk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list計画書データ: async (事業所pk: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter '事業所pk' is not null or undefined
            assertParamExists('list計画書データ', '事業所pk', 事業所pk)
            let localVarPath = `/計画書データ/{事業所pk}`
                .replace(`{${"事業所pk"}}`, encodeURIComponent(String(事業所pk)));
            if (process.env.VUE_APP_IS_MOCK === "true") localVarPath = ApiUtility.convertSampleUrl('GET', '/計画書データ/{事業所pk}', options);
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            // jsonファイルアクセス時、PUT/DELETEの場合apacheの仕様（default-handler）で弾かれてしまうため、GETへ変換している
            const method = process.env.VUE_APP_IS_MOCK === "true" && ['PUT', 'DELETE'].includes('GET')
              ? 'GET'
              : 'GET';
            const localVarRequestOptions = { method, ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "userToken", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 認証/認可トークンのt企業と指定計画書データpkに紐付くt計画書データを論理削除します
         * @summary 計画書データ論理削除
         * @param {number} 計画書データpk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logicalDelete計画書データ: async (計画書データpk: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter '計画書データpk' is not null or undefined
            assertParamExists('logicalDelete計画書データ', '計画書データpk', 計画書データpk)
            let localVarPath = `/計画書データ/{計画書データpk}`
                .replace(`{${"計画書データpk"}}`, encodeURIComponent(String(計画書データpk)));
            if (process.env.VUE_APP_IS_MOCK === "true") localVarPath = ApiUtility.convertSampleUrl('DELETE', '/計画書データ/{計画書データpk}', options);
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            // jsonファイルアクセス時、PUT/DELETEの場合apacheの仕様（default-handler）で弾かれてしまうため、GETへ変換している
            const method = process.env.VUE_APP_IS_MOCK === "true" && ['PUT', 'DELETE'].includes('DELETE')
              ? 'GET'
              : 'DELETE';
            const localVarRequestOptions = { method, ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "userToken", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 認証/認可トークンのt企業と指定計画書データpkに紐付くt計画書データのモニタリング会計期間を更新します
         * @summary モニタリング会計期間更新
         * @param {number} 計画書データpk 
         * @param {モニタリング会計期間Request} モニタリング会計期間request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateモニタリング会計期間: async (計画書データpk: number, モニタリング会計期間request: モニタリング会計期間Request, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter '計画書データpk' is not null or undefined
            assertParamExists('updateモニタリング会計期間', '計画書データpk', 計画書データpk)
            // verify required parameter 'モニタリング会計期間request' is not null or undefined
            assertParamExists('updateモニタリング会計期間', 'モニタリング会計期間request', モニタリング会計期間request)
            let localVarPath = `/計画書データ/{計画書データpk}/モニタリング会計期間`
                .replace(`{${"計画書データpk"}}`, encodeURIComponent(String(計画書データpk)));
            if (process.env.VUE_APP_IS_MOCK === "true") localVarPath = ApiUtility.convertSampleUrl('PUT', '/計画書データ/{計画書データpk}/モニタリング会計期間', options);
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            // jsonファイルアクセス時、PUT/DELETEの場合apacheの仕様（default-handler）で弾かれてしまうため、GETへ変換している
            const method = process.env.VUE_APP_IS_MOCK === "true" && ['PUT', 'DELETE'].includes('PUT')
              ? 'GET'
              : 'PUT';
            const localVarRequestOptions = { method, ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "userToken", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(モニタリング会計期間request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 認証/認可トークンのt企業と指定計画書データpkに紐付くt計画書データを更新します
         * @summary 計画書データ更新
         * @param {number} 計画書データpk 
         * @param {計画書データRequest} 計画書データrequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update計画書データ: async (計画書データpk: number, 計画書データrequest: 計画書データRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter '計画書データpk' is not null or undefined
            assertParamExists('update計画書データ', '計画書データpk', 計画書データpk)
            // verify required parameter '計画書データrequest' is not null or undefined
            assertParamExists('update計画書データ', '計画書データrequest', 計画書データrequest)
            let localVarPath = `/計画書データ/{計画書データpk}`
                .replace(`{${"計画書データpk"}}`, encodeURIComponent(String(計画書データpk)));
            if (process.env.VUE_APP_IS_MOCK === "true") localVarPath = ApiUtility.convertSampleUrl('PUT', '/計画書データ/{計画書データpk}', options);
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            // jsonファイルアクセス時、PUT/DELETEの場合apacheの仕様（default-handler）で弾かれてしまうため、GETへ変換している
            const method = process.env.VUE_APP_IS_MOCK === "true" && ['PUT', 'DELETE'].includes('PUT')
              ? 'GET'
              : 'PUT';
            const localVarRequestOptions = { method, ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "userToken", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(計画書データrequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 認証/認可トークンのt企業と指定計画書データpkに紐付くt計画書データの表示設定を更新します
         * @summary 計画書データ表示設定更新
         * @param {number} 計画書データpk 
         * @param {計画書データ表示設定Request} 計画書データ表示設定request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update計画書データ表示設定: async (計画書データpk: number, 計画書データ表示設定request: 計画書データ表示設定Request, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter '計画書データpk' is not null or undefined
            assertParamExists('update計画書データ表示設定', '計画書データpk', 計画書データpk)
            // verify required parameter '計画書データ表示設定request' is not null or undefined
            assertParamExists('update計画書データ表示設定', '計画書データ表示設定request', 計画書データ表示設定request)
            let localVarPath = `/計画書データ/{計画書データpk}/表示設定`
                .replace(`{${"計画書データpk"}}`, encodeURIComponent(String(計画書データpk)));
            if (process.env.VUE_APP_IS_MOCK === "true") localVarPath = ApiUtility.convertSampleUrl('PUT', '/計画書データ/{計画書データpk}/表示設定', options);
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            // jsonファイルアクセス時、PUT/DELETEの場合apacheの仕様（default-handler）で弾かれてしまうため、GETへ変換している
            const method = process.env.VUE_APP_IS_MOCK === "true" && ['PUT', 'DELETE'].includes('PUT')
              ? 'GET'
              : 'PUT';
            const localVarRequestOptions = { method, ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "userToken", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(計画書データ表示設定request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * 計画書データApi - functional programming interface
 * @export
 */
export const 計画書データApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = 計画書データApiAxiosParamCreator(configuration)
    return {
        /**
         * 認証/認可トークンのt企業と指定計画書データpkに紐づくt計画書データを基として、 c計画書データ名を変更したt計画書データを新たに作成します
         * @summary 計画書データコピー
         * @param {number} 計画書データpk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async copy計画書データ(計画書データpk: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.copy計画書データ(計画書データpk, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 認証/認可トークンのt企業と指定事業所pkに紐付くt計画書データを作成します
         * @summary 計画書データ作成
         * @param {number} 事業所pk 
         * @param {計画書データRequest} 計画書データrequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create計画書データ(事業所pk: number, 計画書データrequest: 計画書データRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create計画書データ(事業所pk, 計画書データrequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 認証/認可トークンのt企業と指定事業所pkに紐付く有効なt計画書データの一覧をc計画書データ番号の昇順で取得します
         * @summary 計画書データ一覧
         * @param {number} 事業所pk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async list計画書データ(事業所pk: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<計画書データListItemResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.list計画書データ(事業所pk, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 認証/認可トークンのt企業と指定計画書データpkに紐付くt計画書データを論理削除します
         * @summary 計画書データ論理削除
         * @param {number} 計画書データpk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logicalDelete計画書データ(計画書データpk: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logicalDelete計画書データ(計画書データpk, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 認証/認可トークンのt企業と指定計画書データpkに紐付くt計画書データのモニタリング会計期間を更新します
         * @summary モニタリング会計期間更新
         * @param {number} 計画書データpk 
         * @param {モニタリング会計期間Request} モニタリング会計期間request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateモニタリング会計期間(計画書データpk: number, モニタリング会計期間request: モニタリング会計期間Request, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateモニタリング会計期間(計画書データpk, モニタリング会計期間request, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 認証/認可トークンのt企業と指定計画書データpkに紐付くt計画書データを更新します
         * @summary 計画書データ更新
         * @param {number} 計画書データpk 
         * @param {計画書データRequest} 計画書データrequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update計画書データ(計画書データpk: number, 計画書データrequest: 計画書データRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update計画書データ(計画書データpk, 計画書データrequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 認証/認可トークンのt企業と指定計画書データpkに紐付くt計画書データの表示設定を更新します
         * @summary 計画書データ表示設定更新
         * @param {number} 計画書データpk 
         * @param {計画書データ表示設定Request} 計画書データ表示設定request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update計画書データ表示設定(計画書データpk: number, 計画書データ表示設定request: 計画書データ表示設定Request, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update計画書データ表示設定(計画書データpk, 計画書データ表示設定request, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * 計画書データApi - factory interface
 * @export
 */
export const 計画書データApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = 計画書データApiFp(configuration)
    return {
        /**
         * 認証/認可トークンのt企業と指定計画書データpkに紐づくt計画書データを基として、 c計画書データ名を変更したt計画書データを新たに作成します
         * @summary 計画書データコピー
         * @param {number} 計画書データpk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copy計画書データ(計画書データpk: number, options?: any): AxiosPromise<void> {
            return localVarFp.copy計画書データ(計画書データpk, options).then((request) => request(axios, basePath));
        },
        /**
         * 認証/認可トークンのt企業と指定事業所pkに紐付くt計画書データを作成します
         * @summary 計画書データ作成
         * @param {number} 事業所pk 
         * @param {計画書データRequest} 計画書データrequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create計画書データ(事業所pk: number, 計画書データrequest: 計画書データRequest, options?: any): AxiosPromise<void> {
            return localVarFp.create計画書データ(事業所pk, 計画書データrequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 認証/認可トークンのt企業と指定事業所pkに紐付く有効なt計画書データの一覧をc計画書データ番号の昇順で取得します
         * @summary 計画書データ一覧
         * @param {number} 事業所pk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list計画書データ(事業所pk: number, options?: any): AxiosPromise<Array<計画書データListItemResponse>> {
            return localVarFp.list計画書データ(事業所pk, options).then((request) => request(axios, basePath));
        },
        /**
         * 認証/認可トークンのt企業と指定計画書データpkに紐付くt計画書データを論理削除します
         * @summary 計画書データ論理削除
         * @param {number} 計画書データpk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logicalDelete計画書データ(計画書データpk: number, options?: any): AxiosPromise<void> {
            return localVarFp.logicalDelete計画書データ(計画書データpk, options).then((request) => request(axios, basePath));
        },
        /**
         * 認証/認可トークンのt企業と指定計画書データpkに紐付くt計画書データのモニタリング会計期間を更新します
         * @summary モニタリング会計期間更新
         * @param {number} 計画書データpk 
         * @param {モニタリング会計期間Request} モニタリング会計期間request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateモニタリング会計期間(計画書データpk: number, モニタリング会計期間request: モニタリング会計期間Request, options?: any): AxiosPromise<void> {
            return localVarFp.updateモニタリング会計期間(計画書データpk, モニタリング会計期間request, options).then((request) => request(axios, basePath));
        },
        /**
         * 認証/認可トークンのt企業と指定計画書データpkに紐付くt計画書データを更新します
         * @summary 計画書データ更新
         * @param {number} 計画書データpk 
         * @param {計画書データRequest} 計画書データrequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update計画書データ(計画書データpk: number, 計画書データrequest: 計画書データRequest, options?: any): AxiosPromise<void> {
            return localVarFp.update計画書データ(計画書データpk, 計画書データrequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 認証/認可トークンのt企業と指定計画書データpkに紐付くt計画書データの表示設定を更新します
         * @summary 計画書データ表示設定更新
         * @param {number} 計画書データpk 
         * @param {計画書データ表示設定Request} 計画書データ表示設定request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update計画書データ表示設定(計画書データpk: number, 計画書データ表示設定request: 計画書データ表示設定Request, options?: any): AxiosPromise<void> {
            return localVarFp.update計画書データ表示設定(計画書データpk, 計画書データ表示設定request, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * 計画書データApi - object-oriented interface
 * @export
 * @class 計画書データApi
 * @extends {BaseAPI}
 */
export class 計画書データApi extends BaseAPI {
    /**
     * 認証/認可トークンのt企業と指定計画書データpkに紐づくt計画書データを基として、 c計画書データ名を変更したt計画書データを新たに作成します
     * @summary 計画書データコピー
     * @param {number} 計画書データpk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof 計画書データApi
     */
    public copy計画書データ(計画書データpk: number, options?: AxiosRequestConfig) {
        return 計画書データApiFp(this.configuration).copy計画書データ(計画書データpk, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 認証/認可トークンのt企業と指定事業所pkに紐付くt計画書データを作成します
     * @summary 計画書データ作成
     * @param {number} 事業所pk 
     * @param {計画書データRequest} 計画書データrequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof 計画書データApi
     */
    public create計画書データ(事業所pk: number, 計画書データrequest: 計画書データRequest, options?: AxiosRequestConfig) {
        return 計画書データApiFp(this.configuration).create計画書データ(事業所pk, 計画書データrequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 認証/認可トークンのt企業と指定事業所pkに紐付く有効なt計画書データの一覧をc計画書データ番号の昇順で取得します
     * @summary 計画書データ一覧
     * @param {number} 事業所pk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof 計画書データApi
     */
    public list計画書データ(事業所pk: number, options?: AxiosRequestConfig) {
        return 計画書データApiFp(this.configuration).list計画書データ(事業所pk, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 認証/認可トークンのt企業と指定計画書データpkに紐付くt計画書データを論理削除します
     * @summary 計画書データ論理削除
     * @param {number} 計画書データpk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof 計画書データApi
     */
    public logicalDelete計画書データ(計画書データpk: number, options?: AxiosRequestConfig) {
        return 計画書データApiFp(this.configuration).logicalDelete計画書データ(計画書データpk, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 認証/認可トークンのt企業と指定計画書データpkに紐付くt計画書データのモニタリング会計期間を更新します
     * @summary モニタリング会計期間更新
     * @param {number} 計画書データpk 
     * @param {モニタリング会計期間Request} モニタリング会計期間request 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof 計画書データApi
     */
    public updateモニタリング会計期間(計画書データpk: number, モニタリング会計期間request: モニタリング会計期間Request, options?: AxiosRequestConfig) {
        return 計画書データApiFp(this.configuration).updateモニタリング会計期間(計画書データpk, モニタリング会計期間request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 認証/認可トークンのt企業と指定計画書データpkに紐付くt計画書データを更新します
     * @summary 計画書データ更新
     * @param {number} 計画書データpk 
     * @param {計画書データRequest} 計画書データrequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof 計画書データApi
     */
    public update計画書データ(計画書データpk: number, 計画書データrequest: 計画書データRequest, options?: AxiosRequestConfig) {
        return 計画書データApiFp(this.configuration).update計画書データ(計画書データpk, 計画書データrequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 認証/認可トークンのt企業と指定計画書データpkに紐付くt計画書データの表示設定を更新します
     * @summary 計画書データ表示設定更新
     * @param {number} 計画書データpk 
     * @param {計画書データ表示設定Request} 計画書データ表示設定request 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof 計画書データApi
     */
    public update計画書データ表示設定(計画書データpk: number, 計画書データ表示設定request: 計画書データ表示設定Request, options?: AxiosRequestConfig) {
        return 計画書データApiFp(this.configuration).update計画書データ表示設定(計画書データpk, 計画書データ表示設定request, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * 部門Api - axios parameter creator
 * @export
 */
export const 部門ApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 認証/認可トークンのt企業と指定事業所pkに紐付くt部門を作成します
         * @summary 部門作成
         * @param {number} 事業所pk 
         * @param {部門Request} 部門request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create部門: async (事業所pk: number, 部門request: 部門Request, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter '事業所pk' is not null or undefined
            assertParamExists('create部門', '事業所pk', 事業所pk)
            // verify required parameter '部門request' is not null or undefined
            assertParamExists('create部門', '部門request', 部門request)
            let localVarPath = `/部門/{事業所pk}`
                .replace(`{${"事業所pk"}}`, encodeURIComponent(String(事業所pk)));
            if (process.env.VUE_APP_IS_MOCK === "true") localVarPath = ApiUtility.convertSampleUrl('POST', '/部門/{事業所pk}', options);
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            // jsonファイルアクセス時、PUT/DELETEの場合apacheの仕様（default-handler）で弾かれてしまうため、GETへ変換している
            const method = process.env.VUE_APP_IS_MOCK === "true" && ['PUT', 'DELETE'].includes('POST')
              ? 'GET'
              : 'POST';
            const localVarRequestOptions = { method, ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "userToken", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(部門request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 認証/認可トークンのt企業と指定部門pkに紐付くt部門を削除します
         * @summary 部門削除
         * @param {number} 部門pk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delete部門: async (部門pk: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter '部門pk' is not null or undefined
            assertParamExists('delete部門', '部門pk', 部門pk)
            let localVarPath = `/部門/{部門pk}`
                .replace(`{${"部門pk"}}`, encodeURIComponent(String(部門pk)));
            if (process.env.VUE_APP_IS_MOCK === "true") localVarPath = ApiUtility.convertSampleUrl('DELETE', '/部門/{部門pk}', options);
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            // jsonファイルアクセス時、PUT/DELETEの場合apacheの仕様（default-handler）で弾かれてしまうため、GETへ変換している
            const method = process.env.VUE_APP_IS_MOCK === "true" && ['PUT', 'DELETE'].includes('DELETE')
              ? 'GET'
              : 'DELETE';
            const localVarRequestOptions = { method, ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "userToken", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 認証/認可トークンのt企業と指定事業所pkに紐付くt部門の一覧をc部門コードの昇順で取得します
         * @summary 部門一覧
         * @param {number} 事業所pk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list部門: async (事業所pk: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter '事業所pk' is not null or undefined
            assertParamExists('list部門', '事業所pk', 事業所pk)
            let localVarPath = `/部門/{事業所pk}`
                .replace(`{${"事業所pk"}}`, encodeURIComponent(String(事業所pk)));
            if (process.env.VUE_APP_IS_MOCK === "true") localVarPath = ApiUtility.convertSampleUrl('GET', '/部門/{事業所pk}', options);
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            // jsonファイルアクセス時、PUT/DELETEの場合apacheの仕様（default-handler）で弾かれてしまうため、GETへ変換している
            const method = process.env.VUE_APP_IS_MOCK === "true" && ['PUT', 'DELETE'].includes('GET')
              ? 'GET'
              : 'GET';
            const localVarRequestOptions = { method, ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "userToken", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 認証/認可トークンのt企業と指定部門pkに紐付くt部門を更新します
         * @summary 部門更新
         * @param {number} 部門pk 
         * @param {部門Request} 部門request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update部門: async (部門pk: number, 部門request: 部門Request, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter '部門pk' is not null or undefined
            assertParamExists('update部門', '部門pk', 部門pk)
            // verify required parameter '部門request' is not null or undefined
            assertParamExists('update部門', '部門request', 部門request)
            let localVarPath = `/部門/{部門pk}`
                .replace(`{${"部門pk"}}`, encodeURIComponent(String(部門pk)));
            if (process.env.VUE_APP_IS_MOCK === "true") localVarPath = ApiUtility.convertSampleUrl('PUT', '/部門/{部門pk}', options);
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            // jsonファイルアクセス時、PUT/DELETEの場合apacheの仕様（default-handler）で弾かれてしまうため、GETへ変換している
            const method = process.env.VUE_APP_IS_MOCK === "true" && ['PUT', 'DELETE'].includes('PUT')
              ? 'GET'
              : 'PUT';
            const localVarRequestOptions = { method, ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authToken required
            await setApiKeyToObject(localVarHeaderParameter, "userToken", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(部門request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * 部門Api - functional programming interface
 * @export
 */
export const 部門ApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = 部門ApiAxiosParamCreator(configuration)
    return {
        /**
         * 認証/認可トークンのt企業と指定事業所pkに紐付くt部門を作成します
         * @summary 部門作成
         * @param {number} 事業所pk 
         * @param {部門Request} 部門request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create部門(事業所pk: number, 部門request: 部門Request, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create部門(事業所pk, 部門request, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 認証/認可トークンのt企業と指定部門pkに紐付くt部門を削除します
         * @summary 部門削除
         * @param {number} 部門pk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delete部門(部門pk: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delete部門(部門pk, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 認証/認可トークンのt企業と指定事業所pkに紐付くt部門の一覧をc部門コードの昇順で取得します
         * @summary 部門一覧
         * @param {number} 事業所pk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async list部門(事業所pk: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<部門ListItemResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.list部門(事業所pk, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 認証/認可トークンのt企業と指定部門pkに紐付くt部門を更新します
         * @summary 部門更新
         * @param {number} 部門pk 
         * @param {部門Request} 部門request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update部門(部門pk: number, 部門request: 部門Request, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update部門(部門pk, 部門request, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * 部門Api - factory interface
 * @export
 */
export const 部門ApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = 部門ApiFp(configuration)
    return {
        /**
         * 認証/認可トークンのt企業と指定事業所pkに紐付くt部門を作成します
         * @summary 部門作成
         * @param {number} 事業所pk 
         * @param {部門Request} 部門request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create部門(事業所pk: number, 部門request: 部門Request, options?: any): AxiosPromise<void> {
            return localVarFp.create部門(事業所pk, 部門request, options).then((request) => request(axios, basePath));
        },
        /**
         * 認証/認可トークンのt企業と指定部門pkに紐付くt部門を削除します
         * @summary 部門削除
         * @param {number} 部門pk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delete部門(部門pk: number, options?: any): AxiosPromise<void> {
            return localVarFp.delete部門(部門pk, options).then((request) => request(axios, basePath));
        },
        /**
         * 認証/認可トークンのt企業と指定事業所pkに紐付くt部門の一覧をc部門コードの昇順で取得します
         * @summary 部門一覧
         * @param {number} 事業所pk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list部門(事業所pk: number, options?: any): AxiosPromise<Array<部門ListItemResponse>> {
            return localVarFp.list部門(事業所pk, options).then((request) => request(axios, basePath));
        },
        /**
         * 認証/認可トークンのt企業と指定部門pkに紐付くt部門を更新します
         * @summary 部門更新
         * @param {number} 部門pk 
         * @param {部門Request} 部門request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update部門(部門pk: number, 部門request: 部門Request, options?: any): AxiosPromise<void> {
            return localVarFp.update部門(部門pk, 部門request, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * 部門Api - object-oriented interface
 * @export
 * @class 部門Api
 * @extends {BaseAPI}
 */
export class 部門Api extends BaseAPI {
    /**
     * 認証/認可トークンのt企業と指定事業所pkに紐付くt部門を作成します
     * @summary 部門作成
     * @param {number} 事業所pk 
     * @param {部門Request} 部門request 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof 部門Api
     */
    public create部門(事業所pk: number, 部門request: 部門Request, options?: AxiosRequestConfig) {
        return 部門ApiFp(this.configuration).create部門(事業所pk, 部門request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 認証/認可トークンのt企業と指定部門pkに紐付くt部門を削除します
     * @summary 部門削除
     * @param {number} 部門pk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof 部門Api
     */
    public delete部門(部門pk: number, options?: AxiosRequestConfig) {
        return 部門ApiFp(this.configuration).delete部門(部門pk, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 認証/認可トークンのt企業と指定事業所pkに紐付くt部門の一覧をc部門コードの昇順で取得します
     * @summary 部門一覧
     * @param {number} 事業所pk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof 部門Api
     */
    public list部門(事業所pk: number, options?: AxiosRequestConfig) {
        return 部門ApiFp(this.configuration).list部門(事業所pk, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 認証/認可トークンのt企業と指定部門pkに紐付くt部門を更新します
     * @summary 部門更新
     * @param {number} 部門pk 
     * @param {部門Request} 部門request 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof 部門Api
     */
    public update部門(部門pk: number, 部門request: 部門Request, options?: AxiosRequestConfig) {
        return 部門ApiFp(this.configuration).update部門(部門pk, 部門request, options).then((request) => request(this.axios, this.basePath));
    }
}


